import { __awaiter, __decorate, __metadata, __param } from 'tslib';
import { EventEmitter, Output, Input, Component, Injectable, ɵɵdefineInjectable, ɵɵinject, HostListener, SecurityContext, Inject, Renderer2, ViewEncapsulation, ViewChild, TemplateRef, NgModule, isDevMode } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavigationEnd, PRIMARY_OUTLET, Router, ActivatedRoute, RouterModule } from '@angular/router';
import { filter, map, debounceTime, distinctUntilChanged, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { TitleCasePipe, DOCUMENT, CommonModule } from '@angular/common';
import { Title, DomSanitizer } from '@angular/platform-browser';
import { createClient } from 'contentful';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { fromEvent, Subject, of, throwError } from 'rxjs';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { JwksValidationHandler, OAuthService, OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import jwt_decode from 'jwt-decode';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { x86 } from 'murmurhash3js';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/common/http';
import * as ɵngcc4 from '@angular/router';
import * as ɵngcc5 from '@angular/platform-browser';
import * as ɵngcc6 from 'angular-oauth2-oidc';
import * as ɵngcc7 from '@ng-bootstrap/ng-bootstrap';

function EmailSubscriptionBoxComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2, "Someone programmed this wrong.");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function EmailSubscriptionBoxComponent_p_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.subtitle);
} }
function EmailSubscriptionBoxComponent_p_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.postInputMessage);
} }
const _c0 = function (a0, a1) { return { "success": a0, "fail": a1 }; };
const _c1 = ["*"];
const _c2 = function (a0) { return [a0]; };
function BreadcrumbComponent_li_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const breadcrumb_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(2, _c2, breadcrumb_r1.url));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(breadcrumb_r1.label);
} }
function JumbotronComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("|\u00A0By ", ctx_r0.authorName, "\u00A0");
} }
function JumbotronComponent_a_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 12);
    ɵngcc0.ɵɵelementStart(1, "button", 13);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r1.ctaButtonUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.ctaButtonText);
} }
function JumbotronComponent_a_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 14);
    ɵngcc0.ɵɵelementStart(1, "button", 13);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLink", ctx_r2.routerPath)("state", ctx_r2.routerData);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.ctaButtonText);
} }
function BlogReferencesComponent_img_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 6);
} }
function BlogReferencesComponent_img_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 7);
} }
function BlogReferencesComponent_li_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "span", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "a", 9);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const referenceUrl_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", i_r4 + 1, ". ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("href", referenceUrl_r3, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(referenceUrl_r3);
} }
function BlogPullQuoteComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.quoteAttribution);
} }
function BlogPostDetailComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLink", ctx_r0.authorRouterPath)("state", ctx_r0.authorRouterData);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0By ", ctx_r0.authorName, "\u00A0");
} }
function BlogPostDetailComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("\u00A0By ", ctx_r1.authorName, "\u00A0");
} }
function BlogPostDetailComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelement(1, "emerson-blog-image", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r2.getLinkedHeaderImage(ctx_r2.posts[0].fields.headerImage.sys.id));
} }
function BlogPostDetailComponent_div_16_emerson_promotion_content_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "emerson-promotion-content", 23);
} if (rf & 2) {
    const contentBlock_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("promotionEntry", ctx_r7.getPromoContent(contentBlock_r6.sys.id));
} }
function BlogPostDetailComponent_div_16_emerson_blog_pull_quote_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "emerson-blog-pull-quote", 24);
} if (rf & 2) {
    const contentBlock_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("quoteContent", ctx_r8.getPullQuoteContent(contentBlock_r6.sys.id));
    ɵngcc0.ɵɵproperty("quoteAttribution", ctx_r8.getPullQuoteAttribution(contentBlock_r6.sys.id));
} }
function BlogPostDetailComponent_div_16_emerson_blog_text_block_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "emerson-blog-text-block", 25);
} if (rf & 2) {
    const contentBlock_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("textContent", ctx_r9.getTextBlockContent(contentBlock_r6.sys.id));
} }
function BlogPostDetailComponent_div_16_emerson_blog_video_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "emerson-blog-video", 26);
} if (rf & 2) {
    const contentBlock_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("url", ctx_r10.getVideoURL(contentBlock_r6.sys.id));
} }
function BlogPostDetailComponent_div_16_emerson_blog_image_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "emerson-blog-image", 27);
} if (rf & 2) {
    const contentBlock_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r11.getLinkedImageUrl(contentBlock_r6.sys.id))("caption", ctx_r11.getLinkedImageCaption(contentBlock_r6.sys.id))("attribution", ctx_r11.getLinkedImageAttribution(contentBlock_r6.sys.id));
} }
function BlogPostDetailComponent_div_16_emerson_blog_columns_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "emerson-blog-columns", 28);
} if (rf & 2) {
    const contentBlock_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("textContent", "test text content")("includes", ctx_r12.includes)("leftSideId", ctx_r12.getLeftSideId(contentBlock_r6.sys.id))("rightSideId", ctx_r12.getRightSideId(contentBlock_r6.sys.id));
} }
function BlogPostDetailComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtemplate(1, BlogPostDetailComponent_div_16_emerson_promotion_content_1_Template, 1, 1, "emerson-promotion-content", 17);
    ɵngcc0.ɵɵtemplate(2, BlogPostDetailComponent_div_16_emerson_blog_pull_quote_2_Template, 1, 2, "emerson-blog-pull-quote", 18);
    ɵngcc0.ɵɵtemplate(3, BlogPostDetailComponent_div_16_emerson_blog_text_block_3_Template, 1, 1, "emerson-blog-text-block", 19);
    ɵngcc0.ɵɵtemplate(4, BlogPostDetailComponent_div_16_emerson_blog_video_4_Template, 1, 1, "emerson-blog-video", 20);
    ɵngcc0.ɵɵtemplate(5, BlogPostDetailComponent_div_16_emerson_blog_image_5_Template, 1, 3, "emerson-blog-image", 21);
    ɵngcc0.ɵɵtemplate(6, BlogPostDetailComponent_div_16_emerson_blog_columns_6_Template, 1, 4, "emerson-blog-columns", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contentBlock_r6 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.getContentType(contentBlock_r6.sys.id) === "promotionalContent");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.getContentType(contentBlock_r6.sys.id) === "pullQuote");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.getContentType(contentBlock_r6.sys.id) === "textBlock");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.getContentType(contentBlock_r6.sys.id) === "videoLink");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.getContentType(contentBlock_r6.sys.id) === "imageBlock");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.getContentType(contentBlock_r6.sys.id) === "columns");
} }
function BlogPostDetailComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelement(1, "emerson-blog-references", 30);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("referenceUrls", ctx_r4.getLinkedReferenceUrls());
} }
function BlogPostDetailComponent_div_29_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 35);
    ɵngcc0.ɵɵelement(1, "emerson-categorycard", 36);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const article_r20 = ctx.$implicit;
    const i_r21 = ctx.index;
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", i_r21 % 2 ? "pl-2" : "pr-2");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("imgUrl", ctx_r19.getCardImgUrl(article_r20))("header", ctx_r19.getTitle(article_r20))("pubDate", ctx_r19.getPubDate(article_r20))("detailedContent", ctx_r19.getFirstContentBlock(article_r20))("ctaButtonUrl", ctx_r19.getUrlSlug(article_r20));
} }
function BlogPostDetailComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵelementStart(1, "h3", 32);
    ɵngcc0.ɵɵtext(2, "Recommended Articles");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 33);
    ɵngcc0.ɵɵtemplate(4, BlogPostDetailComponent_div_29_div_4_Template, 2, 6, "div", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.recommendedArticles);
} }
function BlogImageComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.attribution);
} }
function BlogImageComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.caption);
} }
function BlogImageComponent_hr_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "hr");
} }
function ContentComponent_div_2_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "a");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contentData_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", contentData_r5.fields.title, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", contentData_r5.fields.copy, " ");
} }
function ContentComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "a", 2);
    ɵngcc0.ɵɵelementStart(2, "h2");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, ContentComponent_div_2_div_1_div_4_Template, 5, 2, "div", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contentListbyCat_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("routerLink", "/", contentListbyCat_r2[0].sys.contentType.sys.id, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(contentListbyCat_r2[0].sys.contentType.sys.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", contentListbyCat_r2);
} }
function ContentComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, ContentComponent_div_2_div_1_Template, 5, 3, "div", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contentListbyCat_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", contentListbyCat_r2.length > 0);
} }
function ContentComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "h4");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵelement(4, "img", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const assets_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(assets_r7.fields.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("src", assets_r7.fields.file.url, ɵngcc0.ɵɵsanitizeUrl);
} }
function NavbarComponent_nav_1_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 19);
    ɵngcc0.ɵɵelementStart(1, "a", 20);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const siteLink_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", siteLink_r9.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(siteLink_r9.name);
} }
function NavbarComponent_nav_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "nav", 15);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "ul", 17);
    ɵngcc0.ɵɵtemplate(3, NavbarComponent_nav_1_li_3_Template, 4, 2, "li", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.siteLinks);
} }
function NavbarComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵlistener("click", function NavbarComponent_div_4_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.toggleSidebar(); });
    ɵngcc0.ɵɵelementEnd();
} }
function NavbarComponent_div_6_h4_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4", 27);
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r12.postBrandLogoText);
} }
function NavbarComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "a", 24);
    ɵngcc0.ɵɵelementStart(2, "img", 25);
    ɵngcc0.ɵɵlistener("click", function NavbarComponent_div_6_Template_img_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.logoClicked(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, NavbarComponent_div_6_h4_3_Template, 3, 1, "h4", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r2.brandLinkUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r2.brandLogoUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.postBrandLogoText);
} }
function NavbarComponent_div_7_img_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 32);
    ɵngcc0.ɵɵlistener("click", function NavbarComponent_div_7_img_2_Template_img_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.searchIconToggle(); });
    ɵngcc0.ɵɵelementEnd();
} }
function NavbarComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelementStart(1, "div", 29);
    ɵngcc0.ɵɵtemplate(2, NavbarComponent_div_7_img_2_Template, 1, 0, "img", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵelement(4, "input", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.searchIconHidden);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("@openClose", ctx_r3.isOpen ? "open" : "closed");
} }
function NavbarComponent_div_8_h4_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4", 27);
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r18.postBrandLogoText);
} }
function NavbarComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 33);
    ɵngcc0.ɵɵelementStart(1, "a", 24);
    ɵngcc0.ɵɵelementStart(2, "img", 25);
    ɵngcc0.ɵɵlistener("click", function NavbarComponent_div_8_Template_img_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.logoClicked(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, NavbarComponent_div_8_h4_3_Template, 3, 1, "h4", 26);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", ctx_r4.brandLinkUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r4.brandLogoUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.postBrandLogoText);
} }
function NavbarComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 34);
    ɵngcc0.ɵɵelementStart(1, "img", 35);
    ɵngcc0.ɵɵlistener("click", function NavbarComponent_div_9_Template_img_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.searchIconToggle(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function NavbarComponent_nav_12_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 19);
    ɵngcc0.ɵɵelementStart(1, "a", 43);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r25 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", category_r25.url);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", category_r25.name, " ");
} }
function NavbarComponent_nav_12_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 44);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r26 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", category_r26.url);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", category_r26.name, " ");
} }
function NavbarComponent_nav_12_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nav", 36);
    ɵngcc0.ɵɵelementStart(1, "div", 37);
    ɵngcc0.ɵɵelementStart(2, "ul", 17);
    ɵngcc0.ɵɵtemplate(3, NavbarComponent_nav_12_li_3_Template, 4, 2, "li", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 38);
    ɵngcc0.ɵɵelementStart(5, "div", 39);
    ɵngcc0.ɵɵelementStart(6, "select", 40);
    ɵngcc0.ɵɵlistener("change", function NavbarComponent_nav_12_Template_select_change_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.categorySelected($event.target.value); });
    ɵngcc0.ɵɵelementStart(7, "option", 41);
    ɵngcc0.ɵɵtext(8, "Select Category...");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, NavbarComponent_nav_12_option_9_Template, 2, 2, "option", 42);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.categories);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.categories);
} }
function NavbarComponent_li_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "a", 24);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const siteLink_r29 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("href", siteLink_r29.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(siteLink_r29.name);
} }
const _c3 = function (a0) { return { "hidden": a0 }; };
function BlogCategoryComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelement(2, "img", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("src", ctx_r0.blogCategory[0].fields.file.url, ɵngcc0.ɵɵsanitizeUrl);
} }
function BlogCategoryComponent_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "emerson-categorycard", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const article_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("imgUrl", ctx_r2.getCardImgUrl(article_r3))("header", ctx_r2.getTitle(article_r3))("detailedContent", ctx_r2.getcardContent(article_r3));
} }
function BlogCategoryComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtemplate(1, BlogCategoryComponent_div_5_div_1_Template, 2, 3, "div", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.categoryCards);
} }
function BlogColumnsComponent_emerson_blog_text_block_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "emerson-blog-text-block", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("textContent", ctx_r0.textContent);
} }
function BlogColumnsComponent_emerson_blog_image_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "emerson-blog-image", 7);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r1.src);
    ɵngcc0.ɵɵpropertyInterpolate("altTitle", ctx_r1.altTitle);
    ɵngcc0.ɵɵpropertyInterpolate("attribution", ctx_r1.attribution);
    ɵngcc0.ɵɵpropertyInterpolate("caption", ctx_r1.caption);
} }
function BlogColumnsComponent_emerson_blog_text_block_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "emerson-blog-text-block", 6);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("textContent", ctx_r2.textContent);
} }
function BlogColumnsComponent_emerson_blog_image_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "emerson-blog-image", 7);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r3.src);
    ɵngcc0.ɵɵpropertyInterpolate("altTitle", ctx_r3.altTitle);
    ɵngcc0.ɵɵpropertyInterpolate("attribution", ctx_r3.attribution);
    ɵngcc0.ɵɵpropertyInterpolate("caption", ctx_r3.caption);
} }
function CategorycardComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 15);
    ɵngcc0.ɵɵelement(1, "img", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLink", ctx_r0.routerPath)("state", ctx_r0.routerData);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r0.imgUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵpropertyInterpolate("alt", ctx_r0.header);
} }
function CategorycardComponent_a_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 17);
    ɵngcc0.ɵɵelement(1, "img", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("href", ctx_r1.ctaButtonUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r1.imgUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵpropertyInterpolate("alt", ctx_r1.header);
} }
function CategorycardComponent_a_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLink", ctx_r2.routerPath)("state", ctx_r2.routerData);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.header, " ");
} }
function CategorycardComponent_a_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("href", ctx_r3.ctaButtonUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.header, " ");
} }
function CategorycardComponent_a_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLink", ctx_r4.routerPath)("state", ctx_r4.routerData);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.ctaButtonText);
} }
function CategorycardComponent_a_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("href", ctx_r5.ctaButtonUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.ctaButtonText);
} }
function BlogAuthorComponent_div_0_p_7_span_1_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contentData_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("href", contentData_r4.data.uri, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", contentData_r4.data.uri, "");
} }
function BlogAuthorComponent_div_0_p_7_span_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contentData_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(contentData_r4.value);
} }
function BlogAuthorComponent_div_0_p_7_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, BlogAuthorComponent_div_0_p_7_span_1_a_1_Template, 2, 2, "a", 4);
    ɵngcc0.ɵɵtemplate(2, BlogAuthorComponent_div_0_p_7_span_1_span_2_Template, 2, 1, "span", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contentData_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", contentData_r4.nodeType == "hyperlink");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", contentData_r4.nodeType == "text");
} }
function BlogAuthorComponent_div_0_p_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtemplate(1, BlogAuthorComponent_div_0_p_7_span_1_Template, 3, 2, "span", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const content_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", content_r2.content);
} }
function BlogAuthorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelement(2, "img", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 1);
    ɵngcc0.ɵɵelementStart(4, "h1");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div");
    ɵngcc0.ɵɵtemplate(7, BlogAuthorComponent_div_0_p_7_Template, 2, 1, "p", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("src", ctx_r0.blogAuthor.fields.profilePicture.fields.file.url, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.blogAuthor.fields.fullDisplayName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.blogAuthor.fields.biography.content);
} }
function NothingHereComponent_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 6);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r0.imageUrl, ɵngcc0.ɵɵsanitizeUrl);
} }
function AccountMergePasswordSetSuccessComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "h3", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵlistener("click", function AccountMergePasswordSetSuccessComponent_div_0_Template_div_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.exitButtonClicked.emit(); });
    ɵngcc0.ɵɵelementStart(6, "button", 6);
    ɵngcc0.ɵɵelementStart(7, "span", 7);
    ɵngcc0.ɵɵtext(8, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 8);
    ɵngcc0.ɵɵelement(10, "span", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 10);
    ɵngcc0.ɵɵelementStart(12, "div", 11);
    ɵngcc0.ɵɵlistener("click", function AccountMergePasswordSetSuccessComponent_div_0_Template_div_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.okButtonClicked.emit(); });
    ɵngcc0.ɵɵtext(13, " OK ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.body, ɵngcc0.ɵɵsanitizeHtml);
} }
function AccountMergePasswordSetComponent__svg_svg_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 22);
    ɵngcc0.ɵɵelementStart(1, "title");
    ɵngcc0.ɵɵtext(2, "D356B5CC-D802-468E-B478-D690EF0B1599");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "g", 23);
    ɵngcc0.ɵɵelementStart(4, "g", 24);
    ɵngcc0.ɵɵelementStart(5, "g", 25);
    ɵngcc0.ɵɵelementStart(6, "g", 26);
    ɵngcc0.ɵɵelement(7, "path", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AccountMergePasswordSetComponent__svg_svg_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 28);
    ɵngcc0.ɵɵelementStart(1, "title");
    ɵngcc0.ɵɵtext(2, "2A3A2612-8497-4621-9BF1-DFA7E6A9EFE4");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "g", 23);
    ɵngcc0.ɵɵelementStart(4, "g", 29);
    ɵngcc0.ɵɵelementStart(5, "g", 25);
    ɵngcc0.ɵɵelementStart(6, "g", 30);
    ɵngcc0.ɵɵelement(7, "path", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AccountMergePasswordSetComponent__svg_svg_28_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 22);
    ɵngcc0.ɵɵelementStart(1, "title");
    ɵngcc0.ɵɵtext(2, "D356B5CC-D802-468E-B478-D690EF0B1599");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "g", 23);
    ɵngcc0.ɵɵelementStart(4, "g", 24);
    ɵngcc0.ɵɵelementStart(5, "g", 25);
    ɵngcc0.ɵɵelementStart(6, "g", 26);
    ɵngcc0.ɵɵelement(7, "path", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AccountMergePasswordSetComponent__svg_svg_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 28);
    ɵngcc0.ɵɵelementStart(1, "title");
    ɵngcc0.ɵɵtext(2, "2A3A2612-8497-4621-9BF1-DFA7E6A9EFE4");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "g", 23);
    ɵngcc0.ɵɵelementStart(4, "g", 29);
    ɵngcc0.ɵɵelementStart(5, "g", 25);
    ɵngcc0.ɵɵelementStart(6, "g", 30);
    ɵngcc0.ɵɵelement(7, "path", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function AccountMergePasswordSetComponent_div_30_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1, " Password is required. ");
    ɵngcc0.ɵɵelementEnd();
} }
function AccountMergePasswordSetComponent_div_30_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.passwordPatternValidatorFailedMessage, " ");
} }
function AccountMergePasswordSetComponent_div_30_li_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1, " Confirm password must match Password. ");
    ɵngcc0.ɵɵelementEnd();
} }
function AccountMergePasswordSetComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 32);
    ɵngcc0.ɵɵelementStart(1, "ul", 33);
    ɵngcc0.ɵɵtemplate(2, AccountMergePasswordSetComponent_div_30_li_2_Template, 2, 0, "li", 34);
    ɵngcc0.ɵɵtemplate(3, AccountMergePasswordSetComponent_div_30_li_3_Template, 2, 1, "li", 34);
    ɵngcc0.ɵɵtemplate(4, AccountMergePasswordSetComponent_div_30_li_4_Template, 2, 0, "li", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.password.errors == null ? null : ctx_r4.password.errors.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r4.password.errors == null ? null : ctx_r4.password.errors.required) && (ctx_r4.password.invalid && (ctx_r4.password.dirty || ctx_r4.password.touched)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r4.confirmPassword.errors == null ? null : ctx_r4.confirmPassword.errors.noMatch) && (ctx_r4.confirmPassword.invalid && (ctx_r4.confirmPassword.dirty || ctx_r4.confirmPassword.touched)));
} }
const _c4 = function (a0) { return { "text-danger": a0 }; };
const _c5 = function (a0) { return { "border border-danger": a0 }; };
function AuthComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function AuthComponent_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.login(); });
    ɵngcc0.ɵɵtext(1, "Login");
    ɵngcc0.ɵɵelementEnd();
} }
function AuthComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵlistener("click", function AuthComponent_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.logout(); });
    ɵngcc0.ɵɵtext(1, "Logout");
    ɵngcc0.ɵɵelementEnd();
} }
function AuthComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 8);
    ɵngcc0.ɵɵlistener("click", function AuthComponent_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.refresh(); });
    ɵngcc0.ɵɵtext(1, "Refresh Token");
    ɵngcc0.ɵɵelementEnd();
} }
function AuthComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function AuthComponent_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.getUserProfile(); });
    ɵngcc0.ɵɵtext(1, "User Profile");
    ɵngcc0.ɵɵelementEnd();
} }
function AuthComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("Access Token : ", ctx_r4.accessToken, "");
} }
function AuthComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("User Profile : ", ctx_r5.userProfile, "");
} }
function NotificationBellComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵtextInterpolate1("Notifications (", ctx_r1.notificationListItems ? ctx_r1.notificationListItems.length : "0", ")");
} }
function NotificationBellComponent_ng_template_2_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelement(1, "emerson-notification-bell-list-item", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const indexOfelement_r10 = ctx.index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(indexOfelement_r10 > 0 ? "notification-item-pad-top" : "");
    ɵngcc0.ɵɵproperty("notificationItem", item_r9);
} }
function NotificationBellComponent_ng_template_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NotificationBellComponent_ng_template_2_ng_container_1_div_1_Template, 2, 4, "div", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.notificationListItems);
} }
function NotificationBellComponent_ng_template_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtext(2, "You have no new notifications");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function NotificationBellComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtemplate(1, NotificationBellComponent_ng_template_2_ng_container_1_Template, 2, 1, "ng-container", 8);
    ɵngcc0.ɵɵtemplate(2, NotificationBellComponent_ng_template_2_ng_container_2_Template, 3, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.notificationListItems.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.notificationListItems.length == 0);
} }
function NotificationBellComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵlistener("click", function NotificationBellComponent_span_8_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); ɵngcc0.ɵɵnextContext(); const _r4 = ɵngcc0.ɵɵreference(6); return _r4.open(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.notificationListItems.length);
} }
function AppTabLinkComponent_span_31_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 13);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.message, ɵngcc0.ɵɵsanitizeHtml);
} }
function AppTabLinkComponent_span_32_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 13);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.shortMessage, ɵngcc0.ɵɵsanitizeHtml);
} }
const _c6 = ["popover"];
function HighlightComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "button", 4);
    ɵngcc0.ɵɵlistener("click", function HighlightComponent_ng_template_3_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); const _r0 = ɵngcc0.ɵɵreference(1); _r0.close(); return ctx_r4.removeOverlay(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.bodyHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.btnText);
} }
function HighlightComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 5);
} }
const _c7 = ["content"];
const _c8 = ["Defaultaddress"];
function ValidateAddressComponent_ng_template_0_p_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1, " Address wasn't able to be successfully validated ");
    ɵngcc0.ɵɵelementEnd();
} }
function ValidateAddressComponent_ng_template_0_p_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p");
    ɵngcc0.ɵɵtext(1, " The address you entered can not be validated. We recommend using the below address that has been validated. ");
    ɵngcc0.ɵɵelementEnd();
} }
function ValidateAddressComponent_ng_template_0_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "input", 24);
    ɵngcc0.ɵɵlistener("change", function ValidateAddressComponent_ng_template_0_div_11_Template_input_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.selectOptions($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 25);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("id", i_r9);
    ɵngcc0.ɵɵpropertyInterpolate("value", i_r9);
    ɵngcc0.ɵɵproperty("checked", ctx_r7.selectedAddressType == i_r9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("for", i_r9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.formatAddress(item_r8));
} }
const _c9 = function (a0) { return { "text-right": a0 }; };
function ValidateAddressComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "form");
    ɵngcc0.ɵɵelementStart(2, "h2");
    ɵngcc0.ɵɵtext(3, "Address Validation");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵtemplate(5, ValidateAddressComponent_ng_template_0_p_5_Template, 2, 0, "p", 5);
    ɵngcc0.ɵɵtemplate(6, ValidateAddressComponent_ng_template_0_p_6_Template, 2, 0, "p", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 6);
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵelementStart(9, "div", 8);
    ɵngcc0.ɵɵelementStart(10, "div", 9);
    ɵngcc0.ɵɵtemplate(11, ValidateAddressComponent_ng_template_0_div_11_Template, 4, 5, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 9);
    ɵngcc0.ɵɵelementStart(13, "input", 11);
    ɵngcc0.ɵɵlistener("change", function ValidateAddressComponent_ng_template_0_Template_input_change_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.selectOptions($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "label", 12);
    ɵngcc0.ɵɵtext(15, "Use the address you entered");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 9);
    ɵngcc0.ɵɵelementStart(17, "input", 13);
    ɵngcc0.ɵɵlistener("change", function ValidateAddressComponent_ng_template_0_Template_input_change_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.selectOptions($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "label", 14);
    ɵngcc0.ɵɵtext(19, "Re-enter your address");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(20, "div", 15);
    ɵngcc0.ɵɵelementStart(21, "div", 16);
    ɵngcc0.ɵɵelementStart(22, "div", 17);
    ɵngcc0.ɵɵelementStart(23, "div", 18);
    ɵngcc0.ɵɵelementStart(24, "input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function ValidateAddressComponent_ng_template_0_Template_input_ngModelChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.isUserOptOut = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "label", 20);
    ɵngcc0.ɵɵtext(26, " Don't ask me again for this address");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(27, "br");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "div", 21);
    ɵngcc0.ɵɵelementStart(29, "button", 22);
    ɵngcc0.ɵɵlistener("click", function ValidateAddressComponent_ng_template_0_Template_button_click_29_listener() { const modal_r4 = ctx.$implicit; return modal_r4.close("Continue"); });
    ɵngcc0.ɵɵtext(30, " Continue ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.addrResponse.body.similarAddresses.length == 0 && !ctx_r1.addrResponse.body.isValid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.addrResponse.body.similarAddresses.length > 0 && !ctx_r1.addrResponse.body.isValid);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.addrResponse.body.similarAddresses);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("checked", ctx_r1.selectedAddressType === "-1");
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.selectedAddressType != "-1" || ctx_r1.hideDontAskAgain);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.isUserOptOut);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c9, ctx_r1.selectedAddressType != "-1" || ctx_r1.hideDontAskAgain));
} }
function ValidateAddressComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "h2");
    ɵngcc0.ɵɵtext(2, "Set default address");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 8);
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelementStart(5, "div", 4);
    ɵngcc0.ɵɵelementStart(6, "p");
    ɵngcc0.ɵɵtext(7, " Would you like to set this new address as your default shipping address?");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "p", 26);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(10, "br");
    ɵngcc0.ɵɵelementStart(11, "div", 27);
    ɵngcc0.ɵɵelementStart(12, "button", 28);
    ɵngcc0.ɵɵlistener("click", function ValidateAddressComponent_ng_template_2_Template_button_click_12_listener() { const modal_r17 = ctx.$implicit; return modal_r17.close("skip"); });
    ɵngcc0.ɵɵtext(13, " Skip this step ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "button", 29);
    ɵngcc0.ɵɵlistener("click", function ValidateAddressComponent_ng_template_2_Template_button_click_14_listener() { const modal_r17 = ctx.$implicit; return modal_r17.close("setdefault"); });
    ɵngcc0.ɵɵtext(15, " Set as default ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.formatAddress(ctx_r3.selectedAddr.selectedaddress), " ");
} }
function HeaderComponent_header_search_bar_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "header-search-bar", 20);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("theme", ctx_r0.theme);
} }
function HeaderComponent_header_navbar_wellevate_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "header-navbar-wellevate", 21);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("theme", ctx_r1.theme);
} }
function HeaderComponent_header_navbar_emerson_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "header-navbar-emerson", 22);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("theme", ctx_r2.theme);
} }
function TabLinkComponent_img_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 3);
    ɵngcc0.ɵɵlistener("click", function TabLinkComponent_img_1_Template_img_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.goToWellevate(); });
    ɵngcc0.ɵɵelementEnd();
} }
function TabLinkComponent_img_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "img", 4);
    ɵngcc0.ɵɵlistener("click", function TabLinkComponent_img_2_Template_img_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.goToEmerson(); });
    ɵngcc0.ɵɵelementEnd();
} }
function ButtonBarComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵlistener("click", function ButtonBarComponent_div_4_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.goToCart(); });
    ɵngcc0.ɵɵelement(2, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.applyThemeClass("button-bar-link"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.applyThemeClass("button-bar-icon"));
} }
class IHubSpotService {
    submitForm(portalId, formId, formFields) {
        throw new Error('Method not implemented');
    }
}

let EmailSubscriptionBoxComponent = class EmailSubscriptionBoxComponent {
    constructor(hubSpot) {
        this.hubSpot = hubSpot;
        this.successfulSubmit = new EventEmitter();
        this.failedSubmit = new EventEmitter();
        this.title = 'default title';
        this.subtitle = '';
        this.subscribeButtonText = 'default subscribe';
        this.subscribeThankYou = 'Thank you!';
        this.disableSubmitButton = false;
        this.postInputMessage = "";
        this.isInitalized = false;
        this.successfulSubmitSent = false;
        this.failedSubmitSent = false;
        this.emailFormControlGroup = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.email]),
        });
    }
    ngOnInit() {
        this.isInitalized = true;
        if (!this.portalId || !this.formId) {
            this.isInitalized = false;
        }
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            const formControl = this.emailFormControlGroup.get('email');
            this.failedSubmitSent = false;
            this.successfulSubmitSent = false;
            if (!formControl.valid) {
                this.failedSubmitSent = true;
                return;
            }
            const formFields = {
                fields: [
                    {
                        name: 'email',
                        value: this.emailFormControlGroup.get('email').value,
                    }
                ]
            };
            try {
                const response = yield this.hubSpot.submitForm(this.portalId, this.formId, formFields);
                this.successfulSubmitSent = true;
                this.successfulSubmit.emit(response);
            }
            catch (error) {
                this.failedSubmitSent = true;
                this.failedSubmit.emit(error);
            }
        });
    }
};
EmailSubscriptionBoxComponent.ɵfac = function EmailSubscriptionBoxComponent_Factory(t) { return new (t || EmailSubscriptionBoxComponent)(ɵngcc0.ɵɵdirectiveInject(IHubSpotService)); };
EmailSubscriptionBoxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EmailSubscriptionBoxComponent, selectors: [["emerson-email-subscription-box"]], inputs: { title: "title", subtitle: "subtitle", subscribeButtonText: "subscribeButtonText", subscribeThankYou: "subscribeThankYou", disableSubmitButton: "disableSubmitButton", postInputMessage: "postInputMessage", portalId: "portalId", formId: "formId" }, outputs: { successfulSubmit: "successfulSubmit", failedSubmit: "failedSubmit" }, features: [ɵngcc0.ɵɵProvidersFeature([])], ngContentSelectors: _c1, decls: 10, vars: 19, consts: [[1, "email-subscription-box", "position-relative", "d-inline-block", "px-3", "pb-3", 3, "formGroup", "ngClass"], ["class", "overlay position-absolute is-not-initalized p-0 w-100 h-100", 4, "ngIf"], [1, "subscribe-title"], ["class", "subscribe-subtitle", 4, "ngIf"], ["aria-label", "email for subscription", "type", "email", "name", "email", "formControlName", "email", 1, "subscription-input", 3, "ngClass"], ["class", "message", 4, "ngIf"], ["aria-label", "submit email subscription form", 1, "subscription-submit-button", 3, "ngClass", "disabled", "click"], [1, "overlay", "position-absolute", "is-not-initalized", "p-0", "w-100", "h-100"], [1, "subscribe-subtitle"], [1, "message"]], template: function EmailSubscriptionBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, EmailSubscriptionBoxComponent_div_1_Template, 3, 0, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h2", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, EmailSubscriptionBoxComponent_p_4_Template, 2, 1, "p", 3);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelement(6, "input", 4);
        ɵngcc0.ɵɵtemplate(7, EmailSubscriptionBoxComponent_p_7_Template, 2, 1, "p", 5);
        ɵngcc0.ɵɵelementStart(8, "button", 6);
        ɵngcc0.ɵɵlistener("click", function EmailSubscriptionBoxComponent_Template_button_click_8_listener() { return ctx.onSubmit(); });
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.emailFormControlGroup)("ngClass", ɵngcc0.ɵɵpureFunction2(10, _c0, ctx.successfulSubmitSent, ctx.failedSubmitSent));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isInitalized);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.subtitle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(13, _c0, ctx.successfulSubmitSent, ctx.failedSubmitSent));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.postInputMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(16, _c0, ctx.successfulSubmitSent, ctx.failedSubmitSent))("disabled", !ctx.emailFormControlGroup.valid || ctx.disableSubmitButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.subscribeButtonText, " ");
    } }, directives: [ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlName], styles: [".ng-invalid[_ngcontent-%COMP%]:not(div):not(.ng-pristine){border-left:5px solid #a94442}div[_ngcontent-%COMP%]{background-color:#e7e5e5;border:1px solid #000}div[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:90%;margin:0}div[_ngcontent-%COMP%]   .overlay[_ngcontent-%COMP%]{top:0;left:0;opacity:50;border:none}"] });
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], EmailSubscriptionBoxComponent.prototype, "successfulSubmit", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], EmailSubscriptionBoxComponent.prototype, "failedSubmit", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EmailSubscriptionBoxComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EmailSubscriptionBoxComponent.prototype, "subtitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EmailSubscriptionBoxComponent.prototype, "subscribeButtonText", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EmailSubscriptionBoxComponent.prototype, "subscribeThankYou", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], EmailSubscriptionBoxComponent.prototype, "portalId", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], EmailSubscriptionBoxComponent.prototype, "formId", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], EmailSubscriptionBoxComponent.prototype, "disableSubmitButton", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], EmailSubscriptionBoxComponent.prototype, "postInputMessage", void 0);
EmailSubscriptionBoxComponent = __decorate([ __metadata("design:paramtypes", [IHubSpotService])
], EmailSubscriptionBoxComponent);

let ConfigurationService = class ConfigurationService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    fetchConfiguration(url) {
        try {
            const promise = this.httpClient.get(url)
                .toPromise()
                .then(configurations => {
                this.configurations = configurations;
                return configurations;
            });
            return promise;
        }
        catch (error) {
            console.log(error);
        }
    }
};
ConfigurationService.ɵfac = function ConfigurationService_Factory(t) { return new (t || ConfigurationService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
ConfigurationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ConfigurationService, factory: function (t) { return ConfigurationService.ɵfac(t); } });
ConfigurationService = __decorate([ __metadata("design:paramtypes", [HttpClient])
], ConfigurationService);

let BreadcrumbComponent = class BreadcrumbComponent {
    constructor(router, activatedRoute, configService, titleCasePipe) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.configService = configService;
        this.titleCasePipe = titleCasePipe;
        this.baseUrl = 'blog';
        this.BREADCRUMB_KEY = 'breadcrumb';
        this.baseUrl = this.configService.configurations.app.baseRewritePath;
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(event => {
            const root = this.activatedRoute.root;
            this.breadcrumbs = this.generateBreadcrumbList(root);
        });
    }
    ngOnInit() {
    }
    generateBreadcrumbList(route, url = '', breadcrumbs = []) {
        const children = route.children;
        if (children.length === 0) {
            return breadcrumbs;
        }
        for (const child of children) {
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }
            if (!child.snapshot.data.hasOwnProperty(this.BREADCRUMB_KEY)) {
                return this.generateBreadcrumbList(child, url, breadcrumbs);
            }
            const routeURL = child.snapshot.url.map(segment => segment.path).join('/');
            url += `/${routeURL}`;
            let formattedLabel = child.snapshot.data[this.BREADCRUMB_KEY];
            if (formattedLabel === ':slug-url') {
                formattedLabel = this.formatLabel(routeURL);
            }
            else {
                formattedLabel = child.snapshot.data[this.BREADCRUMB_KEY];
            }
            if (formattedLabel !== '') {
                const breadcrumb = {
                    label: formattedLabel,
                    params: child.snapshot.params,
                    url
                };
                breadcrumbs.push(breadcrumb);
            }
            return this.generateBreadcrumbList(child, url, breadcrumbs);
        }
        return breadcrumbs;
    }
    formatLabel(label) {
        return this.titleCasePipe.transform(label.split('-').join(' '));
    }
};
BreadcrumbComponent.ɵfac = function BreadcrumbComponent_Factory(t) { return new (t || BreadcrumbComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ConfigurationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.TitleCasePipe)); };
BreadcrumbComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbComponent, selectors: [["emerson-breadcrumb"]], decls: 6, vars: 5, consts: [[1, "emerson-breadcrumb"], [1, "emerson-breadcrumb", 3, "href"], [4, "ngFor", "ngForOf"], [3, "routerLink"]], template: function BreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵelementStart(1, "li");
        ɵngcc0.ɵɵelementStart(2, "a", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "titlecase");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, BreadcrumbComponent_li_5_Template, 3, 4, "li", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate1("href", "/", ctx.baseUrl, "", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 3, ctx.baseUrl));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.breadcrumbs);
    } }, directives: [ɵngcc2.NgForOf, ɵngcc4.RouterLinkWithHref], pipes: [ɵngcc2.TitleCasePipe], styles: ["@charset \"UTF-8\";ul.emerson-breadcrumb[_ngcontent-%COMP%]{list-style:none;-webkit-padding-start:0;padding-inline-start:0}ul.emerson-breadcrumb[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline;color:#115ea5;font-family:Roboto;font-size:14px;line-height:19px}ul.emerson-breadcrumb[_ngcontent-%COMP%]   li[_ngcontent-%COMP%] + li[_ngcontent-%COMP%]:before{padding:6px;color:#000;content:\"/\u00A0\"}"] });
BreadcrumbComponent = __decorate([ __metadata("design:paramtypes", [Router, ActivatedRoute,
        ConfigurationService, TitleCasePipe])
], BreadcrumbComponent);

let JumbotronComponent = class JumbotronComponent {
    constructor() {
        this.header = 'Hello World!';
        this.categoryName = 'None';
        this.authorName = '';
        this.pubDate = '01/01/2019';
        this.lead = 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquam aliquid excepturi similique.';
        this.detailedContent = 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. A accusantium at fugiat harum ' +
            'nobis quasi qui saepe vel vitae voluptas, voluptates?';
        this.ctaButtonText = 'Learn more...';
        this.ctaButtonUrl = '';
    }
    ngOnInit() {
    }
};
JumbotronComponent.ɵfac = function JumbotronComponent_Factory(t) { return new (t || JumbotronComponent)(); };
JumbotronComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: JumbotronComponent, selectors: [["emerson-jumbotron"]], inputs: { header: "header", categoryName: "categoryName", authorName: "authorName", pubDate: "pubDate", lead: "lead", detailedContent: "detailedContent", ctaButtonText: "ctaButtonText", ctaButtonUrl: "ctaButtonUrl", imgUrl: "imgUrl", routerPath: "routerPath", routerData: "routerData" }, decls: 20, vars: 8, consts: [[1, "jumbotron", "ee-jumbotron", "container-lg"], [1, "row"], [1, "col-lg"], ["alt", "jogger", "width", "100%", 1, "img-fluid", "image-fill", 3, "src"], [1, "p-4"], [1, "h2"], [1, "font-weight-bold"], [1, "text-muted"], [4, "ngIf"], [1, ""], ["class", "href", 3, "href", 4, "ngIf"], ["class", "href", 3, "routerLink", "state", 4, "ngIf"], [1, "href", 3, "href"], ["href", "#", "role", "button", 1, "ee-btn", "ee-btn-primary", "pl-5", "pr-5"], [1, "href", 3, "routerLink", "state"]], template: function JumbotronComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "img", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "h1", 5);
        ɵngcc0.ɵɵelementStart(7, "strong");
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "p");
        ɵngcc0.ɵɵelementStart(10, "strong", 6);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "span", 7);
        ɵngcc0.ɵɵtext(13, "\u00A0");
        ɵngcc0.ɵɵtemplate(14, JumbotronComponent_span_14_Template, 2, 1, "span", 8);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "p", 9);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, JumbotronComponent_a_18_Template, 3, 2, "a", 10);
        ɵngcc0.ɵɵtemplate(19, JumbotronComponent_a_19_Template, 3, 3, "a", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.imgUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.header);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.categoryName);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.authorName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("|\u00A0", ctx.pubDate, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.detailedContent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.routerPath && ctx.ctaButtonUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.routerPath);
    } }, directives: [ɵngcc2.NgIf, ɵngcc4.RouterLinkWithHref], styles: [".image-fill[_ngcontent-%COMP%]{-o-object-fit:cover;object-fit:cover;-o-object-position:top;object-position:top;min-width:100%;height:100%}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], JumbotronComponent.prototype, "header", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], JumbotronComponent.prototype, "categoryName", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], JumbotronComponent.prototype, "authorName", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], JumbotronComponent.prototype, "pubDate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], JumbotronComponent.prototype, "lead", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], JumbotronComponent.prototype, "detailedContent", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], JumbotronComponent.prototype, "ctaButtonText", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], JumbotronComponent.prototype, "ctaButtonUrl", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], JumbotronComponent.prototype, "imgUrl", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], JumbotronComponent.prototype, "routerPath", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], JumbotronComponent.prototype, "routerData", void 0);
JumbotronComponent = __decorate([ __metadata("design:paramtypes", [])
], JumbotronComponent);

let SocialIconsComponent = class SocialIconsComponent {
    constructor() {
        this.linkedinUrl = 'https://www.linkedin.com';
        this.facebookUrl = 'https://www.facebook.com';
        this.twitterUrl = 'https://twitter.com';
        // instagramUrl = 'https://instagram.com';
        this.pinterestUrl = 'https://pinterest.com';
    }
    ngOnInit() {
        // capture the current page url for use as a parameter
        // Note - Instagram does NOT support share link embedding
        const thisUrl = window.location;
        this.linkedinUrl = this.linkedinUrl + '/shareArticle?mini=true&url=' + thisUrl;
        this.facebookUrl = this.facebookUrl + '/sharer/sharer.php?u=' + thisUrl;
        this.twitterUrl = this.twitterUrl + '/home?status=' + thisUrl;
        this.pinterestUrl = this.pinterestUrl + '/pin/create/button/?url=' + thisUrl;
    }
};
SocialIconsComponent.ɵfac = function SocialIconsComponent_Factory(t) { return new (t || SocialIconsComponent)(); };
SocialIconsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SocialIconsComponent, selectors: [["emerson-social-icons"]], decls: 14, vars: 4, consts: [[1, "ee-social-icons", "p-2"], [1, "my-2"], [1, "list-inline", "d-inline"], [3, "href"], ["src", "assets/icons/icon-social-media-linkedin-blue.svg", "alt", "", 1, "mx-3"], ["src", "assets/icons/icon-social-media-facebook-blue.svg", "alt", "", 1, "mx-3"], ["src", "assets/icons/icon-social-media-twitter-blue.svg", "alt", "", 1, "mx-3"], ["src", "assets/icons/icon-social-media-pinterest-blue.svg", "alt", "", 1, "mx-3"]], template: function SocialIconsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ol", 1);
        ɵngcc0.ɵɵelementStart(2, "li", 2);
        ɵngcc0.ɵɵelementStart(3, "a", 3);
        ɵngcc0.ɵɵelement(4, "img", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "li", 2);
        ɵngcc0.ɵɵelementStart(6, "a", 3);
        ɵngcc0.ɵɵelement(7, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "li", 2);
        ɵngcc0.ɵɵelementStart(9, "a", 3);
        ɵngcc0.ɵɵelement(10, "img", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "li", 2);
        ɵngcc0.ɵɵelementStart(12, "a", 3);
        ɵngcc0.ɵɵelement(13, "img", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.linkedinUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.facebookUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.twitterUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.pinterestUrl, ɵngcc0.ɵɵsanitizeUrl);
    } }, styles: [".ee-social-icons[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%]{-webkit-padding-start:unset;padding-inline-start:unset}.ee-social-icons[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:24px}"] });
SocialIconsComponent = __decorate([ __metadata("design:paramtypes", [])
], SocialIconsComponent);

let BlogReferencesComponent = class BlogReferencesComponent {
    constructor() {
        this.referenceUrls = [];
        this.showDetail = false;
    }
    ngOnInit() {
    }
};
BlogReferencesComponent.ɵfac = function BlogReferencesComponent_Factory(t) { return new (t || BlogReferencesComponent)(); };
BlogReferencesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlogReferencesComponent, selectors: [["emerson-blog-references"]], inputs: { referenceUrls: "referenceUrls" }, decls: 9, vars: 5, consts: [[1, "ee-blog-references"], [1, "chevron", 3, "click"], ["title", "Toggle details...", 1, "clickable"], ["src", "assets/bootstrap-icons/chevron-compact-up.svg", "class", "text-light-gray", "alt", "", "width", "32", "height", "32", "title", "Toggle details...", 4, "ngIf"], ["src", "assets/bootstrap-icons/chevron-compact-down.svg", "class", "text-light-gray", "alt", "", "width", "32", "height", "32", "title", "Toggle details...", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["src", "assets/bootstrap-icons/chevron-compact-up.svg", "alt", "", "width", "32", "height", "32", "title", "Toggle details...", 1, "text-light-gray"], ["src", "assets/bootstrap-icons/chevron-compact-down.svg", "alt", "", "width", "32", "height", "32", "title", "Toggle details...", 1, "text-light-gray"], [1, "indexCounter"], ["target", "_blank", 3, "href"]], template: function BlogReferencesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵlistener("click", function BlogReferencesComponent_Template_span_click_2_listener() { return ctx.showDetail = !ctx.showDetail; });
        ɵngcc0.ɵɵelementStart(3, "p", 2);
        ɵngcc0.ɵɵtext(4, "References ");
        ɵngcc0.ɵɵtemplate(5, BlogReferencesComponent_img_5_Template, 1, 0, "img", 3);
        ɵngcc0.ɵɵtemplate(6, BlogReferencesComponent_img_6_Template, 1, 0, "img", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "ol");
        ɵngcc0.ɵɵtemplate(8, BlogReferencesComponent_li_8_Template, 5, 3, "li", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDetail);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showDetail);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("display", ctx.showDetail ? "block" : "none");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.referenceUrls);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf], styles: [".ee-blog-references[_ngcontent-%COMP%]{color:#115ea5;line-height:18px;border-top:2px solid #979797;border-bottom:2px solid #979797;padding:.5rem 0}ol[_ngcontent-%COMP%]{list-style:none}.indexCounter[_ngcontent-%COMP%]{color:#000}.clickable[_ngcontent-%COMP%]{cursor:pointer}"] });
__decorate([
    Input(),
    __metadata("design:type", Array)
], BlogReferencesComponent.prototype, "referenceUrls", void 0);
BlogReferencesComponent = __decorate([ __metadata("design:paramtypes", [])
], BlogReferencesComponent);

let BlogPullQuoteComponent = class BlogPullQuoteComponent {
    constructor() { }
    ngOnInit() {
    }
};
BlogPullQuoteComponent.ɵfac = function BlogPullQuoteComponent_Factory(t) { return new (t || BlogPullQuoteComponent)(); };
BlogPullQuoteComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlogPullQuoteComponent, selectors: [["emerson-blog-pull-quote"]], inputs: { quoteContent: "quoteContent", quoteAttribution: "quoteAttribution" }, decls: 4, vars: 2, consts: [[1, "ee-pull-quote", "row", "d-flex", "justify-content-center", "align-items-center"], [1, "quoteText"], ["class", "quoteAttribution text-align-right mt-2 mr-2", 4, "ngIf"], [1, "quoteAttribution", "text-align-right", "mt-2", "mr-2"]], template: function BlogPullQuoteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "blockquote", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵtemplate(3, BlogPullQuoteComponent_div_3_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("\u201C", ctx.quoteContent, "\u201D ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.quoteAttribution);
    } }, directives: [ɵngcc2.NgIf], styles: [".ee-pull-quote[_ngcontent-%COMP%]{min-height:140px;border-top:2px solid #979797;border-bottom:2px solid #979797}.ee-pull-quote[_ngcontent-%COMP%]   .quoteText[_ngcontent-%COMP%]{display:-ms-inline-grid;display:inline-grid;line-height:48px;font-size:36px;font-style:italic;font-weight:300;color:#333}.ee-pull-quote[_ngcontent-%COMP%]   .quoteAttribution[_ngcontent-%COMP%]{text-align:right;color:#666;font-size:12px;line-height:15px}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogPullQuoteComponent.prototype, "quoteContent", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogPullQuoteComponent.prototype, "quoteAttribution", void 0);
BlogPullQuoteComponent = __decorate([ __metadata("design:paramtypes", [])
], BlogPullQuoteComponent);

var IContentService_1;
let IContentService = IContentService_1 = class IContentService {
    static throwMethodNotImplemented() {
        throw new Error('Method not implemented exception');
    }
    getContent() {
        try {
            IContentService_1.throwMethodNotImplemented();
        }
        catch (error) {
            console.log(error);
        }
        return;
    }
    getContentTypes() {
        try {
            IContentService_1.throwMethodNotImplemented();
        }
        catch (error) {
            console.log(error);
        }
        return;
    }
    getAssets() {
        try {
            IContentService_1.throwMethodNotImplemented();
        }
        catch (error) {
            console.log(error);
        }
        return;
    }
    getBlogPosts(query) {
        try {
            IContentService_1.throwMethodNotImplemented();
        }
        catch (error) {
            console.log(error);
        }
        return;
    }
    searchBlogPosts(query) {
        try {
            IContentService_1.throwMethodNotImplemented();
        }
        catch (error) {
            console.log(error);
        }
        return;
    }
    getEntriesByContentType(entryTypeId, query) {
        try {
            IContentService_1.throwMethodNotImplemented();
        }
        catch (error) {
            console.log(error);
        }
        return;
    }
    getNextSlug(updatedAt) {
        IContentService_1.throwMethodNotImplemented();
        return;
    }
    getPreviousSlug(entryTypeId) {
        try {
            IContentService_1.throwMethodNotImplemented();
        }
        catch (error) {
            console.log(error);
        }
        return;
    }
    convertRichTextToHtml(richText) {
        try {
            IContentService_1.throwMethodNotImplemented();
        }
        catch (error) {
            console.log(error);
        }
        return;
    }
};
IContentService.ɵfac = function IContentService_Factory(t) { return new (t || IContentService)(); };
IContentService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: IContentService, factory: function (t) { return IContentService.ɵfac(t); }, providedIn: 'root' });
IContentService.ngInjectableDef = ɵɵdefineInjectable({ factory: function IContentService_Factory() { return new IContentService(); }, token: IContentService, providedIn: "root" });

let ContentfulService = class ContentfulService extends IContentService {
    constructor(configService) {
        super();
        this.configService = configService;
        this.initClient();
    }
    /**
     * Initializes the client
     */
    initClient() {
        this.client = createClient({
            space: this.configService.configurations.contentful.space,
            accessToken: this.configService.configurations.contentful.accessToken,
            environment: this.configService.configurations.contentful.environment
        });
    }
    /**
     * @returns The entries
     */
    getContent() {
        try {
            return this.client.getEntries()
                .then(res => res.items);
        }
        catch (error) {
            console.log(error);
        }
    }
    /**
     * @returns A single entry
     */
    getEntry(id) {
        try {
            return this.client.getEntry(id)
                .then(res => res.items);
        }
        catch (error) {
            console.log(error);
        }
    }
    /**
     * @returns The content types
     */
    getContentTypes() {
        try {
            return this.client.getContentTypes()
                .then(res => res.items);
        }
        catch (error) {
            console.log(error);
        }
    }
    /**
     * @returns The Image Assets
     */
    getAssets() {
        try {
            return this.client.getAssets()
                .then(res => res.items);
        }
        catch (error) {
            console.log(error);
        }
    }
    /**
     * @returns blog posts - all or use query to filter by category or url slug
     */
    getBlogPosts(query) {
        try {
            return this.client.getEntries(Object.assign({
                content_type: 'blogPost'
            }, query))
                .then(res => res); // we need to return res to capture items and includes
        }
        catch (error) {
            console.log(error);
        }
    }
    /**
     * @returns blog posts matching the search string on first level fields only and returning items
     */
    searchBlogPosts(query) {
        try {
            return this.client.getEntries(Object.assign({
                content_type: 'blogPost'
            }, query))
                // .then(res => res);
                .then(res => res.items);
        }
        catch (error) {
            console.log(error);
        }
    }
    getEntriesByContentType(entryTypeId, query) {
        try {
            return this.client.getEntries(Object.assign({
                content_type: entryTypeId
            }, query)).then(res => res);
        }
        catch (error) {
            console.log(error);
        }
    }
    // the next two methods will return a next or previous url-slug or an empty string to indicate at end or start of entries
    getNextSlug(updatedAt) {
        // console.log('getNextSlug - updatedAt', updatedAt);
        const cQuery = {
            order: 'sys.updatedAt',
            limit: 1,
            select: 'sys.id,sys.updatedAt,fields.title,fields.subTitle,fields.headerImage,fields.urlSlug,' +
                'fields.publishDate,fields.metaDescription',
            'sys.updatedAt[gt]': updatedAt
        };
        return this.client.getEntries(Object.assign({
            content_type: 'blogPost'
        }, cQuery))
            .then(res => ((res.total) ? res.items[0].fields.urlSlug : ''));
    }
    getPreviousSlug(updatedAt) {
        // console.log('getPreviousSlug - updatedAt', updatedAt);
        const cQuery = {
            order: 'sys.updatedAt',
            limit: 1,
            select: 'sys.id,sys.updatedAt,fields.title,fields.subTitle,fields.headerImage,fields.urlSlug,' +
                'fields.publishDate,fields.metaDescription',
            'sys.updatedAt[lt]': updatedAt
        };
        return this.client.getEntries(Object.assign({
            content_type: 'blogPost'
        }, cQuery))
            .then(res => ((res.total) ? res.items[0].fields.urlSlug : ''));
    }
    convertRichTextToHtml(richText) {
        let returnValue = '';
        if (Array.isArray(richText)) {
            let response = '';
            for (const content of richText) {
                response += this.convertRichTextToHtml(content);
            }
            return response;
        }
        for (const element of richText.content) {
            if (element.nodeType === 'text') {
                let beforeText = '';
                let afterText = '';
                for (const mark of element.marks) {
                    if (mark.type === 'bold') {
                        beforeText += '<b>';
                        afterText += '</b>';
                    }
                    if (mark.type === 'italic') {
                        beforeText += '<i>';
                        afterText += '</i>';
                    }
                    if (mark.type === 'underline') {
                        beforeText += '<u>';
                        afterText += '</u>';
                    }
                }
                returnValue += beforeText + (element.value || '<br>') + afterText;
            }
            if (element.nodeType === 'hyperlink') {
                returnValue += `<a href="${element.data.uri}">`;
                returnValue += this.convertRichTextToHtml(element);
                returnValue += '</a>';
            }
            if (element.nodeType === 'entry-hyperlink') {
                // @ts-ignore
                returnValue += this.convertRichTextToHtml(element.data.target.fields.value.content);
            }
        }
        return returnValue;
    }
};
ContentfulService.ɵfac = function ContentfulService_Factory(t) { return new (t || ContentfulService)(ɵngcc0.ɵɵinject(ConfigurationService)); };
ContentfulService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ContentfulService, factory: function (t) { return ContentfulService.ɵfac(t); }, providedIn: 'root' });
ContentfulService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ContentfulService_Factory() { return new ContentfulService(ɵɵinject(ConfigurationService)); }, token: ContentfulService, providedIn: "root" });
ContentfulService = __decorate([ __metadata("design:paramtypes", [ConfigurationService])
], ContentfulService);

let BlogPostDetailComponent = class BlogPostDetailComponent {
    constructor(contentfulService, titleService) {
        this.contentfulService = contentfulService;
        this.titleService = titleService;
        // assume get method returns only one post based on urlSlug
        // public posts: Entry<any>[] = [];
        this.posts = [];
        this.contentBlocks = [];
        this.referenceUrls = [];
        this.recommendedArticles = [];
        this.includes = [];
        this.assets = [];
        this.hasHeaderImage = false;
        this.navigateToUrl = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (changes.urlSlug && !changes.urlSlug.firstChange) {
            this.getBlogData(changes.urlSlug.currentValue);
        }
    }
    ngOnInit() {
        this.getBlogData(this.urlSlug);
    }
    getBlogData(slug) {
        console.log('slug passed to getBlogData', slug);
        this.contentfulService.getBlogPosts({
            'fields.urlSlug': slug,
            include: 3,
            limit: 1,
            order: 'sys.updatedAt'
        })
            .then((response) => {
            this.posts = response.items;
            this.includes = response.includes.Entry;
            this.post = this.posts[0];
            this.assets = response.includes.Asset;
            this.contentBlocks = this.post.fields.contentBlocks;
            this.referenceUrls = this.post.fields.referenceUrls;
            this.title = this.post.fields.title;
            this.publishDate = this.post.fields.publishDate;
            this.updatedAt = this.post.sys.updatedAt;
            this.nextSlug = this.contentfulService.getNextSlug(this.updatedAt);
            this.previousSlug = this.contentfulService.getPreviousSlug(this.updatedAt);
            this.subTitle = this.post.fields.subTitle;
            this.categoryId = this.post.fields.category[0].sys.id;
            this.categoryName = this.getLinkedCategoryName(this.categoryId);
            this.categoryLink = this.getLinkedCategoryUrl(this.categoryId);
            this.authorId = this.post.fields.author.sys.id;
            this.authorName = this.getLinkedAuthor(this.authorId);
            this.recommendedArticles = this.post.fields.recommendedArticles;
            this.hasHeaderImage = 'headerImage' in this.post.fields;
            this.hasReferences = 'referenceUrls' in this.post.fields;
            this.hasRecommendedArticles = 'recommendedArticles' in this.post.fields;
            this.titleService.setTitle(this.title + ' | Emerson Ecologics - Blog');
        });
    }
    getLinkedCategoryName(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].fields.categoryName;
    }
    getLinkedCategoryUrl(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].fields.urlSlug;
    }
    getLinkedAuthor(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].fields.fullDisplayName;
    }
    getLinkedHeaderImage(id) {
        const ret = this.assets.filter(item => item.sys.id === id);
        return ret[0].fields.file.url;
    }
    getContentType(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].sys.contentType.sys.id;
    }
    getPullQuoteContent(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].fields.quoteText;
    }
    getPullQuoteAttribution(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].fields.quoteAttribution;
    }
    getVideoURL(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].fields.url;
    }
    getPromoContent(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return JSON.stringify(ret[0].fields);
    }
    getTextBlockContent(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        const rawRichTextField = ret[0].fields.content;
        const formattedContent = documentToHtmlString(rawRichTextField);
        return formattedContent;
    }
    getLinkedImageUrl(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].fields.image.fields.file.url;
    }
    getLinkedImageCaption(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].fields.caption;
    }
    getLinkedImageAttribution(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].fields.attribution;
    }
    getLeftSideId(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].fields.leftSide.sys.id;
    }
    getRightSideId(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return ret[0].fields.rightSide.sys.id;
    }
    getLinkedReferenceUrls() {
        const urls = [];
        const that = this;
        this.referenceUrls.forEach((element) => {
            const linkedItem = that.includes.filter(item => item.sys.id === element.sys.id);
            urls.push(linkedItem[0].fields.referenceUrl);
        });
        return urls;
    }
    getTitle(article) {
        return article.fields.postLink[0].fields.title;
    }
    getCardImgUrl(article) {
        return article.fields.postLink[0].fields.headerImage.fields.file.url;
    }
    getPubDate(article) {
        return article.fields.postLink[0].fields.publishDate;
    }
    getFirstContentBlock(article) {
        const firstId = article.fields.postLink[0].fields.contentBlocks[0].sys.id;
        const ret = this.includes.filter(item => item.sys.id === firstId);
        const paragraphs = ret[0].fields.content.content;
        return paragraphs[0].content[0].value;
    }
    getUrlSlug(article) {
        const theUrl = 'post/' + article.fields.postLink[0].fields.urlSlug;
        return theUrl;
    }
    navigateToPost(slug) {
        slug.then(value => {
            this.urlSlug = value;
            this.navigateToUrl.emit(this.urlSlug);
        });
    }
};
BlogPostDetailComponent.ɵfac = function BlogPostDetailComponent_Factory(t) { return new (t || BlogPostDetailComponent)(ɵngcc0.ɵɵdirectiveInject(IContentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.Title)); };
BlogPostDetailComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlogPostDetailComponent, selectors: [["emerson-blog-post-detail"]], inputs: { urlSlug: "urlSlug", authorRouterPath: "authorRouterPath", authorRouterData: "authorRouterData" }, outputs: { navigateToUrl: "navigateToUrl" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: IContentService, useClass: ContentfulService }]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 30, vars: 25, consts: [[1, "blog-post-detail"], [1, "legend"], [1, "categoryLink", 3, "href"], [3, "routerLink", "state", 4, "ngIf"], [4, "ngIf"], ["class", "image-full-width mb-4", 4, "ngIf"], ["class", "content-block", 4, "ngFor", "ngForOf"], [1, "nav-buttons", "d-flex", "justify-content-center", "my-5"], ["type", "button", 1, "ee-btn", "mr-3", "text-center", 3, "disabled", "ngClass", "click"], ["src", "assets/icons/triangle-solid-up-black.svg", "alt", "", 1, "nav-prev"], ["src", "assets/icons/triangle-solid-up-black.svg", "alt", "", 1, "nav-next"], ["class", "references", 4, "ngIf"], ["class", "mt-3", 4, "ngIf"], [3, "routerLink", "state"], [1, "image-full-width", "mb-4"], ["altTitle", "", "attribution", "", "caption", "", 3, "src"], [1, "content-block"], [3, "promotionEntry", 4, "ngIf"], [3, "quoteContent", "quoteAttribution", 4, "ngIf"], [3, "textContent", 4, "ngIf"], [3, "url", 4, "ngIf"], [3, "src", "altTitle", "caption", "attribution", 4, "ngIf"], [3, "imageLeft", "textContent", "src", "includes", "caption", "attribution", "leftSideId", "rightSideId", 4, "ngIf"], [3, "promotionEntry"], [3, "quoteContent", "quoteAttribution"], [3, "textContent"], [3, "url"], [3, "src", "altTitle", "caption", "attribution"], [3, "imageLeft", "textContent", "src", "includes", "caption", "attribution", "leftSideId", "rightSideId"], [1, "references"], [3, "referenceUrls"], [1, "mt-3"], [1, "text-center", "mb-5"], [1, "d-flex", "flex-wrap", "container-lg"], ["class", "flex-grow-0 mt-lg-1 col-lg-6 col-12", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "flex-grow-0", "mt-lg-1", "col-lg-6", "col-12", 3, "ngClass"], [3, "imgUrl", "header", "pubDate", "detailedContent", "ctaButtonUrl"]], template: function BlogPostDetailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h1");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "h2");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 1);
        ɵngcc0.ɵɵelementStart(6, "strong");
        ɵngcc0.ɵɵelementStart(7, "a", 2);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9, "\u00A0|");
        ɵngcc0.ɵɵtemplate(10, BlogPostDetailComponent_span_10_Template, 2, 3, "span", 3);
        ɵngcc0.ɵɵtemplate(11, BlogPostDetailComponent_span_11_Template, 2, 1, "span", 4);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(14, "emerson-social-icons");
        ɵngcc0.ɵɵtemplate(15, BlogPostDetailComponent_div_15_Template, 2, 1, "div", 5);
        ɵngcc0.ɵɵtemplate(16, BlogPostDetailComponent_div_16_Template, 7, 6, "div", 6);
        ɵngcc0.ɵɵelementStart(17, "div", 7);
        ɵngcc0.ɵɵelementStart(18, "button", 8);
        ɵngcc0.ɵɵlistener("click", function BlogPostDetailComponent_Template_button_click_18_listener() { return ctx.navigateToPost(ctx.previousSlug); });
        ɵngcc0.ɵɵpipe(19, "async");
        ɵngcc0.ɵɵpipe(20, "async");
        ɵngcc0.ɵɵelement(21, "img", 9);
        ɵngcc0.ɵɵtext(22, " Previous post ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "button", 8);
        ɵngcc0.ɵɵlistener("click", function BlogPostDetailComponent_Template_button_click_23_listener() { return ctx.navigateToPost(ctx.nextSlug); });
        ɵngcc0.ɵɵpipe(24, "async");
        ɵngcc0.ɵɵpipe(25, "async");
        ɵngcc0.ɵɵtext(26, " Next post ");
        ɵngcc0.ɵɵelement(27, "img", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(28, BlogPostDetailComponent_div_28_Template, 2, 1, "div", 11);
        ɵngcc0.ɵɵtemplate(29, BlogPostDetailComponent_div_29_Template, 5, 1, "div", 12);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.subTitle);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate1("href", "category/", ctx.categoryLink, "", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.categoryName);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.authorRouterPath);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.authorRouterPath);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("|\u00A0", ɵngcc0.ɵɵpipeBind1(13, 15, ctx.publishDate), "");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasHeaderImage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.contentBlocks);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ɵngcc0.ɵɵpipeBind1(19, 17, ctx.previousSlug) === false)("ngClass", ɵngcc0.ɵɵpipeBind1(20, 19, ctx.previousSlug) === false ? " ee-btn-disabled" : "ee-btn-tertiary");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("disabled", ɵngcc0.ɵɵpipeBind1(24, 21, ctx.nextSlug) === false)("ngClass", ɵngcc0.ɵɵpipeBind1(25, 23, ctx.nextSlug) === false ? " ee-btn-disabled" : "ee-btn-tertiary");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasReferences);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasRecommendedArticles);
    } }, directives: function () { return [ɵngcc2.NgIf, SocialIconsComponent, ɵngcc2.NgForOf, ɵngcc2.NgClass, ɵngcc4.RouterLink, BlogImageComponent, PromotionContentComponent, BlogPullQuoteComponent, BlogTextBlockComponent, BlogVideoComponent, BlogColumnsComponent, BlogReferencesComponent, CategorycardComponent]; }, pipes: function () { return [ɵngcc2.DatePipe, ɵngcc2.AsyncPipe]; }, styles: [".nav-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{min-width:200px;font-size:18px;line-height:24px;font-weight:700;padding:.75rem}.nav-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .nav-next[_ngcontent-%COMP%]{transform:rotate(90deg);height:14px;width:21px}.nav-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .nav-prev[_ngcontent-%COMP%]{transform:rotate(-90deg);height:14px;width:21px}.placeholder[_ngcontent-%COMP%]{color:red;font-weight:bolder;font-size:24px}.author-page-link[_ngcontent-%COMP%]{cursor:pointer}.recommended-articles[_ngcontent-%COMP%]{margin-top:1rem}.recommended-articles[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{text-align:center;margin-bottom:2rem}.card-container[_ngcontent-%COMP%]{width:100%!important}@media (min-width:992px){.card-container[_ngcontent-tsn-c7][_ngcontent-%COMP%]{width:90%!important}}.recommendedArticlesWrapper[_ngcontent-%COMP%]{display:flex!important;flex-wrap:wrap}.recommendedArticlesWrapper[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{flex:0 50%;box-sizing:border-box;width:100%}@media (max-width:992px){.recommendedArticlesWrapper[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{flex:0 100%;margin-top:1rem}}.pad-left[_ngcontent-%COMP%]{padding-left:.5em}.pad-right[_ngcontent-%COMP%]{padding-right:.5em}a.categoryLink[_ngcontent-%COMP%]{text-display:none;color:#212529}h1[_ngcontent-%COMP%]{font-size:36px}h2[_ngcontent-%COMP%]{font-size:24px}h3[_ngcontent-%COMP%], h4[_ngcontent-%COMP%], h5[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]{font-size:20px}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogPostDetailComponent.prototype, "urlSlug", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogPostDetailComponent.prototype, "authorRouterPath", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], BlogPostDetailComponent.prototype, "authorRouterData", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], BlogPostDetailComponent.prototype, "navigateToUrl", void 0);
BlogPostDetailComponent = __decorate([ __metadata("design:paramtypes", [IContentService, Title])
], BlogPostDetailComponent);

let BlogImageComponent = class BlogImageComponent {
    constructor() { }
    ngOnInit() {
    }
};
BlogImageComponent.ɵfac = function BlogImageComponent_Factory(t) { return new (t || BlogImageComponent)(); };
BlogImageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlogImageComponent, selectors: [["emerson-blog-image"]], inputs: { src: "src", altTitle: "altTitle", attribution: "attribution", caption: "caption" }, decls: 6, vars: 5, consts: [[1, "blog-image-wrapper"], [1, "blog-image"], [1, "img-fluid", 3, "src", "alt"], ["class", "attribution", 4, "ngIf"], ["class", "caption", 4, "ngIf"], [4, "ngIf"], [1, "attribution"], [1, "caption"]], template: function BlogImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "img", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, BlogImageComponent_div_3_Template, 2, 1, "div", 3);
        ɵngcc0.ɵɵtemplate(4, BlogImageComponent_div_4_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(5, BlogImageComponent_hr_5_Template, 1, 0, "hr", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.src, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵpropertyInterpolate("alt", ctx.altTitle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.attribution);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.caption);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.attribution || ctx.caption);
    } }, directives: [ɵngcc2.NgIf], styles: [".blog-image-wrapper[_ngcontent-%COMP%]{margin:0;width:100%}.blog-image-wrapper[_ngcontent-%COMP%]   hr[_ngcontent-%COMP%]{border:1px solid #ccc}.blog-image[_ngcontent-%COMP%]{border:2px solid #ccc}.blog-image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:100%}.attribution[_ngcontent-%COMP%]{color:#666;font-size:11px;line-height:15px;margin-top:.5rem}.caption[_ngcontent-%COMP%]{font-size:13px;font-weight:500;line-height:18px;margin-top:.5rem}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogImageComponent.prototype, "src", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogImageComponent.prototype, "altTitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogImageComponent.prototype, "attribution", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogImageComponent.prototype, "caption", void 0);
BlogImageComponent = __decorate([ __metadata("design:paramtypes", [])
], BlogImageComponent);

const ɵ0 = ContentfulService;
let ContentComponent = class ContentComponent {
    constructor(contentful) {
        this.contentful = contentful;
        this.content = [];
    }
    ngOnInit() {
        // this.getContentTypes();
        // this.getAssets();
    }
    getContent() {
        this.contentful.getContent()
            .then(content => {
            this.content = content;
            this.contentList = [];
            if (this.contentTypes.length > 0) {
                this.contentTypes.forEach((item, i) => {
                    this.contentList[i] = this.groupByitem(this.content, item.sys.id.toLowerCase());
                });
            }
        });
    }
    getAssets() {
        this.contentful.getAssets().then(assets => {
            assets.forEach(item => {
                item.fields.file.url = `https:${item.fields.file.url}`;
            });
            this.assetsList = assets;
        });
    }
    getContentTypes() {
        this.contentful.getContentTypes()
            .then(contenttypes => {
            this.contentTypes = contenttypes;
            this.getContent();
        });
    }
    groupByitem(array, key) {
        const result = [];
        // Return the end result
        array.forEach(item => {
            if (item.sys.contentType.sys.id.toLowerCase() === key.toLowerCase()) {
                result.push(item);
            }
        });
        return result;
    }
};
ContentComponent.ɵfac = function ContentComponent_Factory(t) { return new (t || ContentComponent)(ɵngcc0.ɵɵdirectiveInject(IContentService)); };
ContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ContentComponent, selectors: [["emerson-content"]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: IContentService, useValue: ɵ0 }])], decls: 6, vars: 2, consts: [[4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "routerLink"], [3, "src"]], template: function ContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h1");
        ɵngcc0.ɵɵtext(1, " Content Block ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, ContentComponent_div_2_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵelement(3, "br");
        ɵngcc0.ɵɵelementStart(4, "div");
        ɵngcc0.ɵɵtemplate(5, ContentComponent_div_5_Template, 5, 2, "div", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.contentList);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.assetsList);
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc4.RouterLinkWithHref], styles: [""] });
ContentComponent = __decorate([ __metadata("design:paramtypes", [IContentService])
], ContentComponent);

let NavbarComponent = class NavbarComponent {
    constructor() {
        this.brandLogoUrl = 'assets/icons/Logo-Emerson-Ecologics-White.svg';
        this.siteLinks = [];
        this.categories = [];
        this.brandLinkUrl = '#';
        this.postBrandLogoText = '';
        this.sidebarToggle = new EventEmitter();
        this.logoClick = new EventEmitter();
        this.categorySelect = new EventEmitter();
        this.getSearchString = new EventEmitter();
        this.sidebarExpanded = false;
        this.searchIconHidden = false;
        this.isOpen = false;
    }
    ngOnInit() {
        const searchBox = document.getElementById('search-box');
        const typeahead = fromEvent(searchBox, 'input').pipe(map((e) => e.target.value), filter(text => text.length > 3), debounceTime(100), distinctUntilChanged());
        typeahead.subscribe(searchString => {
            // Handle the data from the observable
            this.getSearchString.emit(searchString);
        });
    }
    toggleSidebar() {
        this.sidebarExpanded = !this.sidebarExpanded;
        this.sidebarToggle.emit(this.sidebarExpanded);
    }
    logoClicked() {
        this.logoClick.emit();
    }
    categorySelected(value) {
        this.categorySelect.emit(value);
    }
    searchIconToggle() {
        if (this.searchIconHidden) {
            this.isOpen = false;
            setTimeout(() => {
                this.searchIconHidden = !this.searchIconHidden;
                this.isOpen = this.searchIconHidden;
            }, 750);
        }
        else {
            this.searchIconHidden = !this.searchIconHidden;
            this.isOpen = this.searchIconHidden;
        }
    }
    onResize($event) {
        if (window.outerWidth >= 992) {
            // set to false to force input block to go away on larger size
            this.searchIconHidden = false;
            this.isOpen = this.searchIconHidden;
        }
    }
};
NavbarComponent.ɵfac = function NavbarComponent_Factory(t) { return new (t || NavbarComponent)(); };
NavbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavbarComponent, selectors: [["emerson-navbar"]], hostBindings: function NavbarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function NavbarComponent_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { brandLogoUrl: "brandLogoUrl", siteLinks: "siteLinks", categories: "categories", brandLinkUrl: "brandLinkUrl", postBrandLogoText: "postBrandLogoText" }, outputs: { sidebarToggle: "sidebarToggle", logoClick: "logoClick", categorySelect: "categorySelect", getSearchString: "getSearchString" }, decls: 16, vars: 11, consts: [[1, "container-fluid", "w-100"], ["class", "row ee-black d-none d-lg-block mo-padding", 4, "ngIf"], [1, "row", "ee-nav", "ee-primary-green", "justify-content-between", "mo-padding"], [1, "col", "d-block", "d-lg-none", "my-auto"], ["class", "navbar-toggler-icon", 3, "click", 4, "ngIf"], [1, "col", "text-center", "text-lg-left", "logo", "d-none", "d-lg-block"], ["class", "wrap-logo", 4, "ngIf"], ["class", "col-9 input-group", 4, "ngIf"], ["class", "col text-center text-lg-left logo d-block d-lg-none", 4, "ngIf"], ["class", "col d-block d-none d-lg-none", 4, "ngIf"], [1, "col", "d-none", "d-lg-block"], ["type", "text", "id", "search-box", "placeholder", "Search...", 1, "form-control", "d-inline-flex", "w-75", "float-right", "mt-2"], ["class", "row ee-gray mo-padding", 4, "ngIf"], [1, "sidebar", "d-sm-block", "d-lg-none", "position-relative", "overflow-hidden", "py-1", "px-3", 3, "ngClass"], [4, "ngFor", "ngForOf"], [1, "row", "ee-black", "d-none", "d-lg-block", "mo-padding"], [1, "flex-list", "position-relative", "overflow-hidden"], [1, "d-flex", "flex-row", "flex-wrap", "justify-content-start", "pl-0", "align-items-center", "m-0", "py-1"], ["class", "text-center align-self-center", 4, "ngFor", "ngForOf"], [1, "text-center", "align-self-center"], [1, "ee-nav-link", 3, "href"], [1, "link-spacer"], [1, "navbar-toggler-icon", 3, "click"], [1, "wrap-logo"], [3, "href"], ["alt", "Logo", 3, "src", "click"], ["class", "d-inline pl-1 ml-1", 4, "ngIf"], [1, "d-inline", "pl-1", "ml-1"], [1, "col-9", "input-group"], [1, "input-group-append"], ["class", "close-icon mr-1", "src", "./assets/icons/icon-close-delete-remove-gray.svg", "alt", "Search", 3, "click", 4, "ngIf"], ["type", "text", "id", "search-box", "placeholder", "Search...", 1, "form-control", "d-inline-flex", "w-75", "float-right", "mt-2", "search-input"], ["src", "./assets/icons/icon-close-delete-remove-gray.svg", "alt", "Search", 1, "close-icon", "mr-1", 3, "click"], [1, "col", "text-center", "text-lg-left", "logo", "d-block", "d-lg-none"], [1, "col", "d-block", "d-none", "d-lg-none"], ["src", "./assets/icons/icon-search-white.svg", "alt", "Search...", 1, "search-icon", "float-right", "mt-3", 3, "click"], [1, "row", "ee-gray", "mo-padding"], [1, "flex-list", "d-none", "d-lg-block", "position-relative", "overflow-hidden"], [1, "row", "input-group", "d-sm-block", "d-lg-none"], [1, "col", "mt-1", "mb-1", "pr-0", "ml-2"], ["id", "inputGroupSelect01", 1, "category-select", "position-relative", "d-block", "w-100", 3, "change"], ["selected", "", "value", "default"], [3, "value", 4, "ngFor", "ngForOf"], [1, "ee-nav-link", 3, "routerLink"], [3, "value"]], template: function NavbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NavbarComponent_nav_1_Template, 4, 1, "nav", 1);
        ɵngcc0.ɵɵelementStart(2, "nav", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, NavbarComponent_div_4_Template, 1, 0, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtemplate(6, NavbarComponent_div_6_Template, 4, 3, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, NavbarComponent_div_7_Template, 5, 2, "div", 7);
        ɵngcc0.ɵɵtemplate(8, NavbarComponent_div_8_Template, 4, 3, "div", 8);
        ɵngcc0.ɵɵtemplate(9, NavbarComponent_div_9_Template, 2, 0, "div", 9);
        ɵngcc0.ɵɵelementStart(10, "div", 10);
        ɵngcc0.ɵɵelement(11, "input", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, NavbarComponent_nav_12_Template, 10, 2, "nav", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 13);
        ɵngcc0.ɵɵelementStart(14, "ul");
        ɵngcc0.ɵɵtemplate(15, NavbarComponent_li_15_Template, 3, 2, "li", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.siteLinks.length);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.siteLinks.length);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.searchIconHidden);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchIconHidden);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.searchIconHidden);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.searchIconHidden);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.categories.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c3, !ctx.sidebarExpanded));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.siteLinks);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc1.NgSelectOption, ɵngcc1.ɵangular_packages_forms_forms_x, ɵngcc4.RouterLinkWithHref], styles: ["nav[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]{padding-left:0}nav[_ngcontent-%COMP%]   .logo[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin:.5em 0;width:12rem}nav[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{border-left:1px solid #fff}nav[_ngcontent-%COMP%]   .navbar-toggler-icon[_ngcontent-%COMP%]{width:2em;background-image:url(assets/icon-blog-hamburger-white.svg)}.ee-nav[_ngcontent-%COMP%]{background-color:var(--primary-green);min-height:56px}.ee-nav-link[_ngcontent-%COMP%]{text-decoration:none;color:#fff;font-weight:600;font-size:14px}.container-fluid[_ngcontent-%COMP%]{white-space:nowrap}.category-select[_ngcontent-%COMP%]{height:2.5rem}.flex-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin-left:-1px;list-style-type:none}.flex-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .link-spacer[_ngcontent-%COMP%]{margin:0 .5em;height:15px;display:inline-block;vertical-align:middle}.flex-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-of-type   .link-spacer[_ngcontent-%COMP%]{padding-left:0;border-left:none}.sidebar[_ngcontent-%COMP%]{height:900em;left:0;top:0;z-index:1;background:#fff;width:30%;box-shadow:2px 0 4px rgba(0,0,0,.5);transition:.25s}.sidebar.hidden[_ngcontent-%COMP%]{display:none;left:-50em}.sidebar[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style:none}.form-control[_ngcontent-%COMP%]{display:inline-flex;width:75%;float:right;margin-top:.6rem}.form-control-animate[_ngcontent-%COMP%]{display:inline-flex;float:right;margin-top:.6rem}.search-icon[_ngcontent-%COMP%]{width:1.5rem}.input-group[_ngcontent-%COMP%]{display:block}.input-group-append[_ngcontent-%COMP%]{float:right;margin-left:-46px;margin-top:18px;z-index:5}.search-input[_ngcontent-%COMP%]{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important;margin-right:.5rem}.close-icon[_ngcontent-%COMP%]{width:1.15rem;z-index:100;margin-left:-34px!important}.mo-padding[_ngcontent-%COMP%]{padding-left:16.67%;padding-right:16.67%}@media (max-width:991.98px){.mo-padding[_ngcontent-%COMP%]{padding-left:0;padding-right:0}}"], data: { animation: [
            trigger('openClose', [
                state('open', style({
                    display: 'block',
                    width: '70%'
                })),
                state('closed', style({
                    display: 'none',
                    width: '1%'
                })),
                transition('open => closed', [
                    animate('0.75s')
                ]),
                transition('* => open', [
                    // animate('15s .2s ease-out')
                    animate('750ms', keyframes([
                        style({ width: '1%', offset: 0 }),
                        style({ width: '10%', offset: 0.1 }),
                        style({ width: '20%', offset: 0.2 }),
                        style({ width: '30%', offset: 0.3 }),
                        style({ width: '40%', offset: 0.4 }),
                        style({ width: '50%', offset: 0.6 }),
                        style({ width: '60%', offset: 0.8 }),
                        style({ width: '70%', offset: 1.0 })
                    ]))
                ]),
            ]),
        ] } });
__decorate([
    Input(),
    __metadata("design:type", Object)
], NavbarComponent.prototype, "brandLogoUrl", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], NavbarComponent.prototype, "siteLinks", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], NavbarComponent.prototype, "categories", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NavbarComponent.prototype, "brandLinkUrl", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NavbarComponent.prototype, "postBrandLogoText", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NavbarComponent.prototype, "sidebarToggle", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NavbarComponent.prototype, "logoClick", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NavbarComponent.prototype, "categorySelect", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NavbarComponent.prototype, "getSearchString", void 0);
__decorate([
    HostListener('window:resize', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NavbarComponent.prototype, "onResize", null);
NavbarComponent = __decorate([ __metadata("design:paramtypes", [])
], NavbarComponent);

let BlogCategoryComponent = class BlogCategoryComponent {
    constructor(contentfulService, activatedRoute) {
        this.contentfulService = contentfulService;
        this.activatedRoute = activatedRoute;
        this.activatedRoute.params.subscribe(params => {
            this.urlSlug = params['slug-url'];
        });
    }
    ngOnInit() {
        this.contentfulService.getEntriesByContentType('blogCategory', {
            'fields.urlSlug': this.urlSlug
        })
            .then((response) => {
            this.blogCategory = response.items[0].fields.promotioncontent[0].fields.promotionalContentImage
                .filter(item => item.fields.title.trim().toLocaleLowerCase() === 'default promo');
            this.categoryCards = response.items[0].fields.categoryCardContent;
        });
    }
    getTitle(article) {
        return article.fields.title;
    }
    getCardImgUrl(article) {
        return article.fields.image[0].fields.file.url;
    }
    getcardContent(article) {
        return article.fields.cardContent;
    }
};
BlogCategoryComponent.ɵfac = function BlogCategoryComponent_Factory(t) { return new (t || BlogCategoryComponent)(ɵngcc0.ɵɵdirectiveInject(IContentService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.ActivatedRoute)); };
BlogCategoryComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlogCategoryComponent, selectors: [["emerson-blog-category"]], inputs: { urlSlug: "urlSlug" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: IContentService, useClass: ContentfulService }])], decls: 6, vars: 2, consts: [[1, "section"], ["imgUrl", "assets/images/Hero-image.png", "header", "This is a blog headline", "categoryName", "Category Name", "authorName", "Author Name", "pubDate", "November 14, 2021", "detailedContent", "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore ipsum neque nihil optio, porro\n      quis unde! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore ipsum neque nihil optio, porro\n      quis unde!Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore ipsum neque nihil optio, porro\n      quis unde! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore ipsum neque nihil optio, porro\n      quis unde!", "ctaButtonText", "Primary", "ctaButtonUrl", ""], [4, "ngIf"], ["class", "blogCategoryCardWrapper container-lg", 4, "ngIf"], [2, "text-align", "center"], ["alt", "", 1, "promo-container", 3, "src"], [1, "blogCategoryCardWrapper", "container-lg"], [4, "ngFor", "ngForOf"], [3, "imgUrl", "header", "detailedContent", "ctaButtonUrl"]], template: function BlogCategoryComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h1");
        ɵngcc0.ɵɵtext(2, "Blog Category");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "emerson-jumbotron", 1);
        ɵngcc0.ɵɵtemplate(4, BlogCategoryComponent_div_4_Template, 3, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(5, BlogCategoryComponent_div_5_Template, 2, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.blogCategory);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.categoryCards);
    } }, directives: function () { return [JumbotronComponent, ɵngcc2.NgIf, ɵngcc2.NgForOf, CategorycardComponent]; }, styles: [".blogCategoryCardWrapper[_ngcontent-%COMP%]{display:flex!important;flex-wrap:wrap;margin-top:20px}.blogCategoryCardWrapper[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{flex:0 50%;box-sizing:border-box;width:100%}@media (max-width:992px){.blogCategoryCardWrapper[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{flex:0 100%;margin-top:1rem}}@media (min-width:576px){.promo-container[_ngcontent-%COMP%]{width:90%;max-width:540px}}@media (min-width:768px){.promo-container[_ngcontent-%COMP%]{width:96%;max-width:720px}}@media (min-width:992px){.promo-container[_ngcontent-%COMP%]{width:100%;max-width:960px}}@media (min-width:1200px){.promo-container[_ngcontent-%COMP%]{width:83%;max-width:1140px}}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogCategoryComponent.prototype, "urlSlug", void 0);
BlogCategoryComponent = __decorate([ __metadata("design:paramtypes", [IContentService, ActivatedRoute])
], BlogCategoryComponent);

let BlogTextBlockComponent = class BlogTextBlockComponent {
    constructor() {
        this.textContent = 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsam.';
    }
    ngOnInit() {
    }
};
BlogTextBlockComponent.ɵfac = function BlogTextBlockComponent_Factory(t) { return new (t || BlogTextBlockComponent)(); };
BlogTextBlockComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlogTextBlockComponent, selectors: [["emerson-blog-text-block"]], inputs: { textContent: "textContent" }, decls: 1, vars: 1, consts: [[1, "ee-text-block", "w-100", 3, "innerHTML"]], template: function BlogTextBlockComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("innerHTML", ctx.textContent, ɵngcc0.ɵɵsanitizeHtml);
    } }, styles: [".ee-text-block[_ngcontent-%COMP%]{color:#333;font-family:Roboto;font-size:18px;line-height:29px}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], BlogTextBlockComponent.prototype, "textContent", void 0);
BlogTextBlockComponent = __decorate([ __metadata("design:paramtypes", [])
], BlogTextBlockComponent);

let FooterComponent = class FooterComponent {
    constructor() {
        this.linkedinUrl = 'https://www.linkedin.com';
        this.facebookUrl = 'https://www.facebook.com';
        this.twitterUrl = 'https://twitter.com';
        this.instagramUrl = 'https://instagram.com';
        this.pinterestUrl = 'https://pinterest.com';
        this.youtubeUrl = 'https://www.youtube.com';
        this.thisYear = (new Date()).getFullYear();
    }
    ngOnInit() {
        this.linkedinUrl = 'https://www.linkedin.com/company/emerson-ecologics';
        this.facebookUrl = 'http://www.facebook.com/emersonecologics';
        this.youtubeUrl = 'https://www.youtube.com/channel/UCpOIVrJzDk9KksMIqgZxusg';
        this.twitterUrl = 'https://twitter.com/EmersonEcologic';
        this.instagramUrl = 'https://www.instagram.com/emerson_ecologics/';
    }
};
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["emerson-footer"]], decls: 73, vars: 5, consts: [[1, "ee-dark-gray", "ee-footer", "container-fluid"], [1, "row", "justify-content-md-center"], [1, "col", "flex-list", "d-flex", "justify-content-md-center", "mt-2", "position-relative"], [1, "emerson-footer", "d-flex", "flex-row", "flex-wrap", "justify-content-start", "pl-0", "align-items-center", "m-0", "py-1", "px-0"], ["target", "_blank", "href", "https://www.emersonecologics.com/brands/directory/all"], [1, "link-spacer"], ["target", "_blank", "href", "https://edu.emersonecologics.com/specials/"], ["target", "_blank", "href", "https://www.emersonecologics.com/blog/"], ["target", "_blank", "href", "https://emerson.zendesk.com/hc/en-us"], ["target", "_blank", "href", "https://edu.emersonecologics.com/about-us/"], ["target", "_blank", "href", "https://emerson.zendesk.com/hc/en-us/articles/231340148-Customer-Support-Contact-Information"], ["target", "_blank", "href", "http://emersonecologics.atsondemand.com/index.cfm?cid=512163"], ["target", "_blank", "href", "https://edu.emersonecologics.com/terms-of-sale/"], ["target", "_blank", "href", "https://edu.emersonecologics.com/privacy-policy/"], [1, "social-icons", "p-2", "text-center"], [1, "my-2"], [1, "list-inline", "d-inline"], ["target", "_blank", 3, "href"], ["src", "assets/icons/icon-social-media-linkedin-white.svg", "alt", "", 1, "mx-3"], ["src", "assets/icons/icon-social-media-facebook-white.svg", "alt", "", 1, "mx-3"], ["src", "assets/icons/icon-social-media-twitter-white.svg", "alt", "", 1, "mx-3"], ["src", "assets/icons/icon-social-media-insta-white.svg", "alt", "", 1, "mx-3"], [1, "col"], [1, "col", "text-center", "flex-list", "position-relative"], [1, "mb-0"], [1, "col-10", "text-center", "flex-list", "position-relative"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "ul", 3);
        ɵngcc0.ɵɵelementStart(4, "li");
        ɵngcc0.ɵɵelementStart(5, "a", 4);
        ɵngcc0.ɵɵtext(6, "Brands");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(7, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "li");
        ɵngcc0.ɵɵelementStart(9, "a", 6);
        ɵngcc0.ɵɵtext(10, "Specials");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(11, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "li");
        ɵngcc0.ɵɵelementStart(13, "a", 7);
        ɵngcc0.ɵɵtext(14, "Blog");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(15, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "li");
        ɵngcc0.ɵɵelementStart(17, "a", 8);
        ɵngcc0.ɵɵtext(18, "FAQs");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(19, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "li");
        ɵngcc0.ɵɵelementStart(21, "a", 9);
        ɵngcc0.ɵɵtext(22, "About Us");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(23, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "li");
        ɵngcc0.ɵɵelementStart(25, "a", 10);
        ɵngcc0.ɵɵtext(26, "Contact Us");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(27, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "li");
        ɵngcc0.ɵɵelementStart(29, "a", 11);
        ɵngcc0.ɵɵtext(30, "Join Our Team");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(31, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "li");
        ɵngcc0.ɵɵelementStart(33, "a", 12);
        ɵngcc0.ɵɵtext(34, "Terms of Use");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(35, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "li");
        ɵngcc0.ɵɵelementStart(37, "a", 13);
        ɵngcc0.ɵɵtext(38, "Privacy Policy");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(39, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "div", 14);
        ɵngcc0.ɵɵelementStart(41, "ol", 15);
        ɵngcc0.ɵɵelementStart(42, "li", 16);
        ɵngcc0.ɵɵelementStart(43, "a", 17);
        ɵngcc0.ɵɵelement(44, "img", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(45, "li", 16);
        ɵngcc0.ɵɵelementStart(46, "a", 17);
        ɵngcc0.ɵɵelement(47, "img", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(48, "li", 16);
        ɵngcc0.ɵɵelementStart(49, "a", 17);
        ɵngcc0.ɵɵelement(50, "img", 20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(51, "li", 16);
        ɵngcc0.ɵɵelementStart(52, "a", 17);
        ɵngcc0.ɵɵelement(53, "img", 21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(54, "div", 1);
        ɵngcc0.ɵɵelement(55, "div", 22);
        ɵngcc0.ɵɵelementStart(56, "div", 23);
        ɵngcc0.ɵɵelementStart(57, "p", 24);
        ɵngcc0.ɵɵelementStart(58, "b");
        ɵngcc0.ɵɵtext(59, "Connect with us!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(60, "div", 22);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(61, "div", 1);
        ɵngcc0.ɵɵelement(62, "div", 22);
        ɵngcc0.ɵɵelementStart(63, "div", 25);
        ɵngcc0.ɵɵelementStart(64, "p");
        ɵngcc0.ɵɵtext(65);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(66, "p");
        ɵngcc0.ɵɵtext(67, "* These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure or prevent any disease.");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(68, "p");
        ɵngcc0.ɵɵtext(69, "\u2020 Claims based on traditional homeopathic practice, not accepted medical evidence. Not FDA evaluated.");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(70, "p");
        ɵngcc0.ɵɵtext(71, "We work to ensure that product information is correct; however, brands may make changes to product from time to time, and actual product packaging and materials may contain more and/or different information than that shown on our website. Please consult all labels, warnings, and directions prior to using or consuming products for the most accurate product information. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(72, "div", 22);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(43);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.linkedinUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.facebookUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.twitterUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.instagramUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(13);
        ɵngcc0.ɵɵtextInterpolate1("Copyright \u00A9 1997-", ctx.thisYear, " Emerson Ecologics, LLC, All rights reserved. ");
    } }, styles: [".link-spacer[_ngcontent-%COMP%]{border-left:2px solid #fff}.emerson-footer[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{float:left}.emerson-footer[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:inherit;text-decoration:none}.social-icons[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%]{-webkit-padding-start:unset;padding-inline-start:unset}.social-icons[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:24px}.flex-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin-left:-1px;list-style-type:none}.flex-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{flex-basis:auto;text-align:center;-ms-grid-row-align:center;align-self:center}.flex-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .link-spacer[_ngcontent-%COMP%]{margin:0 .5em;height:15px;display:inline-block;vertical-align:middle}.flex-list[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-of-type   .link-spacer[_ngcontent-%COMP%]{padding-left:0;border-left:none}"] });
FooterComponent = __decorate([ __metadata("design:paramtypes", [])
], FooterComponent);

let BlogColumnsComponent = class BlogColumnsComponent {
    constructor() {
        this.imageLeft = false;
        this.textContent = '';
    }
    ngOnInit() {
        // use the left and right side ids to look up the nested content and set the other inputs (make private?)
        this.imageLeft = this.getLeftSideType(this.leftSideId) !== 'textBlock';
        this.getRightSideItem(this.rightSideId);
        // tslint:disable-next-line:no-debugger
        // debugger;
        if (this.imageLeft) {
            // use right side for text attribute
            this.textContent = this.getTextBlockContent(this.rightSideId);
            // use left side for image attributes
            this.src = this.leftSideItem.fields.image.fields.file.url;
            this.caption = this.leftSideItem.fields.caption;
            this.attribution = this.leftSideItem.fields.attribution;
        }
        else {
            // use left side for text attribute
            this.textContent = this.getTextBlockContent(this.leftSideId);
            // use right side for image attributes
            this.src = this.rightSideItem.fields.image.fields.file.url;
            this.caption = this.rightSideItem.fields.caption;
            this.attribution = this.rightSideItem.fields.attribution;
        }
    }
    getLeftSideType(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        this.leftSideItem = ret[0];
        return ret[0].sys.contentType.sys.id;
    }
    getRightSideItem(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        this.rightSideItem = ret[0];
    }
    getTextBlockContent(id) {
        const ret = this.includes.filter(item => item.sys.id === id);
        return documentToHtmlString(ret[0].fields.content);
    }
};
BlogColumnsComponent.ɵfac = function BlogColumnsComponent_Factory(t) { return new (t || BlogColumnsComponent)(); };
BlogColumnsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlogColumnsComponent, selectors: [["emerson-blog-columns"]], inputs: { imageLeft: "imageLeft", textContent: "textContent", src: "src", caption: "caption", attribution: "attribution", altTitle: "altTitle", includes: "includes", leftSideId: "leftSideId", rightSideId: "rightSideId" }, decls: 8, vars: 4, consts: [[1, "blog-col-wrapper", "container-fluid"], [1, "row"], [1, "col-xl", "col-left"], [3, "textContent", 4, "ngIf"], [3, "src", "altTitle", "attribution", "caption", 4, "ngIf"], [1, "col-xl", "col-right"], [3, "textContent"], [3, "src", "altTitle", "attribution", "caption"]], template: function BlogColumnsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, BlogColumnsComponent_emerson_blog_text_block_3_Template, 1, 1, "emerson-blog-text-block", 3);
        ɵngcc0.ɵɵtemplate(4, BlogColumnsComponent_emerson_blog_image_4_Template, 1, 4, "emerson-blog-image", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtemplate(6, BlogColumnsComponent_emerson_blog_text_block_6_Template, 1, 1, "emerson-blog-text-block", 3);
        ɵngcc0.ɵɵtemplate(7, BlogColumnsComponent_emerson_blog_image_7_Template, 1, 4, "emerson-blog-image", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.imageLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.imageLeft);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.imageLeft);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.imageLeft);
    } }, directives: [ɵngcc2.NgIf, BlogTextBlockComponent, BlogImageComponent], styles: [".blog-col-wrapper[_ngcontent-%COMP%]{margin:1rem 0}.col-left[_ngcontent-%COMP%]{padding:0;margin-bottom:1rem}.col-right[_ngcontent-%COMP%]{padding:0}@media (min-width:1200px){.col-left[_ngcontent-%COMP%]{padding-right:1rem}}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], BlogColumnsComponent.prototype, "imageLeft", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], BlogColumnsComponent.prototype, "textContent", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogColumnsComponent.prototype, "src", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogColumnsComponent.prototype, "altTitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogColumnsComponent.prototype, "attribution", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogColumnsComponent.prototype, "caption", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], BlogColumnsComponent.prototype, "includes", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogColumnsComponent.prototype, "leftSideId", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogColumnsComponent.prototype, "rightSideId", void 0);
BlogColumnsComponent = __decorate([ __metadata("design:paramtypes", [])
], BlogColumnsComponent);

let BlogVideoComponent = class BlogVideoComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    ngOnInit() {
        // https://developers.google.com/youtube/iframe_api_reference
        if (typeof this.url === 'string') {
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.url + '?rel=0');
        }
    }
};
BlogVideoComponent.ɵfac = function BlogVideoComponent_Factory(t) { return new (t || BlogVideoComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
BlogVideoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlogVideoComponent, selectors: [["emerson-blog-video"]], inputs: { url: "url" }, decls: 4, vars: 1, consts: [[1, "my-3", "mx-0"], [1, "blog-video"], [1, "embed-responsive", "embed-responsive-16by9"], ["allowfullscreen", "", 1, "embed-responsive-item", 3, "src"]], template: function BlogVideoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "iframe", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("src", ctx.url, ɵngcc0.ɵɵsanitizeResourceUrl);
    } }, styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], BlogVideoComponent.prototype, "url", void 0);
BlogVideoComponent = __decorate([ __metadata("design:paramtypes", [DomSanitizer])
], BlogVideoComponent);

let StaticcontentComponent = class StaticcontentComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    ngOnInit() {
        this.content = this.sanitizer.sanitize(SecurityContext.HTML, this.content);
    }
};
StaticcontentComponent.ɵfac = function StaticcontentComponent_Factory(t) { return new (t || StaticcontentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
StaticcontentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StaticcontentComponent, selectors: [["emerson-staticcontent"]], inputs: { content: "content" }, decls: 1, vars: 1, consts: [[3, "innerHtml"]], template: function StaticcontentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("innerHtml", ctx.content, ɵngcc0.ɵɵsanitizeHtml);
    } }, styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], StaticcontentComponent.prototype, "content", void 0);
StaticcontentComponent = __decorate([ __metadata("design:paramtypes", [DomSanitizer])
], StaticcontentComponent);

let CategorycardComponent = class CategorycardComponent {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.header = 'Hello World!';
        this.categoryName = 'None';
        this.categoryLink = 'Link';
        this.pubDate = '';
        this.lead = 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquam aliquid excepturi similique.';
        this.detailedContent = 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. A accusantium at fugiat harum ' +
            'nobis quasi qui saepe vel vitae voluptas, voluptates?';
        this.ctaButtonUrl = '#';
        this.ctaButtonText = "Learn More";
    }
    ngOnInit() {
        // this.ctaButtonUrl = this.sanitizer.bypassSecurityTrustUrl(this.ctaButtonUrl);
    }
};
CategorycardComponent.ɵfac = function CategorycardComponent_Factory(t) { return new (t || CategorycardComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.DomSanitizer)); };
CategorycardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CategorycardComponent, selectors: [["emerson-categorycard"]], inputs: { header: "header", categoryName: "categoryName", categoryLink: "categoryLink", pubDate: "pubDate", lead: "lead", detailedContent: "detailedContent", ctaButtonUrl: "ctaButtonUrl", ctaButtonText: "ctaButtonText", imgUrl: "imgUrl", routerPath: "routerPath", routerData: "routerData" }, decls: 16, vars: 9, consts: [[1, "jumbotron", "ee-jumbotron", "card-container", "w-100", "p-0", "mx-auto"], [1, "pb-3"], [1, "col-lg", "p-0"], [3, "routerLink", "state", 4, "ngIf"], ["class", "href image-fill", 3, "href", 4, "ngIf"], [1, "col-lg"], [1, "p-1"], [1, "category-type"], [1, "categoryLink", 3, "href"], [1, "mt-2"], ["class", "href-title", 3, "routerLink", "state", 4, "ngIf"], ["class", "href-title", 3, "href", 4, "ngIf"], [1, "text-content", "truncate-overflow", "overflow-hidden", 3, "innerHTML"], ["class", "href href-cta", 3, "routerLink", "state", 4, "ngIf"], ["class", "href href-cta", 3, "href", 4, "ngIf"], [3, "routerLink", "state"], [1, "img-fluid", "image-fill", 3, "src", "alt"], [1, "href", "image-fill", 3, "href"], [1, "img-fluid", 3, "src", "alt"], [1, "href-title", 3, "routerLink", "state"], [1, "href-title", 3, "href"], [1, "href", "href-cta", 3, "routerLink", "state"], [1, "href", "href-cta", 3, "href"]], template: function CategorycardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, CategorycardComponent_a_3_Template, 2, 4, "a", 3);
        ɵngcc0.ɵɵtemplate(4, CategorycardComponent_a_4_Template, 2, 3, "a", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementStart(7, "p", 7);
        ɵngcc0.ɵɵelementStart(8, "a", 8);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "h2", 9);
        ɵngcc0.ɵɵtemplate(11, CategorycardComponent_a_11_Template, 2, 3, "a", 10);
        ɵngcc0.ɵɵtemplate(12, CategorycardComponent_a_12_Template, 2, 2, "a", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(13, "div", 12);
        ɵngcc0.ɵɵtemplate(14, CategorycardComponent_a_14_Template, 2, 3, "a", 13);
        ɵngcc0.ɵɵtemplate(15, CategorycardComponent_a_15_Template, 2, 2, "a", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.routerPath);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.routerPath);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵpropertyInterpolate1("href", "category/", ctx.categoryLink, "", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.categoryName);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.routerPath);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.routerPath);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.detailedContent, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.routerPath);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.routerPath);
    } }, directives: [ɵngcc2.NgIf, ɵngcc4.RouterLinkWithHref], styles: [".image-fill[_ngcontent-%COMP%]{-o-object-fit:cover;object-fit:cover;-o-object-position:top;object-position:top;min-width:100%;height:100%}.category-type[_ngcontent-%COMP%]{margin-top:1rem}.category-type[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#666;font-size:13px;line-height:18px;font-weight:700;text-decoration:none}.category-type[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:underline}.card-container[_ngcontent-%COMP%]{border-radius:0;background-color:#fff;border:2px solid #ccc}.truncate-overflow[_ngcontent-%COMP%]{--max-lines:6;--lh:1.5rem;max-height:calc(var(--lh) * var(--max-lines))}.truncate-overflow[_ngcontent-%COMP%]::before{position:absolute;content:\"...\";bottom:2rem;right:1rem}.truncate-overflow[_ngcontent-%COMP%]::after{content:\"\";position:absolute;right:0;width:1rem;height:1rem;background:#fff}.column[_ngcontent-%COMP%]{padding-bottom:1rem}.href-title[_ngcontent-%COMP%]{color:#000;font-size:24px;text-decoration:none;line-height:1.2;display:inline-block}.href-title[_ngcontent-%COMP%]:hover{text-decoration:underline}.href-cta[_ngcontent-%COMP%]{margin-top:1rem!important;display:inline-block}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], CategorycardComponent.prototype, "header", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], CategorycardComponent.prototype, "categoryName", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], CategorycardComponent.prototype, "categoryLink", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], CategorycardComponent.prototype, "pubDate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], CategorycardComponent.prototype, "lead", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], CategorycardComponent.prototype, "detailedContent", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], CategorycardComponent.prototype, "ctaButtonUrl", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], CategorycardComponent.prototype, "ctaButtonText", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], CategorycardComponent.prototype, "imgUrl", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], CategorycardComponent.prototype, "routerPath", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], CategorycardComponent.prototype, "routerData", void 0);
CategorycardComponent = __decorate([ __metadata("design:paramtypes", [DomSanitizer])
], CategorycardComponent);

let BlogAuthorComponent = class BlogAuthorComponent {
    constructor(contentfulService) {
        this.contentfulService = contentfulService;
    }
    ngOnInit() {
        this.contentfulService.getEntriesByContentType('author', {
            'fields.urlSlug': this.urlSlug,
            include: 2
        })
            .then((response) => {
            this.blogAuthor = response.items[0];
        });
    }
};
BlogAuthorComponent.ɵfac = function BlogAuthorComponent_Factory(t) { return new (t || BlogAuthorComponent)(ɵngcc0.ɵɵdirectiveInject(IContentService)); };
BlogAuthorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BlogAuthorComponent, selectors: [["emerson-blog-author"]], inputs: { urlSlug: "urlSlug" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: IContentService, useClass: ContentfulService }])], decls: 1, vars: 1, consts: [[4, "ngIf"], [2, "text-align", "center"], ["alt", "", 3, "src"], [4, "ngFor", "ngForOf"], [3, "href", 4, "ngIf"], [3, "href"]], template: function BlogAuthorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BlogAuthorComponent_div_0_Template, 8, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.blogAuthor);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", String)
], BlogAuthorComponent.prototype, "urlSlug", void 0);
BlogAuthorComponent = __decorate([ __metadata("design:paramtypes", [IContentService])
], BlogAuthorComponent);

let NothingHereComponent = class NothingHereComponent {
    constructor() {
        this.title = 'Nothing here chap!';
        this.message = 'Now go away before I taunt you a second time!';
        this.buttonText = 'Go away!';
        this.imageUrl = '';
        this.routerPath = '/';
    }
    ngOnInit() {
    }
};
NothingHereComponent.ɵfac = function NothingHereComponent_Factory(t) { return new (t || NothingHereComponent)(); };
NothingHereComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NothingHereComponent, selectors: [["emerson-nothing-here"]], inputs: { title: "title", message: "message", buttonText: "buttonText", imageUrl: "imageUrl", routerPath: "routerPath", routerData: "routerData" }, decls: 9, vars: 6, consts: [[1, "card", "nothing-burger", "w-100"], ["class", "card-img-top", "alt", "Card image cap", 3, "src", 4, "ngIf"], [1, "card-body"], [1, "card-title"], [1, "card-text"], [1, "btn", "btn-primary", 3, "routerLink", "state"], ["alt", "Card image cap", 1, "card-img-top", 3, "src"]], template: function NothingHereComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NothingHereComponent_img_1_Template, 1, 1, "img", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "h5", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "p", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "a", 5);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.imageUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.message);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("routerLink", ctx.routerPath)("state", ctx.routerData);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.buttonText);
    } }, directives: [ɵngcc2.NgIf, ɵngcc4.RouterLinkWithHref], styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], NothingHereComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NothingHereComponent.prototype, "message", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NothingHereComponent.prototype, "buttonText", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NothingHereComponent.prototype, "imageUrl", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NothingHereComponent.prototype, "routerPath", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NothingHereComponent.prototype, "routerData", void 0);
NothingHereComponent = __decorate([ __metadata("design:paramtypes", [])
], NothingHereComponent);

let PromotionContentComponent = class PromotionContentComponent {
    constructor() {
    }
    ngOnInit() {
        const promotionEntryObject = JSON.parse(this.promotionEntry);
        this.promotionTitle = promotionEntryObject.title;
        this.promotionLink = promotionEntryObject.promotionLink;
        this.promotionImage = promotionEntryObject.promotionImage.fields.file.url;
    }
};
PromotionContentComponent.ɵfac = function PromotionContentComponent_Factory(t) { return new (t || PromotionContentComponent)(); };
PromotionContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PromotionContentComponent, selectors: [["emerson-promotion-content"]], inputs: { promotionEntry: "promotionEntry" }, decls: 3, vars: 3, consts: [[1, "promotion-content", "mb-3"], ["target", "_blank", 3, "href"], [1, "promo-container", "img-fluid", "w-100", 3, "src", "alt"]], template: function PromotionContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "a", 1);
        ɵngcc0.ɵɵelement(2, "img", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("href", ctx.promotionLink, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.promotionImage, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵpropertyInterpolate("alt", ctx.promotionTitle);
    } }, styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], PromotionContentComponent.prototype, "promotionEntry", void 0);
PromotionContentComponent = __decorate([ __metadata("design:paramtypes", [])
], PromotionContentComponent);

let GoogleAnalyticsComponent = class GoogleAnalyticsComponent {
    constructor(pRenderer2, pDocument) {
        this.pRenderer2 = pRenderer2;
        this.pDocument = pDocument;
        this.sendPageView = false;
    }
    ngOnInit() {
        const script = this.pRenderer2.createElement('script');
        script.text = ' \
    (function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){ \
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o), \
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m) \
    })(window,document,\'script\',\'https://www.google-analytics.com/analytics.js\',\'ga\'); \
    ga(\'create\', \'' + this.gaAccountId + '\', \'auto\'); \
    ';
        if (this.sendPageView) {
            script.text = script.text + 'ga(\'send\', \'pageview\');';
        }
        this.pRenderer2.appendChild(this.pDocument.body, script);
    }
};
GoogleAnalyticsComponent.ɵfac = function GoogleAnalyticsComponent_Factory(t) { return new (t || GoogleAnalyticsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
GoogleAnalyticsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: GoogleAnalyticsComponent, selectors: [["emerson-google-analytics"]], inputs: { sendPageView: "sendPageView", gaAccountId: "gaAccountId" }, decls: 0, vars: 0, template: function GoogleAnalyticsComponent_Template(rf, ctx) { }, styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", String)
], GoogleAnalyticsComponent.prototype, "gaAccountId", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], GoogleAnalyticsComponent.prototype, "sendPageView", void 0);
GoogleAnalyticsComponent = __decorate([ __param(1, Inject(DOCUMENT)),
    __metadata("design:paramtypes", [Renderer2, Object])
], GoogleAnalyticsComponent);

let GoogleTagManagerComponent = class GoogleTagManagerComponent {
    constructor(pRenderer2, pDocument) {
        this.pRenderer2 = pRenderer2;
        this.pDocument = pDocument;
    }
    ngOnInit() {
        const script = this.pRenderer2.createElement('script');
        script.text = ' \
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\
        new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\
      j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\
      \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\
    })(window,document,\'script\',\'dataLayer\',\'' + this.gtmAccountId + '\');\
    ';
        this.pRenderer2.appendChild(this.pDocument.body, script);
    }
};
GoogleTagManagerComponent.ɵfac = function GoogleTagManagerComponent_Factory(t) { return new (t || GoogleTagManagerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
GoogleTagManagerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: GoogleTagManagerComponent, selectors: [["emerson-google-tag-manager"]], inputs: { gtmAccountId: "gtmAccountId" }, decls: 0, vars: 0, template: function GoogleTagManagerComponent_Template(rf, ctx) { }, styles: [""] });
__decorate([
    Input(),
    __metadata("design:type", String)
], GoogleTagManagerComponent.prototype, "gtmAccountId", void 0);
GoogleTagManagerComponent = __decorate([ __param(1, Inject(DOCUMENT)),
    __metadata("design:paramtypes", [Renderer2, Object])
], GoogleTagManagerComponent);

class Constants {
}
Constants.DEFAULT_APP_NAME = 'DEFAULT_APP_NAME';
Constants.DEFAULT_INSTANCE_ID = 'DEFAULT_INSTANCE_ID';
Constants.DEFAULT_SDK_VERSION = 'DEFAULT_SDK_VERSION';
Constants.DEFAULT_STRATEGIES = [];
Constants.DEFAULT_INTERVAL = 15000;
Constants.DEFAULT_REGISTER_ENDPOINT = '/register';
Constants.DEFAULT_FEATURES_ENDPOINT = '/features';
Constants.DEFAULT_METRICS_ENDPOINT = '/metrics';

class IStrategyComputeProvider {
    isEnabled(feature, context) {
        throw new Error('Method not implemented!');
    }
}

let UnleashService = class UnleashService {
    constructor(http) {
        this.http = http;
        this.featuresSource$ = new Subject();
        this.errorSource$ = new Subject();
        this.features$ = this.featuresSource$.asObservable();
        this.error$ = this.errorSource$.asObservable();
    }
    getFeatures(featuresPollUrl) {
        this.http.get(featuresPollUrl).subscribe((data) => {
            this.featuresSource$.next(data);
        });
    }
    registerClient(config) {
        if (!config.baseurl || !config.registerEndpoint) {
            return;
        }
        const sub = this.http.post(`${config.baseurl}${config.registerEndpoint}`, {
            appName: config.appName || Constants.DEFAULT_APP_NAME,
            instanceId: config.instanceId || Constants.DEFAULT_INSTANCE_ID,
            sdkVersion: config.sdkVersion || Constants.DEFAULT_SDK_VERSION,
            strategies: config.strategies || Constants.DEFAULT_STRATEGIES,
            started: new Date().toISOString(),
            interval: config.interval || Constants.DEFAULT_INTERVAL,
        }).pipe(catchError((error) => {
            this.errorSource$.next(error);
            return null;
        }))
            .subscribe(() => {
            sub.unsubscribe();
        });
    }
    reportMetrics(metricReportUrl, metrics) {
        return new Promise((resolve, reject) => {
            if (!metrics || !metrics.bucket || !metrics.bucket.start || !metrics.bucket.stop) {
                return;
            }
            const reportMetricsSub = this.http.post(metricReportUrl, Object.assign({}, metrics, { bucket: Object.assign({}, metrics.bucket, { start: metrics.bucket.start.toISOString(), stop: metrics.bucket.stop.toISOString() }) })).pipe(catchError((error) => {
                this.errorSource$.next(error);
                return null;
            })).subscribe(() => {
                reportMetricsSub.unsubscribe();
                resolve();
            });
        });
    }
};
UnleashService.ɵfac = function UnleashService_Factory(t) { return new (t || UnleashService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
UnleashService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: UnleashService, factory: function (t) { return UnleashService.ɵfac(t); }, providedIn: 'root' });
UnleashService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UnleashService_Factory() { return new UnleashService(ɵɵinject(HttpClient)); }, token: UnleashService, providedIn: "root" });
UnleashService = __decorate([ __metadata("design:paramtypes", [HttpClient])
], UnleashService);

var version = "1.0.0";
var packageJson = {
	version: version
};

let FeatureService = class FeatureService {
    constructor(unleashService, configService, strategyProvider) {
        this.unleashService = unleashService;
        this.configService = configService;
        this.strategyProvider = strategyProvider;
        this.privateContext = {};
        this.subscriptions = [];
        this.currentFeatureToggles = new Map();
        this.isFeatureFetched = false;
        this.checkFeatureEnabled = (featureToggle) => {
            const featureEnabled = this.strategyProvider.isEnabled(featureToggle, this.privateContext || {});
            this.recordMetric(featureToggle.name, featureEnabled);
            return featureEnabled;
        };
        let configFromFile;
        if (this.configService.configurations) {
            configFromFile = this.configService.configurations.unleash;
        }
        this.providerImplementedStrategies = [...this.strategyProvider.implementedStrategies.keys()];
        this.privateConfig = {
            baseurl: '',
            featurePollEndpoint: Constants.DEFAULT_FEATURES_ENDPOINT,
            metricReportEndpoint: Constants.DEFAULT_METRICS_ENDPOINT,
            registerEndpoint: Constants.DEFAULT_REGISTER_ENDPOINT,
            sdkVersion: `trove:${packageJson.version}`,
            interval: Constants.DEFAULT_INTERVAL,
            appName: Constants.DEFAULT_APP_NAME,
            instanceId: Constants.DEFAULT_INSTANCE_ID,
            strategies: this.providerImplementedStrategies.length ?
                this.providerImplementedStrategies : Constants.DEFAULT_STRATEGIES,
        };
        this.featureMetrics = {
            appName: this.privateConfig.appName,
            instanceId: this.privateConfig.instanceId,
            bucket: {
                start: null,
                stop: null,
                toggles: {}
            }
        };
        if (configFromFile) {
            this.privateConfig = Object.assign({}, this.privateConfig, configFromFile);
        }
        this.featureToggles$ = this.unleashService.features$
            .pipe(map((featuresResponse) => {
            const returnMap = new Map();
            featuresResponse.features.forEach((feature) => {
                returnMap.set(feature.name, feature);
            });
            this.currentFeatureToggles = returnMap;
            this.isFeatureFetched = true;
            return returnMap;
        }));
        this.subscriptions.push(this.unleashService.error$.subscribe((error) => {
            console.error('Unleash: HttpErrorResponse. Disconnecting service to prevent request spam', error);
            this.disconnectUnleash();
        }));
        this.lastMetricStartTime = new Date();
    }
    get context() {
        return this.privateContext;
    }
    set context(value) {
        if (value) {
            this.privateContext = value;
            if (this.featurePollIntervalId) {
                this.disconnectUnleash();
                this.connectUnleash();
            }
        }
    }
    set config(value) {
        if (!value) {
            return;
        }
        this.privateConfig = Object.assign({}, this.privateContext, value);
        if (this.privateConfig.strategies.length === 0) {
            this.privateConfig.strategies = [...this.providerImplementedStrategies];
        }
    }
    connectUnleash(config, featurePollMethod, metricReportMethod) {
        this.privateConfig = Object.assign({}, this.privateConfig, config);
        this.configValid = this.configValidForConnection();
        if (!this.configValid) {
            console.warn('FeatureService: Config not valid, can\'t connect');
        }
        if (this.featurePollIntervalId) {
            this.disconnectUnleash();
        }
        if (!featurePollMethod) {
            featurePollMethod = () => {
                this.unleashService.getFeatures(`${this.privateConfig.baseurl}${this.privateConfig.featurePollEndpoint}`);
            };
        }
        if (!metricReportMethod) {
            metricReportMethod = () => {
                this.reportMetrics();
            };
        }
        if (this.configValid) {
            this.unleashService.registerClient(this.privateConfig);
            featurePollMethod();
            this.featurePollIntervalId = window.setInterval(featurePollMethod, this.privateConfig.interval || Constants.DEFAULT_INTERVAL, true);
            metricReportMethod();
            this.metricReportIntervalId = window.setInterval(metricReportMethod, this.privateConfig.interval || Constants.DEFAULT_INTERVAL, true);
            return true;
        }
        return false;
    }
    disconnectUnleash() {
        if (this.featurePollIntervalId) {
            clearInterval(this.featurePollIntervalId);
            this.featurePollIntervalId = null;
        }
        if (this.metricReportIntervalId) {
            clearInterval(this.metricReportIntervalId);
            this.metricReportIntervalId = null;
        }
    }
    configValidForConnection(config = this.privateConfig) {
        if (config.baseurl && config.featurePollEndpoint && config.interval && config.interval > 999) {
            return true;
        }
        return false;
    }
    appendClientContext(context) {
        this.privateContext = Object.assign({}, this.privateContext, context);
    }
    isEnabled(featureToggle) {
        if (!featureToggle || !this.currentFeatureToggles.get(featureToggle.name)) {
            return false;
        }
        return this.checkFeatureEnabled(featureToggle);
    }
    isEnabledViaName(featureName) {
        if (!this.isFeatureFetched) {
            return this.isEnabledObserveViaName(featureName);
        }
        else {
            const featureToggle = this.currentFeatureToggles.get(featureName);
            if (!featureToggle) {
                return of(false);
            }
            return of(this.checkFeatureEnabled(featureToggle));
        }
    }
    isEnabledObserveViaName(featureName) {
        if (!this.featurePollIntervalId) {
            return of(false);
        }
        return this.featureToggles$.pipe(map((allFeaturesMap) => {
            return Array.from(allFeaturesMap.values());
        }), map((featureToggleArray) => {
            return featureToggleArray.find((featureToggleToFindOn) => featureToggleToFindOn.name === featureName);
        }), map((featureToggleToCheck) => {
            if (!featureToggleToCheck) {
                return false;
            }
            return this.isEnabled(featureToggleToCheck);
        }));
    }
    recordMetric(featureName, isEnabled) {
        if (!this.featureMetrics) {
            this.featureMetrics = {
                appName: this.privateConfig.appName,
                instanceId: this.privateConfig.instanceId,
                bucket: {
                    start: null,
                    stop: null,
                    toggles: {}
                }
            };
        }
        let originalYesValue = 0;
        let originalNoValue = 0;
        if (this.featureMetrics.bucket.toggles[featureName]) {
            originalNoValue = this.featureMetrics.bucket.toggles[featureName].no;
            originalYesValue = this.featureMetrics.bucket.toggles[featureName].yes;
        }
        this.featureMetrics.bucket.toggles = Object.assign({}, this.featureMetrics.bucket.toggles, { [featureName]: {
                yes: isEnabled ? originalYesValue + 1 : originalYesValue,
                no: !isEnabled ? originalNoValue + 1 : originalNoValue,
            } });
    }
    reportMetrics() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.featureMetrics || !this.featureMetrics.bucket) {
                return;
            }
            this.featureMetrics = Object.assign({}, this.featureMetrics, { bucket: Object.assign({}, this.featureMetrics.bucket, { start: this.lastMetricStartTime, stop: new Date() }) });
            this.unleashService
                .reportMetrics(`${this.privateConfig.baseurl}${this.privateConfig.metricReportEndpoint}`, Object.assign({}, this.featureMetrics, { bucket: Object.assign({}, this.featureMetrics.bucket) }));
            this.lastMetricStartTime = new Date();
            this.featureMetrics.bucket.toggles = {};
        });
    }
    ngOnDestroy() {
        this.disconnectUnleash();
        for (const sub of this.subscriptions) {
            sub.unsubscribe();
        }
    }
};
FeatureService.ɵfac = function FeatureService_Factory(t) { return new (t || FeatureService)(ɵngcc0.ɵɵinject(UnleashService), ɵngcc0.ɵɵinject(ConfigurationService), ɵngcc0.ɵɵinject(IStrategyComputeProvider)); };
FeatureService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: FeatureService, factory: function (t) { return FeatureService.ɵfac(t); }, providedIn: 'root' });
FeatureService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FeatureService_Factory() { return new FeatureService(ɵɵinject(UnleashService), ɵɵinject(ConfigurationService), ɵɵinject(IStrategyComputeProvider)); }, token: FeatureService, providedIn: "root" });
FeatureService = __decorate([ __metadata("design:paramtypes", [UnleashService,
        ConfigurationService,
        IStrategyComputeProvider])
], FeatureService);

let AccountMergePasswordSetSuccessComponent = class AccountMergePasswordSetSuccessComponent {
    constructor(contentfulService) {
        this.contentfulService = contentfulService;
        this.title = 'default title';
        this.body = 'default AccountMergePasswordSetSuccessComponent body';
        this.titleFetched = false;
        this.bodyFetched = false;
        this.application = '';
        this.okButtonClicked = new EventEmitter();
        this.exitButtonClicked = new EventEmitter();
    }
    ngOnInit() {
        if (this.application) {
            this.contentfulService.getEntriesByContentType('uiCopy', {
                'fields.key': `${this.application}-account-merge-password-set-success-body`,
                limit: 1,
                order: 'sys.updatedAt',
            }).then((bodyData) => {
                if (bodyData.total < 1 || !bodyData.items) {
                    return;
                }
                this.body = this.contentfulService.convertRichTextToHtml(bodyData.items[0].fields.value.content);
                this.bodyFetched = true;
                if (this.replacements) {
                    for (const [keyword, value] of this.replacements) {
                        this.body = this.body.replace(keyword, value);
                    }
                }
            });
            this.contentfulService.getEntriesByContentType('uiCopy', {
                'fields.key': `${this.application}-account-merge-password-set-success-title`,
                limit: 1,
                order: 'sys.updatedAt',
            }).then((titleData) => {
                if (titleData.total < 1 || !titleData.items) {
                    return;
                }
                this.title = titleData.items[0].fields.value.content[0].content[0].value;
                this.titleFetched = true;
                if (this.replacements) {
                    for (const [keyword, value] of this.replacements) {
                        this.title = this.title.replace(keyword, value);
                    }
                }
            });
        }
    }
};
AccountMergePasswordSetSuccessComponent.ɵfac = function AccountMergePasswordSetSuccessComponent_Factory(t) { return new (t || AccountMergePasswordSetSuccessComponent)(ɵngcc0.ɵɵdirectiveInject(IContentService)); };
AccountMergePasswordSetSuccessComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AccountMergePasswordSetSuccessComponent, selectors: [["emerson-account-merge-password-set-success"]], inputs: { application: "application", replacements: "replacements" }, outputs: { okButtonClicked: "okButtonClicked", exitButtonClicked: "exitButtonClicked" }, decls: 1, vars: 1, consts: [["class", "component container-fluid", 4, "ngIf"], [1, "component", "container-fluid"], [1, "row", "d-flex", "justify-content-between", "header", "align-middle"], [1, "d-flex"], [1, "merge-password-set-success-title", "font-weight-bold", "my-2", "pl-3"], [1, "d-flex", "mr-2", 3, "click"], ["type", "button", "aria-label", "close popup", 1, "close"], ["aria-hidden", "true"], [1, "row", "d-flex", "pl-3", "py-3"], [1, "merge-password-set-success-body", 3, "innerHTML"], [1, "row", "d-flex", "justify-content-end", "p-2", "footer"], [1, "btn", "btn-primary", "px-3", 3, "click"]], template: function AccountMergePasswordSetSuccessComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AccountMergePasswordSetSuccessComponent_div_0_Template, 14, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.titleFetched && ctx.bodyFetched);
    } }, directives: [ɵngcc2.NgIf], styles: [".header[_ngcontent-%COMP%]{border-bottom:1px solid #eceff1;min-height:3rem}.header[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{font-size:2rem}.footer[_ngcontent-%COMP%]{border-top:1px solid #eceff1}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], AccountMergePasswordSetSuccessComponent.prototype, "application", void 0);
__decorate([
    Input(),
    __metadata("design:type", Map)
], AccountMergePasswordSetSuccessComponent.prototype, "replacements", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], AccountMergePasswordSetSuccessComponent.prototype, "okButtonClicked", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], AccountMergePasswordSetSuccessComponent.prototype, "exitButtonClicked", void 0);
AccountMergePasswordSetSuccessComponent = __decorate([ __metadata("design:paramtypes", [IContentService])
], AccountMergePasswordSetSuccessComponent);

let AccountMergePasswordSetComponent = class AccountMergePasswordSetComponent {
    constructor(contentfulService) {
        this.contentfulService = contentfulService;
        this.title = 'default title';
        this.body = 'default AccountMergePasswordSetSuccessComponent body';
        this.titleFetched = false;
        this.bodyFetched = false;
        this.passwordInputType = 'password';
        this.confirmPasswordInputType = 'password';
        this.application = '';
        this.usernameForAccessibility = '';
        this.submitEmitter = new EventEmitter();
    }
    ngOnInit() {
        const passwordValidators = [Validators.required];
        if (this.passwordPatternValidator && this.passwordPatternValidatorFailedMessage) {
            passwordValidators.push(this.passwordPatternValidator);
        }
        else {
            console.warn('WARN: AccountMergePasswordSetComponent: passwordPatternValidator or passwordPatternValidatorFailedMessage isn\'t set');
        }
        this.form = new FormGroup({
            password: new FormControl(this.passwordString, passwordValidators),
            confirmPassword: new FormControl(this.confirmPasswordString),
        }, this.pwdMatchValidator);
        if (this.application) {
            this.contentfulService.getEntriesByContentType('uiCopy', {
                'fields.key': `${this.application}-account-merge-password-set-body`,
                limit: 1,
                order: 'sys.updatedAt',
            }).then((bodyData) => {
                if (bodyData.total < 1 || !bodyData.items) {
                    return;
                }
                this.body = this.contentfulService.convertRichTextToHtml(bodyData.items[0].fields.value.content);
                this.bodyFetched = true;
                if (this.replacements) {
                    for (const [keyword, value] of this.replacements) {
                        this.body = this.body.replace(keyword, value);
                    }
                }
            });
            this.contentfulService.getEntriesByContentType('uiCopy', {
                'fields.key': `${this.application}-account-merge-password-set-title`,
                limit: 1,
                order: 'sys.updatedAt',
            }).then((titleData) => {
                if (titleData.total < 1 || !titleData.items) {
                    return;
                }
                this.title = titleData.items[0].fields.value.content[0].content[0].value;
                this.titleFetched = true;
                if (this.replacements) {
                    for (const [keyword, value] of this.replacements) {
                        this.title = this.title.replace(keyword, value);
                    }
                }
            });
        }
    }
    togglePasswordInputType() {
        if (this.passwordInputType === 'password') {
            this.passwordInputType = 'text';
        }
        else {
            this.passwordInputType = 'password';
        }
    }
    toggleConfirmPasswordInputType() {
        if (this.confirmPasswordInputType === 'password') {
            this.confirmPasswordInputType = 'text';
        }
        else {
            this.confirmPasswordInputType = 'password';
        }
    }
    onSubmit() {
        this.submitEmitter.emit(this.form.get('password').value);
    }
    pwdMatchValidator(frm) {
        const returnValue = frm.get('password').value === frm.get('confirmPassword').value ? null : { noMatch: true };
        frm.get('confirmPassword').setErrors(returnValue);
        return returnValue;
    }
    get password() { return this.form.get('password'); }
    get confirmPassword() { return this.form.get('confirmPassword'); }
};
AccountMergePasswordSetComponent.ɵfac = function AccountMergePasswordSetComponent_Factory(t) { return new (t || AccountMergePasswordSetComponent)(ɵngcc0.ɵɵdirectiveInject(IContentService)); };
AccountMergePasswordSetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AccountMergePasswordSetComponent, selectors: [["emerson-account-merge-password-set"]], inputs: { application: "application", usernameForAccessibility: "usernameForAccessibility", replacements: "replacements", passwordPatternValidator: "passwordPatternValidator", passwordPatternValidatorFailedMessage: "passwordPatternValidatorFailedMessage" }, outputs: { submitEmitter: "submitEmitter" }, decls: 35, vars: 26, consts: [[1, "container", "component"], [1, "row"], [3, "innerHTML"], [1, "row", "justify-content-center"], [1, "col", "col-md-8", "input-col", "px-0", 3, "formGroup", "ngSubmit"], [1, "row", "mx-1", "mt-1"], ["for", "basic-password", 1, "mb-0", 3, "ngClass"], [1, "d-none"], ["type", "text", "autocomplete", "username", "aria-label", "username", 1, "form-control", 3, "value"], [1, "col", "input-group", "input-group-sm", "p-0", "mx-3", "form-control", 3, "ngClass"], ["autocomplete", "new-password", "id", "basic-password", "aria-label", "new password", 1, "form-control-plaintext", "pl-2", "py-0", 3, "type", "formControl"], [1, "input-group-append"], ["type", "button", 1, "btn", 3, "click"], ["width", "22px", "height", "14px", "viewBox", "0 0 22 14", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "width", "20px", "height", "10px", "viewBox", "0 0 20 10", "version", "1.1", 4, "ngIf"], [1, "row", "mx-1", "mt-3"], ["for", "basic-password-confirm", 1, "mb-0", 3, "ngClass"], ["autocomplete", "new-password", "id", "basic-password-confirm", "aria-label", "new password", 1, "form-control-plaintext", "pl-2", "py-0", 3, "type", "formControl"], ["class", "row mt-1 mx-1 pl-4", 4, "ngIf"], [1, "row", "mt-4", "justify-content-center"], [1, "col", "text-center"], ["type", "submit", 1, "btn", "btn-primary", "btn-block", 3, "disabled"], ["width", "22px", "height", "14px", "viewBox", "0 0 22 14", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink"], ["id", "WV-First-Run", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["id", "EE/WV-Login-Screen-WV-Login", "transform", "translate(-831.000000, -393.000000)", "fill", "#6C757D", "fill-rule", "nonzero"], ["id", "Group-3", "transform", "translate(436.000000, 178.000000)"], ["id", "ico_eye_open", "transform", "translate(395.000000, 215.000000)"], ["d", "M11,0.25 C15.6985283,0.25 21.25,4.05503835 21.25,6.9375 C21.25,9.8199617 15.6985283,13.625 11,13.625 C6.30147173,13.625 0.75,9.8199617 0.75,6.9375 C0.75,4.05503835 6.30147173,0.25 11,0.25 Z M11,1.75 C7.0358394,1.75 2.25,5.0302657 2.25,6.9375 C2.25,8.8447343 7.0358394,12.125 11,12.125 C14.9641606,12.125 19.75,8.8447343 19.75,6.9375 C19.75,5.0302657 14.9641606,1.75 11,1.75 Z M11,2.625 C13.381728,2.625 15.3125,4.55577202 15.3125,6.9375 C15.3125,9.319228 13.381728,11.25 11,11.25 C8.61827202,11.25 6.6875,9.319228 6.6875,6.9375 C6.6875,4.55577202 8.61827202,2.625 11,2.625 Z M11,4.125 C9.4466991,4.125 8.1875,5.3841991 8.1875,6.9375 C8.1875,8.4908009 9.4466991,9.75 11,9.75 C12.5533009,9.75 13.8125,8.4908009 13.8125,6.9375 C13.8125,5.3841991 12.5533009,4.125 11,4.125 Z", "id", "Combined-Shape"], ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "width", "20px", "height", "10px", "viewBox", "0 0 20 10", "version", "1.1"], ["id", "EE/WV-Login-Screen-WV-Login-Show-PW", "transform", "translate(-832.000000, -397.000000)", "fill", "#6C757D", "fill-rule", "nonzero"], ["id", "ico_eye_closed", "transform", "translate(396.000000, 219.000000)"], ["d", "M9.9007162,7.2319741 C10.3585312,7.2319741 10.7296635,7.6031065 10.7296635,8.0609215 L10.7296635,9.1661847 C10.7296635,9.6239997 10.3585312,9.995132 9.9007162,9.995132 C9.4429012,9.995132 9.0717688,9.6239997 9.0717688,9.1661847 L9.0717688,8.0609215 C9.0717688,7.6031065 9.4429012,7.2319741 9.9007162,7.2319741 Z M5.95219128,6.70018363 C6.38239665,6.85676558 6.60421225,7.3324507 6.44763033,7.76265599 L6.06960805,8.80126366 C5.9130261,9.23146904 5.43734099,9.45328466 5.00713562,9.29670272 C4.57693025,9.14012077 4.35511465,8.66443564 4.5116966,8.23423026 L4.88971888,7.19562259 C5.0463008,6.76541731 5.52198591,6.54360168 5.95219128,6.70018363 Z M13.8492415,6.70018372 C14.2794469,6.54360176 14.755132,6.76541739 14.9117139,7.19562267 L14.9117139,7.19562267 L15.2897362,8.23423034 C15.4463181,8.66443572 15.2245025,9.14012085 14.7942971,9.2967028 C14.3640918,9.45328476 13.8884066,9.23146914 13.7318247,8.80126376 L13.7318247,8.80126376 L13.3538024,7.76265609 C13.1972205,7.3324508 13.4190361,6.85676567 13.8492415,6.70018372 Z M17.4417701,4.87724621 C17.8167902,4.61465431 18.3336768,4.70579543 18.5962686,5.08081552 L18.5962686,5.08081552 L19.2302215,5.98619405 C19.4928134,6.36121415 19.4016724,6.87810075 19.0266523,7.14069265 C18.6516322,7.40328454 18.1347456,7.31214348 17.8721537,6.93712339 L17.8721537,6.93712339 L17.2382008,6.03174486 C16.9756089,5.65672477 17.06675,5.1398381 17.4417701,4.87724621 Z M2.22665195,4.87724622 C2.60167203,5.13983811 2.69281307,5.65672476 2.43022118,6.03174485 L1.79626831,6.93712338 C1.53367641,7.31214347 1.01678977,7.40328456 0.641769685,7.14069266 C0.2667496,6.87810077 0.175608552,6.36121412 0.438200448,5.98619403 L1.07215332,5.0808155 C1.33474521,4.70579541 1.85163186,4.61465433 2.22665195,4.87724622 Z M0.47761541,0.3928102 C0.84022687,0.1925958 1.29648738,0.3242446 1.49670178,0.686856 C2.70099679,2.8679737 6.64124122,5.125 10,5.125 C13.3442219,5.125 17.2639874,2.8896385 18.4904069,0.7099828 C18.6935255,0.3489901 19.150828,0.2210078 19.5118207,0.4241264 C19.8728134,0.6272449 20.0007957,1.0845475 19.7976771,1.4455402 C18.3024429,4.1029471 13.8799564,6.625 10,6.625 C6.10236709,6.625 1.65553254,4.0777919 0.18356954,1.4118965 C-0.01664487,1.0492851 0.11500396,0.5930246 0.47761541,0.3928102 Z", "id", "Combined-Shape"], [1, "row", "mt-1", "mx-1", "pl-4"], [1, "p-0", "text-danger"], [4, "ngIf"]], template: function AccountMergePasswordSetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h4");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵelement(5, "span", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵelementStart(7, "form", 4);
        ɵngcc0.ɵɵlistener("ngSubmit", function AccountMergePasswordSetComponent_Template_form_ngSubmit_7_listener() { return ctx.onSubmit(); });
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "label", 6);
        ɵngcc0.ɵɵtext(10, " Password* ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵelement(12, "input", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 1);
        ɵngcc0.ɵɵelementStart(14, "div", 9);
        ɵngcc0.ɵɵelement(15, "input", 10);
        ɵngcc0.ɵɵelementStart(16, "div", 11);
        ɵngcc0.ɵɵelementStart(17, "button", 12);
        ɵngcc0.ɵɵlistener("click", function AccountMergePasswordSetComponent_Template_button_click_17_listener() { return ctx.togglePasswordInputType(); });
        ɵngcc0.ɵɵtemplate(18, AccountMergePasswordSetComponent__svg_svg_18_Template, 8, 0, "svg", 13);
        ɵngcc0.ɵɵtemplate(19, AccountMergePasswordSetComponent__svg_svg_19_Template, 8, 0, "svg", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 15);
        ɵngcc0.ɵɵelementStart(21, "label", 16);
        ɵngcc0.ɵɵtext(22, " Confirm Password* ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 1);
        ɵngcc0.ɵɵelementStart(24, "div", 9);
        ɵngcc0.ɵɵelement(25, "input", 17);
        ɵngcc0.ɵɵelementStart(26, "div", 11);
        ɵngcc0.ɵɵelementStart(27, "button", 12);
        ɵngcc0.ɵɵlistener("click", function AccountMergePasswordSetComponent_Template_button_click_27_listener() { return ctx.toggleConfirmPasswordInputType(); });
        ɵngcc0.ɵɵtemplate(28, AccountMergePasswordSetComponent__svg_svg_28_Template, 8, 0, "svg", 13);
        ɵngcc0.ɵɵtemplate(29, AccountMergePasswordSetComponent__svg_svg_29_Template, 8, 0, "svg", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(30, AccountMergePasswordSetComponent_div_30_Template, 5, 3, "div", 18);
        ɵngcc0.ɵɵelementStart(31, "div", 19);
        ɵngcc0.ɵɵelementStart(32, "div", 20);
        ɵngcc0.ɵɵelementStart(33, "button", 21);
        ɵngcc0.ɵɵtext(34, " Submit ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.body, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(18, _c4, ctx.password.invalid && (ctx.password.dirty || ctx.password.touched)));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("value", ctx.usernameForAccessibility);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(20, _c5, ctx.password.invalid && (ctx.password.dirty || ctx.password.touched)));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("type", ctx.passwordInputType)("formControl", ctx.password);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.passwordInputType === "password");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.passwordInputType === "text");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(22, _c4, ctx.confirmPassword.invalid && (ctx.confirmPassword.dirty || ctx.confirmPassword.touched)));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(24, _c5, ctx.confirmPassword.invalid && (ctx.confirmPassword.dirty || ctx.confirmPassword.touched)));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("type", ctx.confirmPasswordInputType)("formControl", ctx.confirmPassword);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.confirmPasswordInputType === "password");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.confirmPasswordInputType === "text");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.confirmPassword.invalid && (ctx.confirmPassword.dirty || ctx.confirmPassword.touched) || ctx.password.invalid && (ctx.password.dirty || ctx.password.touched));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", !ctx.form.valid);
    } }, directives: [ɵngcc1.ɵangular_packages_forms_forms_y, ɵngcc1.NgControlStatusGroup, ɵngcc1.FormGroupDirective, ɵngcc2.NgClass, ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.FormControlDirective, ɵngcc2.NgIf], styles: [".component[_ngcontent-%COMP%]{max-width:55vw;min-width:5vw}.form-control-plaintext[_ngcontent-%COMP%]{outline:0}"] });
__decorate([
    Input(),
    __metadata("design:type", Object)
], AccountMergePasswordSetComponent.prototype, "application", void 0);
__decorate([
    Input(),
    __metadata("design:type", Map)
], AccountMergePasswordSetComponent.prototype, "replacements", void 0);
__decorate([
    Input(),
    __metadata("design:type", Function)
], AccountMergePasswordSetComponent.prototype, "passwordPatternValidator", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], AccountMergePasswordSetComponent.prototype, "usernameForAccessibility", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], AccountMergePasswordSetComponent.prototype, "passwordPatternValidatorFailedMessage", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], AccountMergePasswordSetComponent.prototype, "submitEmitter", void 0);
AccountMergePasswordSetComponent = __decorate([ __metadata("design:paramtypes", [IContentService])
], AccountMergePasswordSetComponent);

const defaultAuthConfig = {
    issuer: 'https://qa-akris-auth.emersonecologics.com/',
    // issuer: 'https://localhost:5001', // local testing
    clientId: 'wvsso',
    responseType: 'code',
    redirectUri: window.location.origin + '/index.html',
    scope: 'openid',
    postLogoutRedirectUri: window.location.origin + '/index.html',
    useSilentRefresh: true,
    silentRefreshRedirectUri: window.location.origin + '/assets/silent-refresh.html',
    sessionChecksEnabled: true,
};

let AuthService = class AuthService {
    constructor(configService, oauthService) {
        this.configService = configService;
        this.oauthService = oauthService;
    }
    configureWithFile() {
        const authConfigFromFile = this.configService.configurations && this.configService.configurations.auth ?
            this.configService.configurations.auth : defaultAuthConfig;
        const enableDebug = localStorage.getItem('enable-oauth-debug');
        if (enableDebug) {
            authConfigFromFile.showDebugInformation = enableDebug === 'true';
        }
        this.oauthService.configure(authConfigFromFile);
        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
        this.oauthService.loadDiscoveryDocumentAndTryLogin();
        if (authConfigFromFile.useSilentRefresh) {
            this.oauthService.setupAutomaticSilentRefresh();
        }
    }
    tryLogin() {
        return this.oauthService.tryLogin();
    }
    login() {
        this.oauthService.initLoginFlow();
    }
    logout(noRedirectToLogoutUrl) {
        this.oauthService.logOut(noRedirectToLogoutUrl);
    }
    refreshToken() {
        this.oauthService.refreshToken();
    }
    refresh() {
        this.oauthService.silentRefresh();
    }
    get accessToken() {
        const accessToken = this.oauthService.getAccessToken();
        if (this.oauthService.showDebugInformation) {
            try {
                const decoded = jwt_decode(accessToken);
                console.log(decoded);
            }
            catch (error) {
            }
        }
        return accessToken;
    }
    get idToken() {
        return this.oauthService.getIdToken();
    }
    get userProfile() {
        return this.oauthService.loadUserProfile();
    }
    get events() {
        return this.oauthService.events;
    }
};
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵngcc0.ɵɵinject(ConfigurationService), ɵngcc0.ɵɵinject(ɵngcc6.OAuthService)); };
AuthService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthService, factory: function (t) { return AuthService.ɵfac(t); }, providedIn: 'root' });
AuthService.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(ɵɵinject(ConfigurationService), ɵɵinject(OAuthService)); }, token: AuthService, providedIn: "root" });
AuthService = __decorate([ __metadata("design:paramtypes", [ConfigurationService, OAuthService])
], AuthService);

var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus[NotificationStatus["New"] = 0] = "New";
    NotificationStatus[NotificationStatus["Read"] = 1] = "Read";
})(NotificationStatus || (NotificationStatus = {}));
class NotificationItem {
    executeAction() {
        this.action(this);
    }
    equals(item) {
        return this.header === item.header && this.body === item.body;
    }
}

let NotificationBellService = class NotificationBellService {
    constructor() {
        this.items = [];
        this.notificationListChange = new Subject();
        this.notificationListChange.subscribe((value) => {
            this.items = value;
        });
    }
    add(item) {
        if (!this.isNotificationOnList(item)) {
            this.items.push(item);
            this.notificationListChange.next(this.items);
        }
    }
    get(item) {
        const res = this.items.filter(nItem => nItem.equals(item));
        if (res.length > 0) {
            return res[0];
        }
        return null;
    }
    getAll() {
        return this.notificationListChange.asObservable();
    }
    remove(item) {
        this.items = this.items.filter(nItem => !nItem.equals(item));
        this.notificationListChange.next(this.items);
    }
    removeAll() {
        this.items = [];
        this.notificationListChange.next(this.items);
    }
    markAsRead(item) {
        const index = this.items.indexOf(item);
        if (index >= 0) {
            item.status = NotificationStatus.Read;
            this.items[index] = item;
            this.notificationListChange.next(this.items);
        }
    }
    isNotificationOnList(item) {
        return this.items.filter(nItem => nItem.equals(item)).length > 0;
    }
    syncNotifications() {
        this.notificationListChange.next(this.items);
    }
};
NotificationBellService.ɵfac = function NotificationBellService_Factory(t) { return new (t || NotificationBellService)(); };
NotificationBellService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NotificationBellService, factory: function (t) { return NotificationBellService.ɵfac(t); } });
NotificationBellService = __decorate([ __metadata("design:paramtypes", [])
], NotificationBellService);

let AuthComponent = class AuthComponent {
    constructor(authService) {
        this.authService = authService;
    }
    ngOnInit() {
        this.authService.configureWithFile();
    }
    login() {
        this.authService.login();
    }
    logout() {
        this.authService.logout();
    }
    refresh() {
        this.authService.refresh();
    }
    getUserProfile() {
        this.authService.userProfile.then((data) => {
            this.userProfile = JSON.stringify(data);
        });
    }
    get accessToken() {
        return this.authService.accessToken;
    }
};
AuthComponent.ɵfac = function AuthComponent_Factory(t) { return new (t || AuthComponent)(ɵngcc0.ɵɵdirectiveInject(AuthService)); };
AuthComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AuthComponent, selectors: [["emerson-auth"]], decls: 9, vars: 6, consts: [[1, "mt-3", "mb-3"], ["class", "btn btn-success mr-1", 3, "click", 4, "ngIf"], ["class", "btn btn-secondary mr-1", 3, "click", 4, "ngIf"], ["class", "btn btn-warning mr-1", 3, "click", 4, "ngIf"], ["class", "btn btn-info mr-1", 3, "click", 4, "ngIf"], ["class", "text-break mt-3 mb-3", 4, "ngIf"], [1, "btn", "btn-success", "mr-1", 3, "click"], [1, "btn", "btn-secondary", "mr-1", 3, "click"], [1, "btn", "btn-warning", "mr-1", 3, "click"], [1, "btn", "btn-info", "mr-1", 3, "click"], [1, "text-break", "mt-3", "mb-3"]], template: function AuthComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h3");
        ɵngcc0.ɵɵtext(1, "Authentication");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵtemplate(3, AuthComponent_button_3_Template, 2, 0, "button", 1);
        ɵngcc0.ɵɵtemplate(4, AuthComponent_button_4_Template, 2, 0, "button", 2);
        ɵngcc0.ɵɵtemplate(5, AuthComponent_button_5_Template, 2, 0, "button", 3);
        ɵngcc0.ɵɵtemplate(6, AuthComponent_button_6_Template, 2, 0, "button", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, AuthComponent_div_7_Template, 3, 1, "div", 5);
        ɵngcc0.ɵɵtemplate(8, AuthComponent_div_8_Template, 3, 1, "div", 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.accessToken);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.accessToken);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.accessToken);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.accessToken);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.accessToken);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.userProfile);
    } }, directives: [ɵngcc2.NgIf], styles: [""] });
AuthComponent = __decorate([ __metadata("design:paramtypes", [AuthService])
], AuthComponent);

let NotificationBellComponent = class NotificationBellComponent {
    constructor(notificationBellService) {
        this.notificationBellService = notificationBellService;
        this.notificationListItems = [];
        this.showNotificationList = false;
        this.appPrefix = 'wv';
    }
    ngOnInit() {
        this.appPrefix = this.targetApp ? this.targetApp : 'default';
        this.notificationItemSubscription = this.notificationBellService.getAll().subscribe(notificationList => {
            this.notificationListItems = notificationList;
        });
    }
    ngOnDestroy() {
        this.notificationItemSubscription.unsubscribe();
    }
    openNotification(state) {
        this.showNotificationList = state;
    }
    ngAfterContentChecked() {
        this.notificationBellService.syncNotifications();
    }
};
NotificationBellComponent.ɵfac = function NotificationBellComponent_Factory(t) { return new (t || NotificationBellComponent)(ɵngcc0.ɵɵdirectiveInject(NotificationBellService)); };
NotificationBellComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NotificationBellComponent, selectors: [["emerson-notification-bell"]], inputs: { targetApp: "targetApp" }, decls: 9, vars: 7, consts: [["popTitle", ""], ["popContent", ""], [2, "position", "relative"], ["type", "button", "placement", "bottom", "popoverClass", "notification-bell-popover", 1, "btn", "btn-outline-none", 3, "ngbPopover", "popoverTitle"], ["notifyPop", "ngbPopover"], [2, "font-size", "20px", "float", "left"], ["class", "notification-bell-badge notification-bell-badge-danger", 3, "click", 4, "ngIf"], [1, "container"], [4, "ngIf"], ["class", "row", 4, "ngFor", "ngForOf"], [1, "row"], [3, "notificationItem"], [2, "text-align", "center", "font-weight", "bold"], [1, "notification-bell-badge", "notification-bell-badge-danger", 3, "click"]], template: function NotificationBellComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NotificationBellComponent_ng_template_0_Template, 1, 1, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, NotificationBellComponent_ng_template_2_Template, 3, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(4, "span", 2);
        ɵngcc0.ɵɵelementStart(5, "button", 3, 4);
        ɵngcc0.ɵɵelement(7, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, NotificationBellComponent_span_8_Template, 2, 1, "span", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        const _r2 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngbPopover", _r2)("popoverTitle", _r0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate2("fa fa-bell", ctx.targetApp === "wv" ? "-o" : "", " notification-bell-", ctx.targetApp, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.notificationListItems && ctx.notificationListItems.length > 0);
    } }, directives: function () { return [ɵngcc7.NgbPopover, ɵngcc2.NgIf, ɵngcc2.NgForOf, NotificationBellListItemComponent]; }, styles: [".notification-bell-badge{padding:3px 5px 2px;position:absolute;top:-8px;right:1px;display:inline-block;min-width:15px;font-size:16px;font-weight:700;color:#fff;line-height:1;vertical-align:baseline;white-space:nowrap;text-align:center;border-radius:10px}.notification-bell-badge-danger{background-color:red}.notification-bell-ee{color:green}.notification-bell-wv{color:#fff}.notification-bell-default{color:#000}.notification-item-pad-top{padding-top:20px}.notification-bell-popover{max-width:370px;min-width:370px}@media (max-width:600px){.notification-bell-popover{min-width:95vw;max-width:95vw;max-height:70vh;min-height:5vh;transform:translate(-71vw,25px)!important}.notification-bell-popover .arrow{left:81%!important}}@media (min-width:610px) and (max-width:768px){.notification-bell-popover{min-width:95vw;max-width:95vw;max-height:70vh;min-height:5vh;transform:translate(-84vw,25px)!important}}.notification-bell-popover .popover-body{min-height:5vh;max-height:550px;overflow-x:hidden;overflow-y:auto}@media (max-width:768px){.notification-bell-popover .popover-body{min-height:5vh;max-height:60vh}}@media (min-width:800px) and (max-width:1200px){.notification-bell-popover{min-width:95vw;max-width:95vw;max-height:70vh;min-height:5vh;transform:translate(-87vw,25px)!important}.notification-bell-popover .popover-body{min-height:5vh;max-height:60vh}}@media (min-width:610px) and (max-width:768px){.notification-bell-popover .arrow{left:91.5%!important}}@media (min-width:800px) and (max-width:1024px){.notification-bell-popover .arrow{left:94%!important}}@media (orientation:landscape) and (max-width:850px){.notification-bell-popover{min-width:95vw;max-width:95vw;max-height:70vh;min-height:5vh;transform:translate(-84vw,25px)!important}.notification-bell-popover .popover-body{max-height:55vh;min-height:5vh}.notification-bell-popover .arrow{left:91.5%!important}}div::-webkit-scrollbar{width:5px}div::-webkit-scrollbar-track{background:#f1f1f1}div::-webkit-scrollbar-thumb{background:#888}div::-webkit-scrollbar-thumb:hover{background:#555}"], encapsulation: 2 });
__decorate([
    Input("targetApp"),
    __metadata("design:type", String)
], NotificationBellComponent.prototype, "targetApp", void 0);
NotificationBellComponent = __decorate([ __metadata("design:paramtypes", [NotificationBellService])
], NotificationBellComponent);

let NotificationBellListItemComponent = class NotificationBellListItemComponent {
    constructor() { }
    ngOnInit() {
    }
};
NotificationBellListItemComponent.ɵfac = function NotificationBellListItemComponent_Factory(t) { return new (t || NotificationBellListItemComponent)(); };
NotificationBellListItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NotificationBellListItemComponent, selectors: [["emerson-notification-bell-list-item"]], inputs: { item: ["notificationItem", "item"] }, decls: 13, vars: 6, consts: [[1, "row"], [1, "col-1"], ["aria-hidden", "true"], [1, "col", "notification-list-item-header"], ["aria-hidden", "true", 1, "fa", "fa-circle", "oval-off"], [1, "col"], [1, "notification-action-button", 3, "click"]], template: function NotificationBellListItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelement(7, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementStart(10, "span", 6);
        ɵngcc0.ɵɵlistener("click", function NotificationBellListItemComponent_Template_span_click_10_listener() { return ctx.item == null ? null : ctx.item.executeAction(); });
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(12, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate1("fa fa-circle ", (ctx.item == null ? null : ctx.item.status) === 0 ? "oval" : "oval-off", "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.item == null ? null : ctx.item.header, " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.item == null ? null : ctx.item.body, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.item == null ? null : ctx.item.actionText);
    } }, styles: [".oval[_ngcontent-%COMP%]{color:#007bff;font-size:8pt}.oval-off[_ngcontent-%COMP%]{color:transparent;font-size:8pt}.notification-list-item-header[_ngcontent-%COMP%]{font-weight:700}.notification-list-item-body[_ngcontent-%COMP%]{margin-left:10px;overflow-wrap:break-word}.notification-action-button[_ngcontent-%COMP%]{border-bottom:1px solid #337ab7;color:#337ab7;cursor:pointer}"] });
__decorate([
    Input("notificationItem"),
    __metadata("design:type", NotificationItem)
], NotificationBellListItemComponent.prototype, "item", void 0);
NotificationBellListItemComponent = __decorate([ __metadata("design:paramtypes", [])
], NotificationBellListItemComponent);

let AppTabLinkComponent = class AppTabLinkComponent {
    constructor() {
        this.shortMessage = '';
        this.message = 'Message';
        this.clicked = new EventEmitter();
        this.shortClicked = new EventEmitter();
    }
};
AppTabLinkComponent.ɵfac = function AppTabLinkComponent_Factory(t) { return new (t || AppTabLinkComponent)(); };
AppTabLinkComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppTabLinkComponent, selectors: [["emerson-app-tab-link"]], inputs: { shortMessage: "shortMessage", message: "message" }, outputs: { clicked: "clicked", shortClicked: "shortClicked" }, decls: 33, vars: 3, consts: [[1, "component-container", "large-view", 3, "click"], [1, "tab-link-content"], [1, "icon"], ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "width", "23px", "height", "20px", "viewBox", "0 0 23 20", "version", "1.1"], ["id", "Final", "stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["id", "WV-Logged-Out-Tab-Final", "transform", "translate(-845.000000, -10.000000)"], ["fill", "#FFFFFF", "x", "0", "y", "0", "width", "1466", "height", "858"], ["id", "tab", "transform", "translate(800.000000, 0.000000)"], ["id", "Rectangle", "fill", "#76BD23", "transform", "translate(333.000000, 20.000000) scale(-1, 1) translate(-333.000000, -20.000000) ", "points", "0 0 666 0 636.783743 40 0 40"], ["id", "Group", "transform", "translate(45.000000, 10.000000)", "fill", "#FFFFFF", "fill-rule", "nonzero"], ["id", "logo_leaf"], ["d", "M12.4373262,17.7826603 C7.60718715,20.528237 2.19157672,20.3056227 2.33794457,19.3409606 C3.72843914,7.91342483 14.3035163,4.50000506 15.0353555,5.13074567 C15.1817234,5.24205284 11.8884467,6.42932928 8.8147219,9.87985144 C5.85077295,13.2190664 4.97256586,16.6324862 4.86278997,18.0052746 C4.82619801,18.3391961 10.8638718,17.5229435 15.4012751,12.6625306 C19.2434312,8.46996067 20.7802936,2.16255457 21.4389489,1.49471157 C22.0244203,0.863970957 21.4755409,12.6254282 12.4373262,17.7826603 Z M18.2920402,0.010616014 C20.4875579,-0.0635887637 21.9146444,0.270332736 22.0976042,0.418742291 C22.1341962,0.492947069 22.1341962,0.530049458 22.0976042,0.530049458 C21.8780525,0.567151846 19.6825347,0.826868568 19.426391,0.863970957 C5.22870959,3.01590951 2.41112849,8.50706306 1.34996158,15.9275408 C1.16700177,16.9664077 1.27677766,17.9310698 1.13040981,17.9310698 C1.09381785,17.9310698 1.05722588,17.9310698 0.910858034,17.7455579 C0.142426824,16.7437934 -0.186900837,14.8144692 0.105834862,12.7367354 C0.618122335,9.21200844 2.63068026,5.87279345 5.7044051,3.64665012 C9.692929,0.715561402 15.8403787,0.0848207916 18.2920402,0.010616014 Z", "id", "Combined-Shape"], [1, "message"], [3, "innerHTML"], [1, "component-container", "small-view", 3, "click"], [3, "innerHTML", 4, "ngIf"]], template: function AppTabLinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function AppTabLinkComponent_Template_div_click_0_listener() { return ctx.clicked.emit(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(3, "svg", 3);
        ɵngcc0.ɵɵelementStart(4, "title");
        ɵngcc0.ɵɵtext(5, "2E322D88-F7CD-4D13-8EF8-5EE5196C1D1B");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "g", 4);
        ɵngcc0.ɵɵelementStart(7, "g", 5);
        ɵngcc0.ɵɵelement(8, "rect", 6);
        ɵngcc0.ɵɵelementStart(9, "g", 7);
        ɵngcc0.ɵɵelement(10, "polygon", 8);
        ɵngcc0.ɵɵelementStart(11, "g", 9);
        ɵngcc0.ɵɵelementStart(12, "g", 10);
        ɵngcc0.ɵɵelement(13, "path", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(14, "div", 12);
        ɵngcc0.ɵɵelement(15, "span", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 14);
        ɵngcc0.ɵɵlistener("click", function AppTabLinkComponent_Template_div_click_16_listener() { return ctx.shortClicked.emit(); });
        ɵngcc0.ɵɵelementStart(17, "div", 1);
        ɵngcc0.ɵɵelementStart(18, "span", 2);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(19, "svg", 3);
        ɵngcc0.ɵɵelementStart(20, "title");
        ɵngcc0.ɵɵtext(21, "2E322D88-F7CD-4D13-8EF8-5EE5196C1D1B");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "g", 4);
        ɵngcc0.ɵɵelementStart(23, "g", 5);
        ɵngcc0.ɵɵelement(24, "rect", 6);
        ɵngcc0.ɵɵelementStart(25, "g", 7);
        ɵngcc0.ɵɵelement(26, "polygon", 8);
        ɵngcc0.ɵɵelementStart(27, "g", 9);
        ɵngcc0.ɵɵelementStart(28, "g", 10);
        ɵngcc0.ɵɵelement(29, "path", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(30, "div", 12);
        ɵngcc0.ɵɵtemplate(31, AppTabLinkComponent_span_31_Template, 1, 1, "span", 15);
        ɵngcc0.ɵɵtemplate(32, AppTabLinkComponent_span_32_Template, 1, 1, "span", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(15);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.message, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(16);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.shortMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.shortMessage);
    } }, directives: [ɵngcc2.NgIf], styles: [".icon[_ngcontent-%COMP%]{margin-right:.25em;margin-left:-1em;margin-top:-.5em}.message[_ngcontent-%COMP%]{display:flex;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;max-width:10em}.large-view[_ngcontent-%COMP%]{display:none}.component-container[_ngcontent-%COMP%]{border-top:3em solid #76bd23;border-left:2em solid transparent;cursor:pointer}.tab-link-content[_ngcontent-%COMP%]{display:flex;align-items:center;padding-left:1rem;margin-top:-3em;height:3em;overflow:hidden;color:#fff}@media (min-width:575.98px){.small-view[_ngcontent-%COMP%]{display:none;white-space:unset}.large-view[_ngcontent-%COMP%]{display:flex}.icon[_ngcontent-%COMP%]{margin-left:0;margin-top:0}.message[_ngcontent-%COMP%]{padding:0 .5em;max-width:unset}}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], AppTabLinkComponent.prototype, "shortMessage", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], AppTabLinkComponent.prototype, "message", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], AppTabLinkComponent.prototype, "clicked", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], AppTabLinkComponent.prototype, "shortClicked", void 0);
AppTabLinkComponent = __decorate([ __metadata("design:paramtypes", [])
], AppTabLinkComponent);

let HighlightComponent = class HighlightComponent {
    constructor() {
        this.btnText = 'Got it!';
        this.bodyHtml = 'Now is the time for all good developers to get moving...';
        this.placement = 'bottom';
        this.showOnLoad = false;
        this.showOverlay = true;
    }
    ngOnInit() {
        if (this.btnText === '') {
            this.btnText = 'Got it!';
        }
    }
    ngAfterViewInit() {
        if (this.showOnLoad) {
            this.popover.open();
            this.showOverlay = true;
        }
    }
    ngAfterViewChecked() {
    }
    removeOverlay() {
        this.showOverlay = false;
        this.showOnLoad = false;
    }
};
HighlightComponent.ɵfac = function HighlightComponent_Factory(t) { return new (t || HighlightComponent)(); };
HighlightComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HighlightComponent, selectors: [["emerson-highlight"]], viewQuery: function HighlightComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popover = _t.first);
    } }, inputs: { btnText: "btnText", bodyHtml: "bodyHtml", placement: "placement", showOnLoad: "showOnLoad" }, ngContentSelectors: _c1, decls: 6, vars: 4, consts: [["animation", "false", "popoverClass", "highlight", "openDelay", "500", "showOnLoad", "false", "triggers", "manual", 1, "element-target", 3, "ngbPopover", "placement", "autoClose"], ["popover", "ngbPopover"], ["popContent", ""], ["class", "overlay", 4, "ngIf"], ["type", "button", 1, "got-it", "btn", "btn-sm", 3, "click"], [1, "overlay"]], template: function HighlightComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, HighlightComponent_ng_template_3_Template, 4, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, HighlightComponent_div_5_Template, 1, 0, "div", 3);
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        const _r1 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵpropertyInterpolate("placement", ctx.placement);
        ɵngcc0.ɵɵproperty("ngbPopover", _r1)("autoClose", false);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", (_r0.isOpen() || ctx.showOverlay) && ctx.showOnLoad);
    } }, directives: [ɵngcc7.NgbPopover, ɵngcc2.NgIf], styles: [".highlight{background:#0181d8;border-color:#0181d8;z-index:99999}.highlight .arrow::after{border-top-color:#0181d8;border-bottom-color:#0181d8}.highlight .arrow::before{border-left-color:transparent;border-right-color:transparent}.bs-popover-top>.arrow::after{right:0;border-color:#0181d8 transparent}.bs-popover-left>.arrow::after{right:0;border-color:transparent #0181d8}.bs-popover-right>.arrow::after{border-top-color:transparent;border-bottom-color:transparent;border-right-color:#0181d8;right:0}.btn-outline-secondary.active,.btn-outline-secondary.focus,.btn-outline-secondary:active,.btn-outline-secondary:focus{box-shadow:none}.popover-body{color:#fff}.got-it{background:#fff;color:#0181d8;float:right;font-weight:700;margin-bottom:8px}.got-it:hover{color:#0181d8}.overlay{width:100%;height:100%;position:fixed;top:0;left:0;z-index:99990;background-color:rgba(0,0,0,.5);opacity:50%}.element-target{z-index:99998;position:relative;display:inline-block}"], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], HighlightComponent.prototype, "btnText", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], HighlightComponent.prototype, "bodyHtml", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], HighlightComponent.prototype, "placement", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], HighlightComponent.prototype, "showOnLoad", void 0);
__decorate([
    ViewChild('popover', { static: false }),
    __metadata("design:type", Object)
], HighlightComponent.prototype, "popover", void 0);
HighlightComponent = __decorate([ __metadata("design:paramtypes", [])
], HighlightComponent);

class address {
}

let ValidateaddressService = class ValidateaddressService {
    constructor(http) {
        this.http = http;
        this.hideDontAskAgain = false;
        this.Addresssubject = new Subject();
        this.OnSelectedAddress = new Subject();
    }
    configuration(config) {
        this.hideDontAskAgain = config.hideDontAskAgain;
    }
    //https://qa-emerson-api.emersonecologics.com/shipping/v1/AddressValidation
    validateAddresssvc(data) {
        return this.http.post(this.AkrisApi + '/AddressValidation', data).pipe(map((responseData) => {
            return responseData;
        }), catchError((errorRes) => {
            const content = { title: 'Update Failed', message: errorRes.error.message };
            return this.handleError(errorRes, content);
        }));
    }
    initsvc() {
        return this.Addresssubject.asObservable();
    }
    checkaddress(data) {
        this.Addresssubject.next(data);
    }
    selectedAddress() {
        return this.OnSelectedAddress.asObservable();
    }
    emitSelectedAddress(data) {
        this.OnSelectedAddress.next(data);
    }
    handleError(error, data) {
        // this.dialogService.openDialog(data);
        return throwError(error);
    }
};
ValidateaddressService.ɵfac = function ValidateaddressService_Factory(t) { return new (t || ValidateaddressService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
ValidateaddressService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ValidateaddressService, factory: function (t) { return ValidateaddressService.ɵfac(t); }, providedIn: 'root' });
ValidateaddressService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ValidateaddressService_Factory() { return new ValidateaddressService(ɵɵinject(HttpClient)); }, token: ValidateaddressService, providedIn: "root" });
ValidateaddressService = __decorate([ __metadata("design:paramtypes", [HttpClient])
], ValidateaddressService);

var EnumAction;
(function (EnumAction) {
    EnumAction[EnumAction["validAddress"] = 0] = "validAddress";
    EnumAction[EnumAction["userEnteredAddress"] = 1] = "userEnteredAddress";
    EnumAction[EnumAction["reEnterAddress"] = 2] = "reEnterAddress";
    EnumAction[EnumAction["suggestedAddress"] = 3] = "suggestedAddress";
    EnumAction[EnumAction["setAsDefault"] = 4] = "setAsDefault";
    EnumAction[EnumAction["error"] = 5] = "error";
})(EnumAction || (EnumAction = {}));
class Body {
}
class AddressResponse {
}
class SelectedAddress {
    constructor(userOptOut = false) {
        this.userOptOut = userOptOut;
    }
}

let ValidateAddressComponent = class ValidateAddressComponent {
    constructor(ValidateAddrsvc, modalService) {
        this.ValidateAddrsvc = ValidateAddrsvc;
        this.modalService = modalService;
        this.selectedAddr = new SelectedAddress();
        this.hideDontAskAgain = ValidateAddrsvc.hideDontAskAgain;
    }
    ngOnInit() {
        this.Subscription = this.ValidateAddrsvc.initsvc().subscribe(addr => {
            this.inputAddress = addr;
            this.selectedAddressType = "0";
            this.isUserOptOut = false;
            this.selectedAddr = new SelectedAddress();
            this.ValidateAddrsvc.validateAddresssvc(addr)
                .subscribe(response => {
                this.addrResponse = response;
                if (!this.addrResponse.body.isValid) {
                    this.selectedAddressType = this.addrResponse.body.similarAddresses.length > 0 ? "0" : "-1";
                    this.openSuggestion();
                }
                else {
                    //eventtype 1 - valid from service
                    this.selectedAddr.eventtype = EnumAction.validAddress;
                    this.selectedAddr.selectedaddress = addr;
                    this.selectedAddr.selectedaddress.isDefault = this.inputAddress.isDefault;
                    this.ValidateAddrsvc.emitSelectedAddress(this.selectedAddr);
                }
            }, error => {
                this.addrResponse = new AddressResponse();
                this.addrResponse.body = new Body();
                this.addrResponse.body.isValid = false;
                this.addrResponse.body.similarAddresses = [];
                this.selectedAddressType = "-1";
                this.openSuggestion();
            });
        });
    }
    ngOnDestroy() {
        this.Subscription.unsubscribe();
    }
    openSuggestion() {
        if (!this.inputAddress.isNewAddress) {
            this.selectedAddr.eventtype = EnumAction.userEnteredAddress;
            this.selectedAddr.selectedaddress = this.inputAddress;
            this.ValidateAddrsvc.emitSelectedAddress(this.selectedAddr);
            return;
        }
        this.modalService.open(this.Dialog, { windowClass: 'AddressValidation_modal', ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false }).result.then((result) => {
            if (!this.selectedAddressType) {
                return;
            }
            this.selectedAddr = new SelectedAddress();
            this.selectedAddr.selectedaddress = new address();
            if (this.selectedAddressType != "-1" && this.selectedAddressType != "-2") {
                this.selectedAddr.selectedaddress = this.addrResponse.body.similarAddresses[this.selectedAddressType];
                this.selectedAddr.eventtype = EnumAction.suggestedAddress;
                this.selectedAddr.selectedaddress.isDefault = this.inputAddress.isDefault;
                if (!this.inputAddress.isDefault && this.inputAddress.showNextStep) {
                    this.defaultAddressDialog();
                    return;
                }
            }
            else if (this.selectedAddressType === "-1") {
                this.selectedAddr.eventtype = EnumAction.userEnteredAddress;
                this.selectedAddr.userOptOut = this.isUserOptOut;
                this.selectedAddr.selectedaddress = this.inputAddress;
            }
            else if (this.selectedAddressType === "-2") {
                this.selectedAddr.eventtype = EnumAction.reEnterAddress;
                this.selectedAddr.selectedaddress = this.inputAddress;
            }
            this.ValidateAddrsvc.emitSelectedAddress(this.selectedAddr);
        }, (reason) => {
        });
    }
    defaultAddressDialog() {
        this.modalService.open(this.DefaultDialog, { windowClass: 'AddressValidation_modal', ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false }).result.then((result) => {
            if (!this.selectedAddressType) {
                return;
            }
            if (result == 'setdefault') {
                this.selectedAddr.selectedaddress.isDefault = true;
            }
            this.ValidateAddrsvc.emitSelectedAddress(this.selectedAddr);
        });
    }
    formatAddress(address) {
        var addr = address.street1;
        addr = addr + (!address.street2 ? '' : ', ' + address.street2);
        addr = addr + ', ' + address.city;
        addr = addr + ', ' + address.regionCode;
        addr = addr + ', ' + address.postalCode;
        return addr;
    }
    selectOptions(e) {
        this.isUserOptOut = false;
        this.selectedAddressType = e.target.value;
    }
};
ValidateAddressComponent.ɵfac = function ValidateAddressComponent_Factory(t) { return new (t || ValidateAddressComponent)(ɵngcc0.ɵɵdirectiveInject(ValidateaddressService), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.NgbModal)); };
ValidateAddressComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ValidateAddressComponent, selectors: [["emerson-validate-address"]], viewQuery: function ValidateAddressComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c7, true);
        ɵngcc0.ɵɵviewQuery(_c8, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.Dialog = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.DefaultDialog = _t.first);
    } }, decls: 4, vars: 0, consts: [["class", ""], ["content", ""], ["Defaultaddress", ""], [1, "modal-body", "address_val_modal"], [1, "add_content"], [4, "ngIf"], [1, "form-group"], [1, "input-group"], [1, ""], [1, "radio"], ["class", "first", 4, "ngFor", "ngForOf"], ["type", "radio", "name", "radioaddress", "id", "-1", "value", "-1", 1, "form-check-input", 3, "checked", "change"], ["for", "-1", 1, "form-check-label", "radio-label"], ["type", "radio", "name", "radioaddress", "id", "-2", "value", "-2", 1, "form-check-input", 3, "change"], ["for", "-2", 1, "form-check-label", "radio-label"], [1, "clear", 2, "clear", "both"], [1, "footerModal"], [1, "flexrow", "text"], [3, "hidden"], ["type", "checkbox", "id", "chk_useroptout", "name", "chk_useroptout", 1, "form-check-input", 3, "ngModel", "ngModelChange"], ["for", "chk_useroptout", 1, "form-check-label", "radio-label"], [3, "ngClass"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], [1, "first"], ["type", "radio", "name", "radioaddress", 1, "custom-control-input", 3, "id", "value", "checked", "change"], [1, "form-check-label", "radio-label", 3, "for"], [1, "address_p"], [1, "text-right"], ["type", "button", 1, "btn", "btn-primary", "skip_btn", 3, "click"], ["type", "button", 1, "btn", "btn-primary", "set_btn", 3, "click"]], template: function ValidateAddressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ValidateAddressComponent_ng_template_0_Template, 31, 9, "ng-template", 0, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, ValidateAddressComponent_ng_template_2_Template, 16, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, directives: [ɵngcc1.ɵangular_packages_forms_forms_y, ɵngcc1.NgControlStatusGroup, ɵngcc1.NgForm, ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc1.CheckboxControlValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc2.NgClass], styles: [".AddressValidation_modal[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{border:1px solid #ddd;border-radius:4px}@media (min-width:576px){.AddressValidation_modal[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{max-width:400px!important}}.text-right[_ngcontent-%COMP%]{text-align:right}.address_val_modal[_ngcontent-%COMP%]{font-family:Roboto;color:#212529}.address_val_modal[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font-size:20px;letter-spacing:0;color:#212529;line-height:24px;font-weight:500}.address_val_modal[_ngcontent-%COMP%]   .add_content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:16px;letter-spacing:0;line-height:24px}.address_val_modal[_ngcontent-%COMP%]   .address_p[_ngcontent-%COMP%]{font-weight:500}.address_val_modal[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%]{margin-bottom:10px}.address_val_modal[_ngcontent-%COMP%]   .radio[_ngcontent-%COMP%]   .radio-label[_ngcontent-%COMP%]{display:flex;line-height:22px;cursor:pointer}.address_val_modal[_ngcontent-%COMP%]   .btn-primary[_ngcontent-%COMP%]{background-color:#0063a5;border-color:#0063a5;color:#fff}.address_val_modal[_ngcontent-%COMP%]   .btn-primary.skip_btn[_ngcontent-%COMP%]{background-color:#fff;border-color:#0063a5;color:#0063a5;margin-right:15px}.address_val_modal[_ngcontent-%COMP%]   .btn-primary.skip_btn[_ngcontent-%COMP%]:hover{background-color:#0063a5;color:#fff}.address_val_modal[_ngcontent-%COMP%]   .btn-primary.set_btn[_ngcontent-%COMP%]{color:#fff}.address_val_modal[_ngcontent-%COMP%]   .btn-primary.set_btn[_ngcontent-%COMP%]:hover{background-color:#004472;border-color:#004472;color:#fff}.address_val_modal[_ngcontent-%COMP%]   .footerModal[_ngcontent-%COMP%]{display:flex;flex-direction:row}.address_val_modal[_ngcontent-%COMP%]   .flexrow[_ngcontent-%COMP%]{flex:1;margin-left:20px}.radio[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]{position:absolute;opacity:0}.radio[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%] + .radio-label[_ngcontent-%COMP%]:before{content:\"\";background:#fff;border-radius:100%;border:1px solid #0063a5;display:inline-block;width:15px;height:15px;flex:0 0 15px;position:relative;top:5px;margin-right:10px;vertical-align:top;cursor:pointer;text-align:center;transition:250ms}.radio[_ngcontent-%COMP%]   input[type=radio][_ngcontent-%COMP%]:checked + .radio-label[_ngcontent-%COMP%]:before{background-color:#fff;box-shadow:inset 0 0 0 4px #0063a5}"] });
__decorate([
    ViewChild('content', { static: false }),
    __metadata("design:type", TemplateRef)
], ValidateAddressComponent.prototype, "Dialog", void 0);
__decorate([
    ViewChild('Defaultaddress', { static: false }),
    __metadata("design:type", TemplateRef)
], ValidateAddressComponent.prototype, "DefaultDialog", void 0);
ValidateAddressComponent = __decorate([ __metadata("design:paramtypes", [ValidateaddressService, NgbModal])
], ValidateAddressComponent);

let HeaderComponent = class HeaderComponent {
    constructor(configService) {
        this.configService = configService;
    }
    ngOnInit() {
        this.emersonUrl = this.configService.configurations.sites.emersonUrl;
        this.emersonEduUrl = this.configService.configurations.sites.emersonEduUrl;
        this.wellevateUrl = this.configService.configurations.sites.wellevateUrl;
        this.wellevateGoUrl = this.configService.configurations.sites.wellevateGoUrl;
    }
    isWellevateTheme() {
        return this.theme == 'wellevate';
    }
    isEmersonTheme() {
        return this.theme == 'emerson';
    }
    applyThemeClass(className) {
        return `${className}-${this.theme}`;
    }
    openInNewTab(url) {
        console.log(url);
        window.open(url, '_blank').focus();
    }
};
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ConfigurationService)); };
HeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["emerson-header"]], inputs: { theme: "theme" }, decls: 23, vars: 11, consts: [["rel", "stylesheet", "href", "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css"], [1, "header", "container-full", "d-none", "d-md-block", 3, "ngClass"], [1, "col-12"], [1, "row", "desktop-row"], [1, "col-3", "align-self-start", 3, "theme"], [1, "col-2", "logo-main", "justify-content-end", "align-self-end"], ["href", ""], [3, "src"], ["class", "col align-self-end", 3, "theme", 4, "ngIf"], ["class", "col align-self-end nav-bar-wellevate", 3, "theme", 4, "ngIf"], [1, "col-3", "align-self-end", 3, "theme"], [3, "theme", 4, "ngIf"], [1, "header", "header-mobile", "row", "d-md-none", 3, "ngClass"], [1, "row"], [1, "col-3", 3, "theme"], [1, "row", "mobile-row", "justify-content-between", "align-items-center"], [1, "col-2", "justify-content-start"], [1, "bi", "bi-list", 2, "font-size", "2em"], [1, "col", "logo-main", "justify-content-start"], [1, "col", "col-offset-sm-1", "justify-content-end", 3, "theme"], [1, "col", "align-self-end", 3, "theme"], [1, "col", "align-self-end", "nav-bar-wellevate", 3, "theme"], [3, "theme"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "link", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "header-tab-link", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "a", 6);
        ɵngcc0.ɵɵelement(7, "img", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, HeaderComponent_header_search_bar_8_Template, 1, 1, "header-search-bar", 8);
        ɵngcc0.ɵɵtemplate(9, HeaderComponent_header_navbar_wellevate_9_Template, 1, 1, "header-navbar-wellevate", 9);
        ɵngcc0.ɵɵelement(10, "header-button-bar", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, HeaderComponent_header_navbar_emerson_11_Template, 1, 1, "header-navbar-emerson", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 12);
        ɵngcc0.ɵɵelementStart(13, "div", 2);
        ɵngcc0.ɵɵelementStart(14, "div", 13);
        ɵngcc0.ɵɵelement(15, "header-tab-link", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 15);
        ɵngcc0.ɵɵelementStart(17, "div", 16);
        ɵngcc0.ɵɵelement(18, "i", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 18);
        ɵngcc0.ɵɵelementStart(20, "a", 6);
        ɵngcc0.ɵɵelement(21, "img", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(22, "header-button-bar", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.applyThemeClass("header"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("theme", ctx.theme);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate1("src", "/assets/images/", ctx.theme, "_logo.svg", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEmersonTheme());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isWellevateTheme());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("theme", ctx.theme);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEmersonTheme());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.applyThemeClass("header"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵpropertyInterpolate("theme", ctx.theme);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵpropertyInterpolate1("src", "/assets/images/", ctx.theme, "_logo.svg", ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("theme", ctx.theme);
    } }, directives: function () { return [ɵngcc2.NgClass, TabLinkComponent, ɵngcc2.NgIf, ButtonBarComponent, SearchBarComponent, NavbarWellevateComponent, NavbarEmersonComponent]; }, styles: [".header[_ngcontent-%COMP%]{border-bottom:1px solid #ececec;font-family:Roboto;font-size:16px;padding-bottom:22px}.header-wellevate[_ngcontent-%COMP%]{color:#fff;background-color:#0081d8;padding-bottom:45px}.header-emerson[_ngcontent-%COMP%]{color:#777;background-color:#fff}.desktop-row[_ngcontent-%COMP%]{height:85px}.mobile-row[_ngcontent-%COMP%]{padding-top:15px}header-tab-link[_ngcontent-%COMP%]{padding:0}.logo-main[_ngcontent-%COMP%]{text-align:right;max-width:184px}.logo-main[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:37px}.nav-bar-button[_ngcontent-%COMP%]{max-width:100px;font-weight:500;background-color:#fff;border-color:#fff}header-button-bar[_ngcontent-%COMP%]{margin-bottom:6px}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], HeaderComponent.prototype, "theme", void 0);
HeaderComponent = __decorate([ __metadata("design:paramtypes", [ConfigurationService])
], HeaderComponent);

let TabLinkComponent = class TabLinkComponent extends HeaderComponent {
    constructor(configService) {
        super(configService);
        this.configService = configService;
    }
    goToEmerson() {
        const url = `${this.emersonUrl}`;
        this.openInNewTab(url);
    }
    goToWellevate() {
        const url = `${this.wellevateUrl}`;
        this.openInNewTab(url);
    }
};
TabLinkComponent.ɵfac = function TabLinkComponent_Factory(t) { return new (t || TabLinkComponent)(ɵngcc0.ɵɵdirectiveInject(ConfigurationService)); };
TabLinkComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TabLinkComponent, selectors: [["header-tab-link"]], inputs: { theme: "theme" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [[1, "tab-link", 3, "ngClass"], ["class", "float-right", "src", "/assets/images/wellevate_tab.svg", 3, "click", 4, "ngIf"], ["class", "float-right", "src", "/assets/images/emerson_tab.svg", 3, "click", 4, "ngIf"], ["src", "/assets/images/wellevate_tab.svg", 1, "float-right", 3, "click"], ["src", "/assets/images/emerson_tab.svg", 1, "float-right", 3, "click"]], template: function TabLinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TabLinkComponent_img_1_Template, 1, 0, "img", 1);
        ɵngcc0.ɵɵtemplate(2, TabLinkComponent_img_2_Template, 1, 0, "img", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.applyThemeClass("tab-link"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEmersonTheme());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isWellevateTheme());
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf], styles: [".tab-link[_ngcontent-%COMP%]{cursor:pointer;overflow:hidden}.tab-link-emerson[_ngcontent-%COMP%]{background:linear-gradient(90deg,#0081d8 80%,#fff 20%)}.tab-link-wellevate[_ngcontent-%COMP%]{background:linear-gradient(90deg,#fff 80%,#0081d8 20%)}@media (min-width:768px){.tab-link[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:70px}}@media (max-width:767.98px){.tab-link[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:36px}}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], TabLinkComponent.prototype, "theme", void 0);
TabLinkComponent = __decorate([ __metadata("design:paramtypes", [ConfigurationService])
], TabLinkComponent);

let SearchBarComponent = class SearchBarComponent extends HeaderComponent {
    constructor(configService) {
        super(configService);
        this.configService = configService;
    }
    emersonSearch() {
        const url = `${this.emersonUrl}shop/search?ff=${this.searchTerm}&fft=term&term=${this.searchTerm}`;
        this.openInNewTab(url);
        this.searchTerm = '';
    }
};
SearchBarComponent.ɵfac = function SearchBarComponent_Factory(t) { return new (t || SearchBarComponent)(ɵngcc0.ɵɵdirectiveInject(ConfigurationService)); };
SearchBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SearchBarComponent, selectors: [["header-search-bar"]], inputs: { theme: "theme" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 1, consts: [[1, "search-bar"], [1, "input-group"], ["type", "text", "placeholder", "Search", 1, "form-control", "shadow-none", 3, "ngModel", "ngModelChange", "keyup.enter"], ["type", "submit", "id", "search-button", 1, "btn", "btn-secondary", "shadow-none", 3, "click"], [1, "bi", "bi-search"]], template: function SearchBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function SearchBarComponent_Template_input_ngModelChange_2_listener($event) { return ctx.searchTerm = $event; })("keyup.enter", function SearchBarComponent_Template_input_keyup_enter_2_listener() { return ctx.emersonSearch(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function SearchBarComponent_Template_button_click_3_listener() { return ctx.emersonSearch(); });
        ɵngcc0.ɵɵelement(4, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchTerm);
    } }, directives: [ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel], styles: [".search-bar[_ngcontent-%COMP%]{height:40px}.search-bar[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{border-color:gray}#search-button[_ngcontent-%COMP%]{background-color:#e9ecef;color:#343a40;border-radius:0 5px 5px 0}#search-button[_ngcontent-%COMP%]:hover{background-color:#777}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], SearchBarComponent.prototype, "theme", void 0);
SearchBarComponent = __decorate([ __metadata("design:paramtypes", [ConfigurationService])
], SearchBarComponent);

let ButtonBarComponent = class ButtonBarComponent extends HeaderComponent {
    constructor(configService) {
        super(configService);
        this.configService = configService;
    }
    goToSupport() {
        const url = this.theme == 'wellevate' ? `${this.wellevateGoUrl}support` : `${this.emersonUrl}support`;
        this.openInNewTab(url);
    }
    goToCart() {
        const url = `${this.emersonUrl}shop/search?ff=*&fft=term&term=*`;
        this.openInNewTab(url);
    }
    goToLogin() {
        const url = `${this.emersonUrl}shop/search?ff=*&fft=term&term=*`;
        this.openInNewTab(url);
    }
};
ButtonBarComponent.ɵfac = function ButtonBarComponent_Factory(t) { return new (t || ButtonBarComponent)(ɵngcc0.ɵɵdirectiveInject(ConfigurationService)); };
ButtonBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ButtonBarComponent, selectors: [["header-button-bar"]], inputs: { theme: "theme" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 14, vars: 7, consts: [[1, "button-bar", "row", "d-none", "d-md-inline-block", "text-nowrap", "justify-content-end"], [1, "col"], [1, "button-bar-link", 3, "ngClass", "click"], [1, "bi", "bi-chat-dots-fill", "button-bar-icon", 3, "ngClass"], ["class", "col", 4, "ngIf"], [1, "button-bar-link", "text-nowrap", 3, "ngClass", "click"], [1, "bi", "bi-person-circle", "button-bar-icon", 3, "ngClass"], [1, "button-bar", "row", "d-md-none", "justify-content-end"], [1, "col", "align-items-center"], [1, "bi", "bi-cart-fill", "button-bar-icon", 3, "ngClass"]], template: function ButtonBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("click", function ButtonBarComponent_Template_div_click_2_listener() { return ctx.goToSupport(); });
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, ButtonBarComponent_div_4_Template, 3, 2, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 1);
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵlistener("click", function ButtonBarComponent_Template_div_click_6_listener() { return ctx.goToLogin(); });
        ɵngcc0.ɵɵelement(7, "i", 6);
        ɵngcc0.ɵɵelementStart(8, "div");
        ɵngcc0.ɵɵtext(9, " Login");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "div", 2);
        ɵngcc0.ɵɵlistener("click", function ButtonBarComponent_Template_div_click_12_listener() { return ctx.goToSupport(); });
        ɵngcc0.ɵɵelement(13, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.applyThemeClass("button-bar-link"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.applyThemeClass("button-bar-icon"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEmersonTheme());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.applyThemeClass("button-bar-link"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.applyThemeClass("button-bar-icon"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngClass", ctx.applyThemeClass("button-bar-link"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.applyThemeClass("button-bar-icon"));
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf], styles: [".button-bar[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{max-width:60px;border-color:#fff;display:inline;white-space:nowrap}.button-bar[_ngcontent-%COMP%]   .col[_ngcontent-%COMP%]{padding-left:10px;padding-right:10px}.button-bar-icon[_ngcontent-%COMP%]{font-size:2em;vertical-align:sub}.button-bar-link[_ngcontent-%COMP%]{letter-spacing:.27px;line-height:16px;margin-right:5px}.button-bar-link[_ngcontent-%COMP%]:hover{cursor:pointer}.button-bar-link-emerson[_ngcontent-%COMP%]{color:gray}.button-bar-link-emerson[_ngcontent-%COMP%]:hover{color:#000}.button-bar-link-wellevate[_ngcontent-%COMP%]{color:#fff}.button-bar-link-wellevate[_ngcontent-%COMP%]:hover{color:#ff0}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], ButtonBarComponent.prototype, "theme", void 0);
ButtonBarComponent = __decorate([ __metadata("design:paramtypes", [ConfigurationService])
], ButtonBarComponent);

let NavbarEmersonComponent = class NavbarEmersonComponent extends HeaderComponent {
    constructor(configService) {
        super(configService);
        this.configService = configService;
    }
    goToShop() {
        const url = `${this.emersonUrl}shop/search?ff=*&fft=term&term=*`;
        this.openInNewTab(url);
    }
    goToBrands() {
        const url = `${this.emersonUrl}brands/directory/all`;
        this.openInNewTab(url);
    }
    goToEducation() {
        const url = `${this.emersonUrl}blog`;
        this.openInNewTab(url);
    }
    goToQuality() {
        const url = `${this.emersonEduUrl}quality`;
        this.openInNewTab(url);
    }
};
NavbarEmersonComponent.ɵfac = function NavbarEmersonComponent_Factory(t) { return new (t || NavbarEmersonComponent)(ɵngcc0.ɵɵdirectiveInject(ConfigurationService)); };
NavbarEmersonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavbarEmersonComponent, selectors: [["header-navbar-emerson"]], inputs: { theme: "theme" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 0, consts: [[1, "row", "nav-bar-emerson", "justify-content-end"], [1, "col-md-7", "col-sm-12"], [1, "row"], [1, "text-nowrap", "col-sm-12", "col-md-auto", "btn", "nav-bar-button", "nav-bar-button-emerson", 3, "click"], ["width", "16", "height", "12", 1, "bi", "bi-caret-down-fill"], [1, "col-sm-12", "col-md-auto", "btn", "nav-bar-button", "nav-bar-button-emerson", 3, "click"], [1, "col-md-1", "d-s-none"]], template: function NavbarEmersonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵlistener("click", function NavbarEmersonComponent_Template_div_click_3_listener() { return ctx.goToShop(); });
        ɵngcc0.ɵɵtext(4, " Shop ");
        ɵngcc0.ɵɵelement(5, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵlistener("click", function NavbarEmersonComponent_Template_div_click_6_listener() { return ctx.goToBrands(); });
        ɵngcc0.ɵɵtext(7, " Brands ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵlistener("click", function NavbarEmersonComponent_Template_div_click_8_listener() { return ctx.goToEducation(); });
        ɵngcc0.ɵɵtext(9, " Education ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 5);
        ɵngcc0.ɵɵlistener("click", function NavbarEmersonComponent_Template_div_click_10_listener() { return ctx.goToQuality(); });
        ɵngcc0.ɵɵtext(11, " Quality ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(12, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".nav-bar-button[_ngcontent-%COMP%]{max-width:100px;font-weight:500;background-color:#fff;border-color:#fff}.nav-bar-emerson[_ngcontent-%COMP%]{white-space:nowrap;padding-top:15px}.nav-bar-button-emerson[_ngcontent-%COMP%]{color:#777}.nav-bar-button-emerson[_ngcontent-%COMP%]:hover{color:#000}.nav-bar-button-wellevate[_ngcontent-%COMP%]{color:#fff;padding:0;margin-left:5px;margin-right:5px;align-content:flex-end}.nav-bar-button-wellevate[_ngcontent-%COMP%]:hover{color:#ff0}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], NavbarEmersonComponent.prototype, "theme", void 0);
NavbarEmersonComponent = __decorate([ __metadata("design:paramtypes", [ConfigurationService])
], NavbarEmersonComponent);

let NavbarWellevateComponent = class NavbarWellevateComponent extends HeaderComponent {
    constructor(configService) {
        super(configService);
        this.configService = configService;
    }
    goToWhyWellevate() {
        const url = `${this.wellevateUrl}page/meet-wellevate-scheduler`;
        this.openInNewTab(url);
    }
    goToResources() {
        const url = `${this.emersonUrl}blog`;
        this.openInNewTab(url);
    }
    goToDemo() {
        const url = `${this.wellevateEduUrl}quality`;
        this.openInNewTab(url);
    }
};
NavbarWellevateComponent.ɵfac = function NavbarWellevateComponent_Factory(t) { return new (t || NavbarWellevateComponent)(ɵngcc0.ɵɵdirectiveInject(ConfigurationService)); };
NavbarWellevateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavbarWellevateComponent, selectors: [["header-navbar-wellevate"]], inputs: { theme: "theme" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 0, consts: [[1, "row", "text-nowrap", "justify-content-center", "align-items-center"], ["type", "button", 1, "col-md-auto", "btn", "nav-bar-button-wellevate", 3, "click"]], template: function NavbarWellevateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function NavbarWellevateComponent_Template_div_click_1_listener() { return ctx.goToWhyWellevate(); });
        ɵngcc0.ɵɵtext(2, " Why Wellevate ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵlistener("click", function NavbarWellevateComponent_Template_div_click_3_listener() { return ctx.goToResources(); });
        ɵngcc0.ɵɵtext(4, " Resources ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 1);
        ɵngcc0.ɵɵlistener("click", function NavbarWellevateComponent_Template_div_click_5_listener() { return ctx.goToDemo(); });
        ɵngcc0.ɵɵtext(6, " Schedule a Demo ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".nav-bar-wellevate[_ngcontent-%COMP%]{margin-bottom:5px;text-align:center;white-space:nowrap}.nav-bar-button-wellevate[_ngcontent-%COMP%]{font-size:1em;color:#fff;padding:0;margin-left:5px;margin-right:5px;align-content:flex-end;max-width:120px}.nav-bar-button-wellevate[_ngcontent-%COMP%]:hover{color:#ff0}"] });
__decorate([
    Input(),
    __metadata("design:type", String)
], NavbarWellevateComponent.prototype, "theme", void 0);
NavbarWellevateComponent = __decorate([ __metadata("design:paramtypes", [ConfigurationService])
], NavbarWellevateComponent);

let HeaderModule = class HeaderModule {
};
HeaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: HeaderModule });
HeaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function HeaderModule_Factory(t) { return new (t || HeaderModule)(); }, imports: [[
            CommonModule,
            FormsModule
        ]] });

class InventoryResponse {
    constructor(init) {
        Object.assign(this, init);
    }
}

let InventoryDataService = class InventoryDataService {
    constructor(http) {
        this.http = http;
    }
    getInventory(url, expiryTimeConfig, productCodes) {
        if (productCodes.length == 0) {
            return;
        }
        productCodes = [...new Set(productCodes)];
        productCodes = productCodes.map((item) => {
            return item.toUpperCase();
        });
        let uncachedItemCodes = checkLocalStorageProduct(productCodes);
        if (uncachedItemCodes.length == 0) {
            let group = {};
            for (let prod in productCodes) {
                const cachekey = "cache_" + productCodes[prod];
                if (localStorage.getItem(cachekey))
                    group[productCodes[prod]] = JSON.parse(localStorage.getItem(cachekey)).data;
            }
            return of(group);
        }
        return this.http.post(url + 'GetInventory', { ItemCodes: uncachedItemCodes }).pipe(map((responseData) => {
            let group = groupByItemCode(responseData.body);
            for (let index = 0; index < productCodes.length; index++) {
                const element = productCodes[index];
                let currentDateTime = new Date();
                let expiry = new Date(currentDateTime.getTime() + expiryTimeConfig * 60000);
                const cachekey = "cache_" + element;
                if (group[element]) {
                    localStorage.setItem(cachekey, JSON.stringify({ data: group[element], expirytime: expiry.toISOString() }));
                }
                else if (localStorage.getItem(cachekey)) {
                    group[element] = JSON.parse(localStorage.getItem(cachekey)).data;
                }
            }
            return group;
        }), catchError((error) => {
            return throwError(error);
        }));
    }
};
InventoryDataService.ɵfac = function InventoryDataService_Factory(t) { return new (t || InventoryDataService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
InventoryDataService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: InventoryDataService, factory: function (t) { return InventoryDataService.ɵfac(t); }, providedIn: 'root' });
InventoryDataService.ngInjectableDef = ɵɵdefineInjectable({ factory: function InventoryDataService_Factory() { return new InventoryDataService(ɵɵinject(HttpClient)); }, token: InventoryDataService, providedIn: "root" });
InventoryDataService = __decorate([ __metadata("design:paramtypes", [HttpClient])
], InventoryDataService);
function checkLocalStorageProduct(productCodes) {
    let uncachedproduct = [];
    for (let index = 0; index < productCodes.length; index++) {
        const code = productCodes[index];
        if (!localStorage.getItem('cache_' + code)) {
            uncachedproduct.push(code);
        }
    }
    return uncachedproduct;
}
function groupByItemCode(body) {
    return body.reduce((r, a) => {
        a.itemCode = a.itemCode.toUpperCase();
        let resp = new InventoryResponse();
        resp.backOrder = a.isBackOrder;
        resp.vendorBackOrder = a.isVendorBackOrder;
        resp.stock = a.stock;
        resp.expectedDeliverDate = a.expectedDeliverDate;
        resp.warehouse = a.warehouse;
        resp.shortShelfLife = a.isShortShelfLife ? '1' : '0';
        resp.onHandQuantity = a.onHandQuantity;
        r[a.itemCode] = [...r[a.itemCode] || [], resp];
        return r;
    }, {});
}

let InventoryService = class InventoryService {
    constructor(inventoryDataService) {
        this.inventoryDataService = inventoryDataService;
    }
    inventoryConfiguration(config) {
        this.inventoryConfig = config;
        this.removeExpiredStorageItem();
        setInterval(this.removeExpiredStorageItem, config.interval);
    }
    getInventory(productCodes) {
        return this.inventoryDataService.getInventory(this.inventoryConfig.baseurl, this.inventoryConfig.expiryMinutes, productCodes);
    }
    removeExpiredStorageItem() {
        const keys = Object.keys(localStorage);
        const currentDateTime = new Date().toISOString();
        for (const key in keys) {
            if (keys[key].startsWith("cache_")) {
                const expirytime = JSON.parse(localStorage[keys[key]]).expirytime;
                if (expirytime < currentDateTime) {
                    localStorage.removeItem(keys[key]);
                }
            }
        }
    }
};
InventoryService.ɵfac = function InventoryService_Factory(t) { return new (t || InventoryService)(ɵngcc0.ɵɵinject(InventoryDataService)); };
InventoryService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: InventoryService, factory: function (t) { return InventoryService.ɵfac(t); }, providedIn: 'root' });
InventoryService.ngInjectableDef = ɵɵdefineInjectable({ factory: function InventoryService_Factory() { return new InventoryService(ɵɵinject(InventoryDataService)); }, token: InventoryService, providedIn: "root" });
InventoryService = __decorate([ __metadata("design:paramtypes", [InventoryDataService])
], InventoryService);

let CatalogDataService = class CatalogDataService {
    constructor(http) {
        this.http = http;
    }
    patchCatalog(url, expiryTimeConfig, storefrontId, addProductIds, deleteProductIds) {
        if (addProductIds.length == 0 && deleteProductIds.length == 0) {
            return;
        }
        return this.http.patch(url + 'catalog/' + storefrontId, { AddProductIds: addProductIds, DeleteProductIds: deleteProductIds }).pipe(map((responseData) => {
        }), catchError((error) => {
            return throwError(error);
        }));
    }
    postCatalog(url, expiryTimeConfig, storefrontId, productIds) {
        if (productIds.length == 0) {
            return;
        }
        return this.http.post(url + 'catalog/' + storefrontId, { ProductIds: productIds }).pipe(map((responseData) => {
        }), catchError((error) => {
            return throwError(error);
        }));
    }
    getStorefrontProductIds(url, expiryTimeConfig, storefrontId) {
        return this.http.get(url + 'GetStorefrontProductIds/' + storefrontId).pipe(map((responseData) => {
            return responseData;
        }), catchError((error) => {
            return throwError(error);
        }));
    }
};
CatalogDataService.ɵfac = function CatalogDataService_Factory(t) { return new (t || CatalogDataService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
CatalogDataService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CatalogDataService, factory: function (t) { return CatalogDataService.ɵfac(t); }, providedIn: 'root' });
CatalogDataService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CatalogDataService_Factory() { return new CatalogDataService(ɵɵinject(HttpClient)); }, token: CatalogDataService, providedIn: "root" });
CatalogDataService = __decorate([ __metadata("design:paramtypes", [HttpClient])
], CatalogDataService);

let CatalogService = class CatalogService {
    constructor(catalogDataService) {
        this.catalogDataService = catalogDataService;
    }
    catalogConfiguration(config) {
        this.catalogConfig = config;
    }
    patchCatalog(storefrontId, addProductIds, deleteProductIds) {
        return this.catalogDataService.patchCatalog(this.catalogConfig.baseurl, this.catalogConfig.expiryMinutes, storefrontId, addProductIds, deleteProductIds);
    }
    postCatalog(storefrontId, productIds) {
        return this.catalogDataService.postCatalog(this.catalogConfig.baseurl, this.catalogConfig.expiryMinutes, storefrontId, productIds);
    }
};
CatalogService.ɵfac = function CatalogService_Factory(t) { return new (t || CatalogService)(ɵngcc0.ɵɵinject(CatalogDataService)); };
CatalogService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CatalogService, factory: function (t) { return CatalogService.ɵfac(t); }, providedIn: 'root' });
CatalogService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CatalogService_Factory() { return new CatalogService(ɵɵinject(CatalogDataService)); }, token: CatalogService, providedIn: "root" });
CatalogService = __decorate([ __metadata("design:paramtypes", [CatalogDataService])
], CatalogService);

var EmersonComponentsModule_1;
function storageFactory() {
    return localStorage;
}
let EmersonComponentsModule = EmersonComponentsModule_1 = class EmersonComponentsModule {
    static forRoot() {
        return {
            ngModule: EmersonComponentsModule_1,
            providers: [
                {
                    provide: ConfigurationService
                },
                {
                    provide: IContentService,
                    useClass: ContentfulService,
                },
                {
                    provide: FeatureService
                },
                {
                    provide: AuthService
                },
                {
                    provide: NotificationBellService
                },
                {
                    provide: InventoryService
                },
                {
                    provide: CatalogService
                }
            ],
        };
    }
};
EmersonComponentsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EmersonComponentsModule });
EmersonComponentsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EmersonComponentsModule_Factory(t) { return new (t || EmersonComponentsModule)(); }, providers: [
        {
            provide: OAuthStorage,
            useFactory: storageFactory
        },
    ], imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            RouterModule,
            OAuthModule.forRoot(),
            NgbModule,
            HeaderModule
        ], HeaderModule] });

var IContentDataService_1;
let IContentDataService = IContentDataService_1 = class IContentDataService {
    static throwMethodNotImplemented() {
        throw new Error('Method not implemented exception');
    }
    getEntriesForModelType(typeId, objectToClone, query) {
        IContentDataService_1.throwMethodNotImplemented();
        return;
    }
};
IContentDataService.ɵfac = function IContentDataService_Factory(t) { return new (t || IContentDataService)(); };
IContentDataService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: IContentDataService, factory: function (t) { return IContentDataService.ɵfac(t); }, providedIn: 'root' });
IContentDataService.ngInjectableDef = ɵɵdefineInjectable({ factory: function IContentDataService_Factory() { return new IContentDataService(); }, token: IContentDataService, providedIn: "root" });

let ContentfulDataService = class ContentfulDataService extends IContentDataService {
    constructor(externalContentService) {
        super();
        this.externalContentService = externalContentService;
    }
    getEntriesForModelType(typeId, objectToClone, query) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const responseData = yield this.externalContentService.getEntriesByContentType(typeId, query);
                const returnData = [];
                responseData.items.forEach(data => {
                    const newDataObject = {};
                    if (!objectToClone) {
                        returnData.push(data.fields);
                    }
                    else {
                        Object.keys(objectToClone).forEach(objectKey => {
                            const typeOfObjectToClone = typeof objectToClone[objectKey];
                            if (data.fields[objectKey] && typeof data.fields[objectKey] === typeOfObjectToClone) {
                                if (typeOfObjectToClone === 'object') {
                                    if (data.fields[objectKey].fields) {
                                        newDataObject[objectKey] = data.fields[objectKey].fields;
                                    }
                                    else if (data.fields[objectKey].length) {
                                        newDataObject[objectKey] = data.fields[objectKey].map(objectToMap => objectToMap.fields);
                                    }
                                    else {
                                        newDataObject[objectKey] = data.fields[objectKey];
                                    }
                                }
                                else {
                                    newDataObject[objectKey] = data.fields[objectKey];
                                }
                            }
                            if (data.sys[objectKey] && typeof data.sys[objectKey] === typeOfObjectToClone) {
                                newDataObject[objectKey] = data.sys[objectKey];
                            }
                        });
                    }
                    if (Object.keys(newDataObject).length) {
                        returnData.push(newDataObject);
                    }
                });
                if (!returnData.length && isDevMode()) {
                    console.warn('ContentfulDataService: WARNING: ', 'There was no data passed back from the contentfulDataService.\n' +
                        'If you think this is a mistake then verify your content source' +
                        ' has data for the provided type and that your data class matches what\'s provided by the service.');
                }
                return returnData;
            }
            catch (error) {
                console.log(error);
            }
        });
    }
};
ContentfulDataService.ɵfac = function ContentfulDataService_Factory(t) { return new (t || ContentfulDataService)(ɵngcc0.ɵɵinject(IContentService)); };
ContentfulDataService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ContentfulDataService, factory: function (t) { return ContentfulDataService.ɵfac(t); }, providedIn: 'root' });
ContentfulDataService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ContentfulDataService_Factory() { return new ContentfulDataService(ɵɵinject(IContentService)); }, token: ContentfulDataService, providedIn: "root" });
ContentfulDataService = __decorate([ __metadata("design:paramtypes", [IContentService])
], ContentfulDataService);

class Strategy {
    constructor(name, returnValue = false) {
        this.name = name || 'unknown';
        this.returnValue = returnValue;
    }
    isEnabled(parameters, context) {
        return this.returnValue;
    }
}

class DefaultStrategy extends Strategy {
    constructor() {
        super('default', true);
    }
}

class GradualRolloutRandomStrategy extends Strategy {
    constructor(randomGenerator) {
        super('gradualRolloutRandom');
        this.randomGenerator = () => Math.floor(Math.random() * 100) + 1;
        this.randomGenerator = randomGenerator || this.randomGenerator;
    }
    isEnabled(parameters, context) {
        const percentage = Number(parameters.percentage);
        const random = this.randomGenerator();
        return percentage >= random;
    }
}

function normalizedValue(id, groupId, normalizer = 100) {
    return (x86.hash32(`${groupId}:${id}`) % normalizer) + 1;
}

class GradualRolloutSessionIdStrategy extends Strategy {
    constructor() {
        super('gradualRolloutSessionId');
    }
    isEnabled(parameters, context) {
        const sessionId = context.sessionId;
        if (!sessionId) {
            return false;
        }
        const percentage = Number(parameters.percentage);
        const groupId = parameters.groupId || '';
        const normalizedId = normalizedValue(sessionId, groupId);
        return percentage > 0 && normalizedId <= percentage;
    }
}

class practitionerTypeStrategy extends Strategy {
    constructor() {
        super('practitionerType');
    }
    isEnabled(parameters, context) {
        if (parameters.doc_type) {
            var docTypesarray = parameters.doc_type.split(',');
            if (docTypesarray.indexOf(context.properties.doc_type) != -1) {
                return true;
            }
        }
        return false;
    }
}

class practitionerIdStrategy extends Strategy {
    constructor() {
        super('practitionerId');
    }
    isEnabled(parameters, context) {
        if (parameters.practitioner_id) {
            var practitionerIdArray = parameters.practitioner_id.split(',');
            if (practitionerIdArray.indexOf(context.properties.practitioner_id) != -1) {
                return true;
            }
        }
        return false;
    }
}

class regionCodeStrategy extends Strategy {
    constructor() {
        super('region');
    }
    isEnabled(parameters, context) {
        if (parameters.region_code) {
            var regionCodeArray = parameters.region_code.split(',');
            if (regionCodeArray.indexOf(context.properties.region_code) != -1) {
                return true;
            }
        }
        return false;
    }
}

class allRegionCodeStrategy extends Strategy {
    constructor() {
        super('all-region-codes');
    }
    isEnabled(parameters, context) {
        if (parameters.region_code) {
            var regionCodeArray = parameters.region_code.toString().split(',');
            var allRegionCodeContext = context.properties.all_region_codes.toString().split(',');
            const filteredArray = regionCodeArray.filter(value => allRegionCodeContext.indexOf(value));
            if (filteredArray.length > 0) {
                return true;
            }
        }
        return false;
    }
}

class LocalStrategyComputeProvider {
    constructor() {
        this.implementedStrategies = new Map();
        this.addStrategy(new DefaultStrategy());
        this.addStrategy(new GradualRolloutRandomStrategy());
        this.addStrategy(new GradualRolloutSessionIdStrategy());
        this.addStrategy(new practitionerTypeStrategy());
        this.addStrategy(new practitionerIdStrategy());
        this.addStrategy(new regionCodeStrategy());
        this.addStrategy(new allRegionCodeStrategy());
    }
    addStrategy(strat, doReplace = false) {
        if (this.implementedStrategies.get(strat.name) && !doReplace) {
            return;
        }
        this.implementedStrategies.set(strat.name, strat);
    }
    isEnabled(feature, context) {
        if (!feature.strategies || !feature.strategies.length || !feature.enabled) {
            return false;
        }
        for (const [index, strat] of feature.strategies.entries()) {
            const stratToCheck = this.implementedStrategies.get(strat.name);
            if (stratToCheck && stratToCheck.isEnabled(strat.parameters, context)) {
                return true;
            }
        }
        return false;
    }
}

let CookieService = class CookieService {
    constructor() { }
    get(key) {
        const currentCookies = document.cookie;
        const cookiesArray = currentCookies.split(';');
        const cookieMap = new Map();
        for (const cookie of cookiesArray) {
            const cookieKey = cookie.split('=')[0];
            const cookieValue = cookie.split('=')[1];
            cookieMap.set((cookieKey || '').trim(), (cookieValue || '').trim());
        }
        return cookieMap.get(key) || '';
    }
    set(key, value) {
        document.cookie = `${(key || '').trim()}=${(value || '').trim()}${!value ? '; expires = Thu, 01 Jan 1970 00:00:00 UTC' : ''};`;
    }
};
CookieService.ɵfac = function CookieService_Factory(t) { return new (t || CookieService)(); };
CookieService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: CookieService, factory: function (t) { return CookieService.ɵfac(t); } });
CookieService = __decorate([ __metadata("design:paramtypes", [])
], CookieService);

class BaseSortableAttribute {
    constructor() {
        this.attributeKey = '';
        this.sortMethod = () => 0;
    }
}

class BaseSortableObject {
}
BaseSortableObject.sortableAttributes = [];

class SortableList {
    static sortByAttribute(attribute, collection) {
        const sortedCollection = [...collection];
        if (collection[0] && collection[0][attribute.attributeKey]) {
            sortedCollection.sort((itemA, itemB) => attribute.sortMethod(itemA, itemB));
        }
        else if (collection[0]) {
            throw new Error('SortableModelList:object:sortByAttribute object is not instance of T' +
                ' or is missing SortableAttribute attributeKey: \'' + attribute.attributeKey + '\'');
        }
        return sortedCollection;
    }
}

const PageType = {
    homepage: 'HOMEPAGE',
    category: 'CATEGORY',
    product: 'PRODUCT',
    cart: 'CART',
    other: 'OTHER'
};
let DynamicYieldService = class DynamicYieldService {
    constructor(configService) {
        this.configService = configService;
        this.DY = window.DY || {};
        this.storageKey = 'lastDYContext';
    }
    setDYContext(type, data) {
        if (this.checkRestorablePageType()) {
            localStorage.setItem(this.storageKey, JSON.stringify(this.DY.recommendationContext));
        }
        if (this.checkClearablePageType()) {
            localStorage.removeItem(this.storageKey);
        }
        const contextData = { type, data };
        if ((type === PageType.homepage || type === PageType.other) && (!data || data === PageType.other)) {
            delete contextData.data;
        }
        this.DY.recommendationContext = contextData;
    }
    checkRestorablePageType() {
        return Object.keys(this.DY.recommendationContext).some((k) => { return this.DY.recommendationContext[k] == PageType.category || this.DY.recommendationContext[k] == PageType.cart; });
    }
    checkClearablePageType() {
        return Object.keys(this.DY.recommendationContext).some((k) => { return this.DY.recommendationContext[k] == PageType.homepage || this.DY.recommendationContext[k] == PageType.other; });
    }
    restoreDYContext() {
        const lastDyContext = localStorage.getItem(this.storageKey);
        if (lastDyContext && lastDyContext.length > 0) {
            this.DY.recommendationContext = JSON.parse(lastDyContext);
            return true;
        }
        else {
            return false;
        }
    }
    // DY events below with mock data for now
    // https://support.dynamicyield.com/hc/en-us/articles/360023172893#events-for-web-0-0
    fireDYLoginEvent(data) {
        this.fireDYEvent('Login', data);
    }
    fireDYAddToCartEvent(data) {
        this.fireDYEvent('Add to Cart', data);
    }
    fireDYRemoveFromCartEvent(data) {
        this.fireDYEvent('Remove from Cart', data);
    }
    fireDYPurchaseEvent(data) {
        this.fireDYEvent('Purchase', data);
    }
    fireDYEvent(name, data) {
        const body = {
            name: name,
            properties: data
        };
        if (this.configService.configurations.app.env != 'prod') {
            console.log('DY API Call', body);
        }
        if (Object.prototype.hasOwnProperty.call(this.DY, 'API')) {
            this.DY.API('event', body);
        }
    }
};
DynamicYieldService.ɵfac = function DynamicYieldService_Factory(t) { return new (t || DynamicYieldService)(ɵngcc0.ɵɵinject(ConfigurationService)); };
DynamicYieldService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DynamicYieldService, factory: function (t) { return DynamicYieldService.ɵfac(t); }, providedIn: 'root' });
DynamicYieldService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DynamicYieldService_Factory() { return new DynamicYieldService(ɵɵinject(ConfigurationService)); }, token: DynamicYieldService, providedIn: "root" });
DynamicYieldService = __decorate([ __metadata("design:paramtypes", [ConfigurationService])
], DynamicYieldService);

let VersionCheckerService = class VersionCheckerService {
    constructor(http) {
        this.http = http;
    }
    initVersionCheck(url, frequency, callBack) {
        this.currentVersion = localStorage.getItem("app-version");
        this.refreshCallBack = callBack;
        setInterval(() => {
            this.checkVersion(url);
        }, frequency);
        this.checkVersion(url);
    }
    checkVersion(url) {
        this.http.get(url)
            .subscribe((response) => {
            const version = response.version;
            const hashChanged = this.hasHashChanged(this.currentVersion, version);
            if (hashChanged) {
                this.currentVersion = version;
                this.refreshCallBack();
            }
        }, (err) => {
            console.error(err, 'Could not get version');
        });
    }
    hasHashChanged(currentVersion, newVersion) {
        if (parseInt(currentVersion) !== parseInt(newVersion)) {
            localStorage.setItem('app-version', newVersion);
            return true;
        }
        return false;
    }
};
VersionCheckerService.ɵfac = function VersionCheckerService_Factory(t) { return new (t || VersionCheckerService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
VersionCheckerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: VersionCheckerService, factory: function (t) { return VersionCheckerService.ɵfac(t); }, providedIn: 'root' });
VersionCheckerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function VersionCheckerService_Factory() { return new VersionCheckerService(ɵɵinject(HttpClient)); }, token: VersionCheckerService, providedIn: "root" });
VersionCheckerService = __decorate([ __metadata("design:paramtypes", [HttpClient])
], VersionCheckerService);

let PricingService = class PricingService {
    constructor(http) {
        this.http = http;
    }
    getPatientPricing(config, data) {
        return this.http.post(config.baseurl, data);
    }
};
PricingService.ɵfac = function PricingService_Factory(t) { return new (t || PricingService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
PricingService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: PricingService, factory: function (t) { return PricingService.ɵfac(t); } });
PricingService = __decorate([ __metadata("design:paramtypes", [HttpClient])
], PricingService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EmailSubscriptionBoxComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-email-subscription-box',
                template: "<div \n  class=\"email-subscription-box position-relative d-inline-block px-3 pb-3\" \n  [formGroup]=\"emailFormControlGroup\"     \n  [ngClass]=\"{'success': this.successfulSubmitSent, 'fail': this.failedSubmitSent}\">\n  <div class=\"overlay position-absolute is-not-initalized p-0 w-100 h-100\" *ngIf=\"!isInitalized\">\n    <p>Someone programmed this wrong.</p>\n  </div>\n\n  <h2 class=\"subscribe-title\">{{title}}</h2>\n  <p *ngIf=\"subtitle\" class=\"subscribe-subtitle\">{{subtitle}}</p>\n  <ng-content></ng-content>\n  <input \n    aria-label=\"email for subscription\"\n    class=\"subscription-input\"\n    type=\"email\"\n    name=\"email\"\n    formControlName=\"email\"\n    [ngClass]=\"{'success': this.successfulSubmitSent, 'fail': this.failedSubmitSent}\"\n  >\n  <p *ngIf=\"this.postInputMessage\" class=\"message\">{{this.postInputMessage}}</p>\n  <button \n    aria-label=\"submit email subscription form\"\n    class=\"subscription-submit-button\" \n    [ngClass]=\"{'success': this.successfulSubmitSent, 'fail': this.failedSubmitSent}\"\n    [disabled]=\"!emailFormControlGroup.valid || disableSubmitButton\"\n    (click)=\"onSubmit()\">\n    {{subscribeButtonText}}\n  </button>\n</div>\n",
                providers: [],
                styles: [".ng-invalid:not(div):not(.ng-pristine){border-left:5px solid #a94442}div{background-color:#e7e5e5;border:1px solid #000}div input{width:90%;margin:0}div .overlay{top:0;left:0;opacity:50;border:none}"]
            }]
    }], function () { return [{ type: IHubSpotService }]; }, { successfulSubmit: [{
            type: Output
        }], failedSubmit: [{
            type: Output
        }], title: [{
            type: Input
        }], subtitle: [{
            type: Input
        }], subscribeButtonText: [{
            type: Input
        }], subscribeThankYou: [{
            type: Input
        }], disableSubmitButton: [{
            type: Input
        }], postInputMessage: [{
            type: Input
        }], portalId: [{
            type: Input
        }], formId: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ConfigurationService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-breadcrumb',
                template: "<ul class=\"emerson-breadcrumb\">\n    <li><a href=\"/{{baseUrl}}\" class=\"emerson-breadcrumb\">{{ baseUrl | titlecase }}</a></li>\n    <li *ngFor=\"let breadcrumb of breadcrumbs\">\n      <a [routerLink]=\"[breadcrumb.url]\">{{breadcrumb.label}}</a>\n    </li>\n</ul>\n",
                styles: ["@charset \"UTF-8\";ul.emerson-breadcrumb{list-style:none;-webkit-padding-start:0;padding-inline-start:0}ul.emerson-breadcrumb li{display:inline;color:#115ea5;font-family:Roboto;font-size:14px;line-height:19px}ul.emerson-breadcrumb li+li:before{padding:6px;color:#000;content:\"/\u00A0\"}"]
            }]
    }], function () { return [{ type: ɵngcc4.Router }, { type: ɵngcc4.ActivatedRoute }, { type: ConfigurationService }, { type: ɵngcc2.TitleCasePipe }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(JumbotronComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-jumbotron',
                template: "<!-- emerson version of ui -->\n<div class=\"jumbotron ee-jumbotron container-lg\">\n  <div class=\"row\">\n    <div class=\"col-lg\">\n      <img src=\"{{imgUrl}}\" alt=\"jogger\" class=\"img-fluid image-fill\" width=\"100%\">\n    </div>\n    <div class=\"col-lg\">\n      <div class=\"p-4\">\n        <h1 class=\"h2\"><strong>{{header}}</strong></h1>\n        <p><strong class=\"font-weight-bold\">{{categoryName}}</strong><span class=\"text-muted\">&nbsp;<span *ngIf=\"authorName\">|&nbsp;By {{authorName}}&nbsp;</span>|&nbsp;{{pubDate}}</span>\n        </p>\n        <p class=\"\">{{detailedContent}}</p>\n        <a *ngIf=\"!routerPath && ctaButtonUrl\" href=\"{{ctaButtonUrl}}\" class=\"href\"><button class=\"ee-btn ee-btn-primary pl-5 pr-5\" href=\"#\" role=\"button\">{{ctaButtonText}}</button></a>\n        <a *ngIf=\"routerPath\" [routerLink]=\"routerPath\" [state]=\"routerData\" class=\"href\"><button class=\"ee-btn ee-btn-primary pl-5 pr-5\" href=\"#\" role=\"button\">{{ctaButtonText}}</button></a>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: [".image-fill{-o-object-fit:cover;object-fit:cover;-o-object-position:top;object-position:top;min-width:100%;height:100%}"]
            }]
    }], function () { return []; }, { header: [{
            type: Input
        }], categoryName: [{
            type: Input
        }], authorName: [{
            type: Input
        }], pubDate: [{
            type: Input
        }], lead: [{
            type: Input
        }], detailedContent: [{
            type: Input
        }], ctaButtonText: [{
            type: Input
        }], ctaButtonUrl: [{
            type: Input
        }], imgUrl: [{
            type: Input
        }], routerPath: [{
            type: Input
        }], routerData: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SocialIconsComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-social-icons',
                template: "<div class=\"ee-social-icons p-2\">\n  <ol class=\"my-2\">\n    <li class=\"list-inline d-inline\"><a href=\"{{linkedinUrl}}\"><img\n      src=\"assets/icons/icon-social-media-linkedin-blue.svg\" alt=\"\" class=\"mx-3\"></a></li>\n    <li class=\"list-inline d-inline\"><a href=\"{{facebookUrl}}\"><img\n      src=\"assets/icons/icon-social-media-facebook-blue.svg\" alt=\"\" class=\"mx-3\"></a></li>\n    <li class=\"list-inline d-inline\"><a href=\"{{twitterUrl}}\"><img \n      src=\"assets/icons/icon-social-media-twitter-blue.svg\" alt=\"\" class=\"mx-3\"></a></li>\n    <!--<li class=\"list-inline d-inline\"><a href=\"{{instagramUrl}}\"><img src=\"assets/icons/icon-social-media-insta-blue.svg\" alt=\"\"></a></li>-->\n    <li class=\"list-inline d-inline\"><a href=\"{{pinterestUrl}}\"><img\n      src=\"assets/icons/icon-social-media-pinterest-blue.svg\" alt=\"\" class=\"mx-3\"></a></li>\n  </ol>\n</div>\n",
                styles: [".ee-social-icons ol{-webkit-padding-start:unset;padding-inline-start:unset}.ee-social-icons img{height:24px}"]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlogReferencesComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-blog-references',
                template: "<div class=\"ee-blog-references\">\n  <div>\n    <span (click)=\"showDetail = !showDetail\" class=\"chevron\">\n      <p class=\"clickable\" title=\"Toggle details...\">References\n        <img *ngIf=\"showDetail\" src=\"assets/bootstrap-icons/chevron-compact-up.svg\" class=\"text-light-gray\" alt=\"\" width=\"32\" height=\"32\" title=\"Toggle details...\">\n        <img *ngIf=\"!showDetail\" src=\"assets/bootstrap-icons/chevron-compact-down.svg\" class=\"text-light-gray\" alt=\"\" width=\"32\" height=\"32\" title=\"Toggle details...\">\n      </p>\n    </span>\n  </div>\n  <ol [style.display]=\"showDetail ? 'block': 'none'\">\n    <li *ngFor=\"let referenceUrl of referenceUrls; index as i;\">\n      <span class=\"indexCounter\">{{i + 1}}. </span><a href=\"{{referenceUrl}}\" target=\"_blank\">{{referenceUrl}}</a>\n    </li>\n  </ol>\n</div>\n",
                styles: [".ee-blog-references{color:#115ea5;line-height:18px;border-top:2px solid #979797;border-bottom:2px solid #979797;padding:.5rem 0}ol{list-style:none}.indexCounter{color:#000}.clickable{cursor:pointer}"]
            }]
    }], function () { return []; }, { referenceUrls: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlogPullQuoteComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-blog-pull-quote',
                template: "<blockquote class=\"ee-pull-quote row d-flex justify-content-center align-items-center\">\n  <div class=\"quoteText\">&ldquo;{{quoteContent}}&rdquo;\n    <div *ngIf=\"quoteAttribution\" class=\"quoteAttribution text-align-right mt-2 mr-2\">{{quoteAttribution}}</div>\n  </div>\n</blockquote>\n",
                styles: [".ee-pull-quote{min-height:140px;border-top:2px solid #979797;border-bottom:2px solid #979797}.ee-pull-quote .quoteText{display:-ms-inline-grid;display:inline-grid;line-height:48px;font-size:36px;font-style:italic;font-weight:300;color:#333}.ee-pull-quote .quoteAttribution{text-align:right;color:#666;font-size:12px;line-height:15px}"]
            }]
    }], function () { return []; }, { quoteContent: [{
            type: Input
        }], quoteAttribution: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IContentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ContentfulService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigurationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlogPostDetailComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-blog-post-detail',
                template: "<div class=\"blog-post-detail\">\n  <h1>{{title}}</h1>\n  <h2>{{subTitle}}</h2>\n  <div class=\"legend\"><strong><a class=\"categoryLink\" href=\"category/{{categoryLink}}\">{{categoryName}}</a></strong>&nbsp;|<span *ngIf=\"authorRouterPath\" [routerLink]=\"authorRouterPath\" [state]=\"authorRouterData\">&nbsp;By {{authorName}}&nbsp;</span><span *ngIf=\"!authorRouterPath\">&nbsp;By {{authorName}}&nbsp;</span>|&nbsp;{{publishDate | date}}</div>\n  <emerson-social-icons></emerson-social-icons>\n  <div *ngIf=\"hasHeaderImage\" class=\"image-full-width mb-4\">\n    <emerson-blog-image\n      src='{{getLinkedHeaderImage(posts[0].fields.headerImage.sys.id)}}'\n      altTitle=''\n      attribution=''\n      caption=''\n    ></emerson-blog-image>\n  </div>\n  <div *ngFor=\"let contentBlock of contentBlocks\" class=\"content-block\">\n    <emerson-promotion-content *ngIf=\"getContentType(contentBlock.sys.id) === 'promotionalContent'\" promotionEntry='{{getPromoContent(contentBlock.sys.id)}}'></emerson-promotion-content>\n    <emerson-blog-pull-quote *ngIf=\"getContentType(contentBlock.sys.id) === 'pullQuote'\" quoteContent='{{getPullQuoteContent(contentBlock.sys.id)}}' [quoteAttribution]=\"getPullQuoteAttribution(contentBlock.sys.id)\"></emerson-blog-pull-quote>\n    <emerson-blog-text-block *ngIf=\"getContentType(contentBlock.sys.id) === 'textBlock'\" textContent=\"{{getTextBlockContent(contentBlock.sys.id)}}\"></emerson-blog-text-block>\n    <emerson-blog-video *ngIf=\"getContentType(contentBlock.sys.id) === 'videoLink'\" [url]=\"getVideoURL(contentBlock.sys.id)\"></emerson-blog-video>\n    <emerson-blog-image  *ngIf=\"getContentType(contentBlock.sys.id) === 'imageBlock'\"\n                         [src]=\"getLinkedImageUrl(contentBlock.sys.id)\"\n                         [altTitle]=\"\" [caption]=\"getLinkedImageCaption(contentBlock.sys.id)\"\n                         [attribution]=\"getLinkedImageAttribution(contentBlock.sys.id)\"\n    ></emerson-blog-image>\n    <emerson-blog-columns *ngIf=\"getContentType(contentBlock.sys.id) === 'columns'\"\n      [imageLeft]=\"\"\n      [textContent]=\"'test text content'\"\n      [src]=\"\"\n      [includes]=\"this.includes\"\n      [caption]=\"\"\n      [attribution]=\"\"\n      [leftSideId]=\"getLeftSideId(contentBlock.sys.id)\"\n      [rightSideId]=\"getRightSideId(contentBlock.sys.id)\"\n    ></emerson-blog-columns>\n  </div>\n  <div class=\"nav-buttons d-flex justify-content-center my-5\">\n    <button [disabled]=\"(previousSlug | async) === false\" (click)=\"navigateToPost(previousSlug)\" type=\"button\" class=\"ee-btn mr-3 text-center\"\n            [ngClass]=\"(previousSlug | async) === false ? ' ee-btn-disabled' : 'ee-btn-tertiary'\">\n      <img class=\"nav-prev\" src=\"assets/icons/triangle-solid-up-black.svg\" alt=\"\">\n      Previous post\n    </button>\n    <button [disabled]=\"(nextSlug | async) === false\"  (click)=\"navigateToPost(nextSlug)\" type=\"button\" class=\"ee-btn mr-3 text-center\"\n            [ngClass]=\"(nextSlug | async) === false ? ' ee-btn-disabled' : 'ee-btn-tertiary'\">\n      Next post\n      <img class=\"nav-next\" src=\"assets/icons/triangle-solid-up-black.svg\" alt=\"\">\n    </button>\n  </div>\n  <div *ngIf=\"hasReferences\" class=\"references\">\n    <emerson-blog-references [referenceUrls]=\"getLinkedReferenceUrls()\"></emerson-blog-references>\n  </div>\n  <div *ngIf=\"hasRecommendedArticles\" class=\"mt-3\">\n    <h3 class=\"text-center mb-5\">Recommended Articles</h3>\n    <div class=\"d-flex flex-wrap container-lg\">\n      <div *ngFor=\"let article of recommendedArticles; index as i\" class=\"flex-grow-0 mt-lg-1 col-lg-6 col-12\" [ngClass]=\"i % 2 ? 'pl-2' : 'pr-2'\">\n        <emerson-categorycard\n          [imgUrl]=\"getCardImgUrl(article)\"\n          [header]=\"getTitle(article)\"\n          [pubDate]=\"getPubDate(article)\"\n          [detailedContent]=\"getFirstContentBlock(article)\"\n          [ctaButtonUrl]=\"getUrlSlug(article)\"\n        ></emerson-categorycard>\n      </div>\n    </div>\n  </div>\n</div>\n",
                providers: [{ provide: IContentService, useClass: ContentfulService }],
                styles: [".nav-buttons button{min-width:200px;font-size:18px;line-height:24px;font-weight:700;padding:.75rem}.nav-buttons button .nav-next{transform:rotate(90deg);height:14px;width:21px}.nav-buttons button .nav-prev{transform:rotate(-90deg);height:14px;width:21px}.placeholder{color:red;font-weight:bolder;font-size:24px}.author-page-link{cursor:pointer}.recommended-articles{margin-top:1rem}.recommended-articles h3{text-align:center;margin-bottom:2rem}.card-container{width:100%!important}@media (min-width:992px){.card-container[_ngcontent-tsn-c7]{width:90%!important}}.recommendedArticlesWrapper{display:flex!important;flex-wrap:wrap}.recommendedArticlesWrapper>div{flex:0 50%;box-sizing:border-box;width:100%}@media (max-width:992px){.recommendedArticlesWrapper>div{flex:0 100%;margin-top:1rem}}.pad-left{padding-left:.5em}.pad-right{padding-right:.5em}a.categoryLink{text-display:none;color:#212529}h1{font-size:36px}h2{font-size:24px}h3,h4,h5,h6{font-size:20px}"]
            }]
    }], function () { return [{ type: IContentService }, { type: ɵngcc5.Title }]; }, { navigateToUrl: [{
            type: Output
        }], urlSlug: [{
            type: Input
        }], authorRouterPath: [{
            type: Input
        }], authorRouterData: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlogImageComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-blog-image',
                template: "<div class=\"blog-image-wrapper\">\n      <div class=\"blog-image\">\n        <img src=\"{{src}}\" class=\"img-fluid\" alt=\"{{altTitle}}\">\n      </div>\n      <div *ngIf=\"attribution\" class=\"attribution\">{{attribution}}</div>\n      <div *ngIf=\"caption\" class=\"caption\">{{caption}}</div>\n      <hr *ngIf=\"attribution || caption\">\n</div>\n",
                styles: [".blog-image-wrapper{margin:0;width:100%}.blog-image-wrapper hr{border:1px solid #ccc}.blog-image{border:2px solid #ccc}.blog-image img{width:100%}.attribution{color:#666;font-size:11px;line-height:15px;margin-top:.5rem}.caption{font-size:13px;font-weight:500;line-height:18px;margin-top:.5rem}"]
            }]
    }], function () { return []; }, { src: [{
            type: Input
        }], altTitle: [{
            type: Input
        }], attribution: [{
            type: Input
        }], caption: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ContentComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-content',
                template: "<h1> Content Block </h1>\n<!--<div *ngFor=\"let contentdata of content\">-->\n<!--<ul class=\"u-listReset\">-->\n<!--<li>-->\n<!--{{contentdata.fields.copy}}-->\n<!--</li>-->\n<!--</ul>-->\n<!--</div>-->\n\n<!--contentful contenttype data-->\n<div *ngFor=\"let contentListbyCat of contentList\">\n  <div *ngIf=\"contentListbyCat.length>0\">\n    <a routerLink=\"/{{contentListbyCat[0].sys.contentType.sys.id}}\">\n      <h2>{{contentListbyCat[0].sys.contentType.sys.id}}</h2>\n    </a>\n    <div *ngFor=\"let contentData of contentListbyCat\">\n      <a> {{contentData.fields.title}}</a>\n      <br/>\n      {{contentData.fields.copy}}\n    </div>\n  </div>\n</div>\n<br/>\n\n<!--image Assets from contentful-->\n<div>\n  <div *ngFor=\"let assets of assetsList\">\n    <h4>{{assets.fields.title}}</h4>\n    <div>\n      <img [src]=\"assets.fields.file.url\"/>\n    </div>\n  </div>\n</div>\n",
                providers: [{ provide: IContentService, useValue: ɵ0 }],
                styles: [""]
            }]
    }], function () { return [{ type: IContentService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavbarComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-navbar',
                template: "<div class=\"container-fluid w-100\">\n  <nav class=\"row ee-black d-none d-lg-block mo-padding\" *ngIf=\"siteLinks.length\">\n    <div class=\"flex-list position-relative overflow-hidden\">\n      <ul class=\"d-flex flex-row flex-wrap justify-content-start pl-0 align-items-center m-0 py-1\">\n        <li *ngFor=\"let siteLink of siteLinks\" class=\"text-center align-self-center\">\n          <a [href]=\"siteLink.url\" class=\"ee-nav-link\">{{siteLink.name}}</a>\n          <div class=\"link-spacer\"></div>\n        </li>\n      </ul>\n    </div>\n  </nav>\n  <nav class=\"row ee-nav ee-primary-green justify-content-between mo-padding\">\n    <div class=\"col d-block d-lg-none my-auto\">\n      <div class=\"navbar-toggler-icon\" (click)=\"toggleSidebar()\" *ngIf=\"siteLinks.length\"></div>\n    </div>\n    <div class=\"col text-center text-lg-left logo d-none d-lg-block\">\n      <div *ngIf=\"!searchIconHidden\" class=\"wrap-logo\">\n        <a [href]=\"brandLinkUrl\">\n          <img\n            [src]=\"brandLogoUrl\"\n            alt=\"Logo\"\n            (click)=\"logoClicked()\"\n          >\n        </a>\n        <h4 *ngIf=\"postBrandLogoText\" class=\"d-inline pl-1 ml-1\"><b>{{postBrandLogoText}}</b></h4>\n      </div>\n    </div>\n    <div *ngIf=\"searchIconHidden\" class=\"col-9 input-group\">\n      <div class=\"input-group-append\">\n        <img *ngIf=\"searchIconHidden\" class=\"close-icon mr-1\" src=\"./assets/icons/icon-close-delete-remove-gray.svg\"\n             alt=\"Search\" (click)=\"searchIconToggle()\">\n      </div>\n      <div>\n        <input [@openClose]=\"isOpen ? 'open' : 'closed'\" type=\"text\"\n               class=\"form-control d-inline-flex w-75 float-right mt-2 search-input\" id=\"search-box\"\n               placeholder=\"Search...\">\n      </div>\n    </div>\n    <div *ngIf=\"!searchIconHidden\" class=\"col text-center text-lg-left logo d-block d-lg-none\">\n      <a [href]=\"brandLinkUrl\">\n        <img\n          [src]=\"brandLogoUrl\"\n          alt=\"Logo\"\n          (click)=\"logoClicked()\"\n        >\n      </a>\n      <h4 *ngIf=\"postBrandLogoText\" class=\"d-inline pl-1 ml-1\"><b>{{postBrandLogoText}}</b></h4>\n    </div>\n    <div *ngIf=\"!searchIconHidden\" class=\"col d-block d-none d-lg-none\">\n      <img class=\"search-icon float-right mt-3\" src=\"./assets/icons/icon-search-white.svg\" alt=\"Search...\"\n           (click)=\"searchIconToggle()\">\n    </div>\n    <div class=\"col d-none d-lg-block\">\n      <input type=\"text\" class=\"form-control d-inline-flex w-75 float-right mt-2\" id=\"search-box\"\n             placeholder=\"Search...\">\n    </div>\n  </nav>\n\n  <nav class=\"row ee-gray mo-padding\" *ngIf=\"categories.length\">\n    <div class=\"flex-list d-none d-lg-block position-relative overflow-hidden\">\n      <ul class=\"d-flex flex-row flex-wrap justify-content-start pl-0 align-items-center m-0 py-1\">\n        <li *ngFor=\"let category of categories\" class=\"text-center align-self-center\">\n          <a\n            class=\"ee-nav-link\"\n            [routerLink]=\"category.url\"\n          >\n            {{category.name}}\n          </a>\n          <div class=\"link-spacer\"></div>\n        </li>\n      </ul>\n    </div>\n    <div class=\"row input-group d-sm-block d-lg-none\">\n      <div class=\"col mt-1 mb-1 pr-0 ml-2\">\n        <select class=\"category-select position-relative d-block w-100\" id=\"inputGroupSelect01\"\n                (change)=\"categorySelected($event.target.value)\">\n          <option selected value=\"default\">Select Category...</option>\n          <option\n            [value]=\"category.url\"\n            *ngFor=\"let category of categories\"\n          >\n            {{category.name}}\n          </option>\n        </select>\n      </div>\n    </div>\n  </nav>\n</div>\n\n<div class=\"sidebar d-sm-block d-lg-none position-relative overflow-hidden py-1 px-3\"\n     [ngClass]=\"{'hidden': !sidebarExpanded}\">\n  <ul>\n    <li *ngFor=\"let siteLink of siteLinks\">\n      <a [href]=\"siteLink.url\">{{siteLink.name}}</a>\n    </li>\n  </ul>\n</div>\n",
                animations: [
                    trigger('openClose', [
                        state('open', style({
                            display: 'block',
                            width: '70%'
                        })),
                        state('closed', style({
                            display: 'none',
                            width: '1%'
                        })),
                        transition('open => closed', [
                            animate('0.75s')
                        ]),
                        transition('* => open', [
                            // animate('15s .2s ease-out')
                            animate('750ms', keyframes([
                                style({ width: '1%', offset: 0 }),
                                style({ width: '10%', offset: 0.1 }),
                                style({ width: '20%', offset: 0.2 }),
                                style({ width: '30%', offset: 0.3 }),
                                style({ width: '40%', offset: 0.4 }),
                                style({ width: '50%', offset: 0.6 }),
                                style({ width: '60%', offset: 0.8 }),
                                style({ width: '70%', offset: 1.0 })
                            ]))
                        ]),
                    ]),
                ],
                styles: ["nav .logo{padding-left:0}nav .logo img{margin:.5em 0;width:12rem}nav h4{border-left:1px solid #fff}nav .navbar-toggler-icon{width:2em;background-image:url(assets/icon-blog-hamburger-white.svg)}.ee-nav{background-color:var(--primary-green);min-height:56px}.ee-nav-link{text-decoration:none;color:#fff;font-weight:600;font-size:14px}.container-fluid{white-space:nowrap}.category-select{height:2.5rem}.flex-list ul{margin-left:-1px;list-style-type:none}.flex-list li .link-spacer{margin:0 .5em;height:15px;display:inline-block;vertical-align:middle}.flex-list li:last-of-type .link-spacer{padding-left:0;border-left:none}.sidebar{height:900em;left:0;top:0;z-index:1;background:#fff;width:30%;box-shadow:2px 0 4px rgba(0,0,0,.5);transition:.25s}.sidebar.hidden{display:none;left:-50em}.sidebar li{list-style:none}.form-control{display:inline-flex;width:75%;float:right;margin-top:.6rem}.form-control-animate{display:inline-flex;float:right;margin-top:.6rem}.search-icon{width:1.5rem}.input-group{display:block}.input-group-append{float:right;margin-left:-46px;margin-top:18px;z-index:5}.search-input{border-top-right-radius:.25rem!important;border-bottom-right-radius:.25rem!important;margin-right:.5rem}.close-icon{width:1.15rem;z-index:100;margin-left:-34px!important}.mo-padding{padding-left:16.67%;padding-right:16.67%}@media (max-width:991.98px){.mo-padding{padding-left:0;padding-right:0}}"]
            }]
    }], function () { return []; }, { brandLogoUrl: [{
            type: Input
        }], siteLinks: [{
            type: Input
        }], categories: [{
            type: Input
        }], brandLinkUrl: [{
            type: Input
        }], postBrandLogoText: [{
            type: Input
        }], sidebarToggle: [{
            type: Output
        }], logoClick: [{
            type: Output
        }], categorySelect: [{
            type: Output
        }], getSearchString: [{
            type: Output
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlogCategoryComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-blog-category',
                template: "<div class=\"section\">\n  <h1>Blog Category</h1>\n  <emerson-jumbotron\n    imgUrl='assets/images/Hero-image.png'\n    header=\"This is a blog headline\"\n    categoryName=\"Category Name\"\n    authorName=\"Author Name\"\n    pubDate=\"November 14, 2021\"\n    detailedContent=\"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore ipsum neque nihil optio, porro\n      quis unde! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore ipsum neque nihil optio, porro\n      quis unde!Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore ipsum neque nihil optio, porro\n      quis unde! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore ipsum neque nihil optio, porro\n      quis unde!\"\n    ctaButtonText=\"Primary\"\n    ctaButtonUrl=\"\">\n  </emerson-jumbotron>\n  <div *ngIf=\"blogCategory\">\n    <div style=\"text-align: center\">\n      <img class=\"promo-container\" [src]=\"blogCategory[0].fields.file.url\" alt=\"\">\n    </div>\n  </div>\n  <div class=\"blogCategoryCardWrapper container-lg\" *ngIf=\"categoryCards\">\n    <div *ngFor=\"let article of categoryCards\">\n      <emerson-categorycard\n        [imgUrl]=\"getCardImgUrl(article)\"\n        [header]=\"getTitle(article)\"\n        [detailedContent]=\"getcardContent(article)\"\n        [ctaButtonUrl]=\"\"\n      ></emerson-categorycard>\n    </div>\n  </div>\n</div>\n",
                providers: [{ provide: IContentService, useClass: ContentfulService }],
                styles: [".blogCategoryCardWrapper{display:flex!important;flex-wrap:wrap;margin-top:20px}.blogCategoryCardWrapper>div{flex:0 50%;box-sizing:border-box;width:100%}@media (max-width:992px){.blogCategoryCardWrapper>div{flex:0 100%;margin-top:1rem}}@media (min-width:576px){.promo-container{width:90%;max-width:540px}}@media (min-width:768px){.promo-container{width:96%;max-width:720px}}@media (min-width:992px){.promo-container{width:100%;max-width:960px}}@media (min-width:1200px){.promo-container{width:83%;max-width:1140px}}"]
            }]
    }], function () { return [{ type: IContentService }, { type: ɵngcc4.ActivatedRoute }]; }, { urlSlug: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlogTextBlockComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-blog-text-block',
                template: "<div class=\"ee-text-block w-100\" [innerHTML]=\"textContent\"></div>\n",
                styles: [".ee-text-block{color:#333;font-family:Roboto;font-size:18px;line-height:29px}"]
            }]
    }], function () { return []; }, { textContent: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-footer',
                template: "<div class=\"ee-dark-gray ee-footer container-fluid\">\n  <div class=\"row justify-content-md-center\">\n    <div class=\"col flex-list d-flex justify-content-md-center mt-2 position-relative\">\n      <ul class=\"emerson-footer d-flex flex-row flex-wrap justify-content-start pl-0 align-items-center m-0 py-1 px-0\">\n        <li>\n          <a target=\"_blank\" href=\"https://www.emersonecologics.com/brands/directory/all\">Brands</a>\n          <div class=\"link-spacer\"></div>\n        </li>\n        <li>\n          <a target=\"_blank\" href=\"https://edu.emersonecologics.com/specials/\">Specials</a>\n          <div class=\"link-spacer\"></div>\n        </li>\n        <li>\n          <a target=\"_blank\" href=\"https://www.emersonecologics.com/blog/\">Blog</a>\n          <div class=\"link-spacer\"></div>\n        </li>\n        <li>\n          <a target=\"_blank\" href=\"https://emerson.zendesk.com/hc/en-us\">FAQs</a>\n          <div class=\"link-spacer\"></div>\n        </li>\n        <li>\n          <a target=\"_blank\" href=\"https://edu.emersonecologics.com/about-us/\">About Us</a>\n          <div class=\"link-spacer\"></div>\n        </li>\n        <li>\n          <a target=\"_blank\"\n             href=\"https://emerson.zendesk.com/hc/en-us/articles/231340148-Customer-Support-Contact-Information\">Contact\n            Us</a>\n          <div class=\"link-spacer\"></div>\n        </li>\n        <li>\n          <a target=\"_blank\" href=\"http://emersonecologics.atsondemand.com/index.cfm?cid=512163\">Join Our Team</a>\n          <div class=\"link-spacer\"></div>\n        </li>\n        <li>\n          <a target=\"_blank\" href=\"https://edu.emersonecologics.com/terms-of-sale/\">Terms of Use</a>\n          <div class=\"link-spacer\"></div>\n        </li>\n        <li>\n          <a target=\"_blank\" href=\"https://edu.emersonecologics.com/privacy-policy/\">Privacy Policy</a>\n          <div class=\"link-spacer\"></div>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <div class=\"social-icons p-2 text-center\">\n    <ol class=\"my-2\">\n      <li class=\"list-inline d-inline\"><a target=\"_blank\" href=\"{{linkedinUrl}}\"><img\n        src=\"assets/icons/icon-social-media-linkedin-white.svg\" alt=\"\" class=\"mx-3\"></a></li>\n      <li class=\"list-inline d-inline\"><a target=\"_blank\" href=\"{{facebookUrl}}\"><img\n        src=\"assets/icons/icon-social-media-facebook-white.svg\" alt=\"\" class=\"mx-3\"></a></li>\n      <li class=\"list-inline d-inline\"><a target=\"_blank\" href=\"{{twitterUrl}}\"><img\n        src=\"assets/icons/icon-social-media-twitter-white.svg\" alt=\"\" class=\"mx-3\"></a></li>\n      <li class=\"list-inline d-inline\"><a target=\"_blank\" href=\"{{instagramUrl}}\"><img\n        src=\"assets/icons/icon-social-media-insta-white.svg\" alt=\"\" class=\"mx-3\"></a></li>\n    </ol>\n  </div>\n  <div class=\"row justify-content-md-center\">\n    <div class=\"col\"></div>\n    <div class=\"col text-center flex-list position-relative\">\n      <p class=\"mb-0\"><b>Connect with us!</b></p>\n    </div>\n    <div class=\"col\"></div>\n  </div>\n  <div class=\"row justify-content-md-center\">\n    <div class=\"col\"></div>\n    <div class=\"col-10 text-center flex-list position-relative\">\n      <p>Copyright \u00A9 1997-{{thisYear}} Emerson Ecologics, LLC, All rights reserved. </p>\n      <p>* These statements have not been evaluated by the Food and Drug Administration. These products are not intended\n        to diagnose, treat, cure or prevent any disease.</p>\n      <p>\u2020 Claims based on traditional homeopathic practice, not accepted medical evidence. Not FDA evaluated.</p>\n      <p>We work to ensure that product information is correct; however, brands may make changes to product from time to\n        time, and actual product packaging and materials may contain more and/or different information than that shown\n        on our website. Please consult all labels, warnings, and directions prior to using or consuming products for the\n        most accurate product information. </p>\n    </div>\n    <div class=\"col\"></div>\n  </div>\n</div>\n",
                styles: [".link-spacer{border-left:2px solid #fff}.emerson-footer li{float:left}.emerson-footer li a{color:inherit;text-decoration:none}.social-icons ol{-webkit-padding-start:unset;padding-inline-start:unset}.social-icons img{height:24px}.flex-list ul{margin-left:-1px;list-style-type:none}.flex-list li{flex-basis:auto;text-align:center;-ms-grid-row-align:center;align-self:center}.flex-list li .link-spacer{margin:0 .5em;height:15px;display:inline-block;vertical-align:middle}.flex-list li:last-of-type .link-spacer{padding-left:0;border-left:none}"]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlogColumnsComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-blog-columns',
                template: "<div class=\"blog-col-wrapper container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-xl col-left\">\n      <emerson-blog-text-block *ngIf=\"!imageLeft\"\n                               textContent={{textContent}}\n      ></emerson-blog-text-block>\n      <emerson-blog-image *ngIf=\"imageLeft\"\n                          src={{src}}\n                          altTitle={{altTitle}}\n                          attribution={{attribution}}\n                          caption={{caption}}\n      ></emerson-blog-image>\n    </div>\n    <div class=\"col-xl col-right\">\n      <emerson-blog-text-block *ngIf=\"imageLeft\"\n                               textContent={{textContent}}\n      ></emerson-blog-text-block>\n      <emerson-blog-image *ngIf=\"!imageLeft\"\n                          src={{src}}\n                          altTitle={{altTitle}}\n                          attribution={{attribution}}\n                          caption={{caption}}\n      ></emerson-blog-image>\n    </div>\n  </div>\n</div>\n\n",
                styles: [".blog-col-wrapper{margin:1rem 0}.col-left{padding:0;margin-bottom:1rem}.col-right{padding:0}@media (min-width:1200px){.col-left{padding-right:1rem}}"]
            }]
    }], function () { return []; }, { imageLeft: [{
            type: Input
        }], textContent: [{
            type: Input
        }], src: [{
            type: Input
        }], caption: [{
            type: Input
        }], attribution: [{
            type: Input
        }], altTitle: [{
            type: Input
        }], includes: [{
            type: Input
        }], leftSideId: [{
            type: Input
        }], rightSideId: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlogVideoComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-blog-video',
                template: "<div class=\"my-3 mx-0\">\n  <div class=\"blog-video\">\n    <div class=\"embed-responsive embed-responsive-16by9\">\n      <iframe class=\"embed-responsive-item\" [src]=\"url\" allowfullscreen></iframe>\n    </div>\n  </div>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc5.DomSanitizer }]; }, { url: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StaticcontentComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-staticcontent',
                template: "<span [innerHtml]=\"content\">\n</span>",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc5.DomSanitizer }]; }, { content: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CategorycardComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-categorycard',
                template: "\n<div class=\"jumbotron ee-jumbotron card-container w-100 p-0 mx-auto\">\n  <div class=\"pb-3\">\n    <div class=\"col-lg p-0\">\n      <a *ngIf=\"routerPath\" [routerLink]=\"routerPath\" [state]=\"routerData\">\n        <img src=\"{{imgUrl}}\" alt=\"{{header}}\" class=\"img-fluid image-fill\" />\n      </a>\n      <a *ngIf=\"!routerPath\" [href]=\"ctaButtonUrl\" class=\"href image-fill\">\n        <img src=\"{{imgUrl}}\" alt=\"{{header}}\" class=\"img-fluid\" />\n      </a>\n    </div>\n    <div class=\"col-lg\">\n      <div class=\"p-1\">\n        <p class=\"category-type\"><a class=\"categoryLink\" href=\"category/{{categoryLink}}\">{{categoryName}}</a></p>\n        <h2 class=\"mt-2\">\n          <a *ngIf=\"routerPath\" [routerLink]=\"routerPath\" [state]=\"routerData\" class=\"href-title\">\n            {{header}}\n          </a>\n          <a *ngIf=\"!routerPath\" [href]=\"ctaButtonUrl\" class=\"href-title\">\n            {{header}}\n          </a>\n        </h2>\n        <div  class=\"text-content truncate-overflow overflow-hidden\" [innerHTML]=\"detailedContent\"></div>\n        <a *ngIf=\"routerPath\" [routerLink]=\"routerPath\" [state]=\"routerData\" class=\"href href-cta\">{{ctaButtonText}}</a>\n        <a *ngIf=\"!routerPath\" [href]=\"ctaButtonUrl\" class=\"href href-cta\">{{ctaButtonText}}</a>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: [".image-fill{-o-object-fit:cover;object-fit:cover;-o-object-position:top;object-position:top;min-width:100%;height:100%}.category-type{margin-top:1rem}.category-type a{color:#666;font-size:13px;line-height:18px;font-weight:700;text-decoration:none}.category-type a:hover{text-decoration:underline}.card-container{border-radius:0;background-color:#fff;border:2px solid #ccc}.truncate-overflow{--max-lines:6;--lh:1.5rem;max-height:calc(var(--lh) * var(--max-lines))}.truncate-overflow::before{position:absolute;content:\"...\";bottom:2rem;right:1rem}.truncate-overflow::after{content:\"\";position:absolute;right:0;width:1rem;height:1rem;background:#fff}.column{padding-bottom:1rem}.href-title{color:#000;font-size:24px;text-decoration:none;line-height:1.2;display:inline-block}.href-title:hover{text-decoration:underline}.href-cta{margin-top:1rem!important;display:inline-block}"]
            }]
    }], function () { return [{ type: ɵngcc5.DomSanitizer }]; }, { header: [{
            type: Input
        }], categoryName: [{
            type: Input
        }], categoryLink: [{
            type: Input
        }], pubDate: [{
            type: Input
        }], lead: [{
            type: Input
        }], detailedContent: [{
            type: Input
        }], ctaButtonUrl: [{
            type: Input
        }], ctaButtonText: [{
            type: Input
        }], imgUrl: [{
            type: Input
        }], routerPath: [{
            type: Input
        }], routerData: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BlogAuthorComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-blog-author',
                template: "<div *ngIf=\"blogAuthor\">\n  <div style=\"text-align: center\">\n    <img [src]=\"blogAuthor.fields.profilePicture.fields.file.url\" alt=\"\">\n  </div>\n  <div style=\"text-align: center\">\n    <h1>{{blogAuthor.fields.fullDisplayName}}</h1>\n  </div>\n\n  <div>\n    <p *ngFor=\"let content of blogAuthor.fields.biography.content\">\n\n      <span *ngFor=\"let contentData of content.content\">\n        <a *ngIf=\"contentData.nodeType=='hyperlink'\" [href]=\"contentData.data.uri\"> {{contentData.data.uri}}</a>\n        <span *ngIf=\"contentData.nodeType=='text'\">{{contentData.value}}</span>\n      </span>\n    </p>\n\n  </div>\n</div>\n",
                providers: [{ provide: IContentService, useClass: ContentfulService }],
                styles: [""]
            }]
    }], function () { return [{ type: IContentService }]; }, { urlSlug: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NothingHereComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-nothing-here',
                template: "<div class=\"card nothing-burger w-100\">\n  <img class=\"card-img-top\" [src]=\"imageUrl\" alt=\"Card image cap\" *ngIf=\"imageUrl\">\n  <div class=\"card-body\">\n    <h5 class=\"card-title\">{{title}}</h5>\n    <p class=\"card-text\">{{message}}</p>\n    <a [routerLink]=\"routerPath\" [state]=\"routerData\" class=\"btn btn-primary\">{{buttonText}}</a>\n  </div>\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, { title: [{
            type: Input
        }], message: [{
            type: Input
        }], buttonText: [{
            type: Input
        }], imageUrl: [{
            type: Input
        }], routerPath: [{
            type: Input
        }], routerData: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PromotionContentComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-promotion-content',
                template: "<div class=\"promotion-content mb-3\">\n  <a target=\"_blank\" [href]=\"promotionLink\">\n    <img class=\"promo-container img-fluid w-100\" src=\"{{promotionImage}}\" alt=\"{{promotionTitle}}\"/>\n  </a>\n</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { promotionEntry: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GoogleAnalyticsComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-google-analytics',
                template: "<!-- GA Placeholder -->",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: Object, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { sendPageView: [{
            type: Input
        }], gaAccountId: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GoogleTagManagerComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-google-tag-manager',
                template: "<!-- GTM Placeholder -->",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: Object, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { gtmAccountId: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UnleashService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FeatureService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: UnleashService }, { type: ConfigurationService }, { type: IStrategyComputeProvider }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccountMergePasswordSetSuccessComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-account-merge-password-set-success',
                template: "<div class=\"component container-fluid\" *ngIf=\"titleFetched && bodyFetched\">\n    <div class=\"row d-flex justify-content-between header align-middle\">\n        <div class=\"d-flex\">\n            <h3 class=\"merge-password-set-success-title font-weight-bold my-2 pl-3\">{{title}}</h3>\n        </div>\n        <div (click)=\"exitButtonClicked.emit()\" class=\"d-flex mr-2\">\n            <button type=\"button\" class=\"close\" aria-label=\"close popup\">\n                <span aria-hidden=\"true\">&times;</span>\n            </button>\n        </div>\n    </div>\n    <div class=\"row d-flex pl-3 py-3\">\n        <span class=\"merge-password-set-success-body\" [innerHTML]=\"body\"></span>\n    </div>\n    <div class=\"row d-flex justify-content-end p-2 footer\">\n        <div class=\"btn btn-primary px-3\" (click) = \"okButtonClicked.emit()\">\n            OK\n        </div>\n    </div>\n</div>\n\n\n",
                styles: [".header{border-bottom:1px solid #eceff1;min-height:3rem}.header .close{font-size:2rem}.footer{border-top:1px solid #eceff1}"]
            }]
    }], function () { return [{ type: IContentService }]; }, { application: [{
            type: Input
        }], okButtonClicked: [{
            type: Output
        }], exitButtonClicked: [{
            type: Output
        }], replacements: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccountMergePasswordSetComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-account-merge-password-set',
                template: "<div class=\"container component\">\n    <div class=\"row\">\n        <h4>{{title}}</h4>\n    </div>\n    <div class=\"row\">\n        <span [innerHTML]=\"body\"></span>\n    </div>\n    <div class=\"row justify-content-center\">\n        <form class=\"col col-md-8 input-col px-0\" [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\">\n            <div class=\"row mx-1 mt-1\">\n                <label \n                    class=\"mb-0\" \n                    [ngClass]=\"{'text-danger': (password.invalid && (password.dirty || password.touched))}\" \n                    for=\"basic-password\"\n                    >\n                    Password*\n                </label>\n            </div>\n\n            <div class=\"d-none\">\n                <input type=\"text\" [value]=\"usernameForAccessibility\" autocomplete=\"username\" class=\"form-control\" aria-label=\"username\">\n            </div>\n\n            <div class=\"row\">\n                <div \n                    class=\"col input-group input-group-sm p-0 mx-3 form-control \"\n                    [ngClass]=\"{'border border-danger': (password.invalid && (password.dirty || password.touched))}\"\n                >\n                    <input [type]=\"passwordInputType\" \n                        [formControl]=\"password\" \n                        autocomplete=\"new-password\" \n                        id=\"basic-password\" \n                        class=\"form-control-plaintext pl-2 py-0\" \n                        aria-label=\"new password\"\n                    >\n                    <div class=\"input-group-append\">\n                        <button class=\"btn\" type=\"button\" (click)=\"togglePasswordInputType()\">\n                            <svg *ngIf=\"passwordInputType === 'password'\" width=\"22px\" height=\"14px\" viewBox=\"0 0 22 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                                <title>D356B5CC-D802-468E-B478-D690EF0B1599</title>\n                                <g id=\"WV-First-Run\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n                                    <g id=\"EE/WV-Login-Screen-WV-Login\" transform=\"translate(-831.000000, -393.000000)\" fill=\"#6C757D\" fill-rule=\"nonzero\">\n                                        <g id=\"Group-3\" transform=\"translate(436.000000, 178.000000)\">\n                                            <g id=\"ico_eye_open\" transform=\"translate(395.000000, 215.000000)\">\n                                                <path d=\"M11,0.25 C15.6985283,0.25 21.25,4.05503835 21.25,6.9375 C21.25,9.8199617 15.6985283,13.625 11,13.625 C6.30147173,13.625 0.75,9.8199617 0.75,6.9375 C0.75,4.05503835 6.30147173,0.25 11,0.25 Z M11,1.75 C7.0358394,1.75 2.25,5.0302657 2.25,6.9375 C2.25,8.8447343 7.0358394,12.125 11,12.125 C14.9641606,12.125 19.75,8.8447343 19.75,6.9375 C19.75,5.0302657 14.9641606,1.75 11,1.75 Z M11,2.625 C13.381728,2.625 15.3125,4.55577202 15.3125,6.9375 C15.3125,9.319228 13.381728,11.25 11,11.25 C8.61827202,11.25 6.6875,9.319228 6.6875,6.9375 C6.6875,4.55577202 8.61827202,2.625 11,2.625 Z M11,4.125 C9.4466991,4.125 8.1875,5.3841991 8.1875,6.9375 C8.1875,8.4908009 9.4466991,9.75 11,9.75 C12.5533009,9.75 13.8125,8.4908009 13.8125,6.9375 C13.8125,5.3841991 12.5533009,4.125 11,4.125 Z\" id=\"Combined-Shape\"></path>\n                                            </g>\n                                        </g>\n                                    </g>\n                                </g>\n                            </svg>\n                            <svg *ngIf=\"passwordInputType === 'text'\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"20px\" height=\"10px\" viewBox=\"0 0 20 10\" version=\"1.1\">\n                                <title>2A3A2612-8497-4621-9BF1-DFA7E6A9EFE4</title>\n                                <g id=\"WV-First-Run\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n                                    <g id=\"EE/WV-Login-Screen-WV-Login-Show-PW\" transform=\"translate(-832.000000, -397.000000)\" fill=\"#6C757D\" fill-rule=\"nonzero\">\n                                        <g id=\"Group-3\" transform=\"translate(436.000000, 178.000000)\">\n                                            <g id=\"ico_eye_closed\" transform=\"translate(396.000000, 219.000000)\">\n                                                <path d=\"M9.9007162,7.2319741 C10.3585312,7.2319741 10.7296635,7.6031065 10.7296635,8.0609215 L10.7296635,9.1661847 C10.7296635,9.6239997 10.3585312,9.995132 9.9007162,9.995132 C9.4429012,9.995132 9.0717688,9.6239997 9.0717688,9.1661847 L9.0717688,8.0609215 C9.0717688,7.6031065 9.4429012,7.2319741 9.9007162,7.2319741 Z M5.95219128,6.70018363 C6.38239665,6.85676558 6.60421225,7.3324507 6.44763033,7.76265599 L6.06960805,8.80126366 C5.9130261,9.23146904 5.43734099,9.45328466 5.00713562,9.29670272 C4.57693025,9.14012077 4.35511465,8.66443564 4.5116966,8.23423026 L4.88971888,7.19562259 C5.0463008,6.76541731 5.52198591,6.54360168 5.95219128,6.70018363 Z M13.8492415,6.70018372 C14.2794469,6.54360176 14.755132,6.76541739 14.9117139,7.19562267 L14.9117139,7.19562267 L15.2897362,8.23423034 C15.4463181,8.66443572 15.2245025,9.14012085 14.7942971,9.2967028 C14.3640918,9.45328476 13.8884066,9.23146914 13.7318247,8.80126376 L13.7318247,8.80126376 L13.3538024,7.76265609 C13.1972205,7.3324508 13.4190361,6.85676567 13.8492415,6.70018372 Z M17.4417701,4.87724621 C17.8167902,4.61465431 18.3336768,4.70579543 18.5962686,5.08081552 L18.5962686,5.08081552 L19.2302215,5.98619405 C19.4928134,6.36121415 19.4016724,6.87810075 19.0266523,7.14069265 C18.6516322,7.40328454 18.1347456,7.31214348 17.8721537,6.93712339 L17.8721537,6.93712339 L17.2382008,6.03174486 C16.9756089,5.65672477 17.06675,5.1398381 17.4417701,4.87724621 Z M2.22665195,4.87724622 C2.60167203,5.13983811 2.69281307,5.65672476 2.43022118,6.03174485 L1.79626831,6.93712338 C1.53367641,7.31214347 1.01678977,7.40328456 0.641769685,7.14069266 C0.2667496,6.87810077 0.175608552,6.36121412 0.438200448,5.98619403 L1.07215332,5.0808155 C1.33474521,4.70579541 1.85163186,4.61465433 2.22665195,4.87724622 Z M0.47761541,0.3928102 C0.84022687,0.1925958 1.29648738,0.3242446 1.49670178,0.686856 C2.70099679,2.8679737 6.64124122,5.125 10,5.125 C13.3442219,5.125 17.2639874,2.8896385 18.4904069,0.7099828 C18.6935255,0.3489901 19.150828,0.2210078 19.5118207,0.4241264 C19.8728134,0.6272449 20.0007957,1.0845475 19.7976771,1.4455402 C18.3024429,4.1029471 13.8799564,6.625 10,6.625 C6.10236709,6.625 1.65553254,4.0777919 0.18356954,1.4118965 C-0.01664487,1.0492851 0.11500396,0.5930246 0.47761541,0.3928102 Z\" id=\"Combined-Shape\"/>\n                                            </g>\n                                        </g>\n                                    </g>\n                                </g>\n                            </svg>\n                        </button>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"row mx-1 mt-3\">\n                <label \n                    class=\"mb-0\" \n                    for=\"basic-password-confirm\" \n                    [ngClass]=\"{'text-danger': (confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched))}\"\n                    >\n                    Confirm Password*\n                </label>\n            </div>\n\n            <div class=\"row\">\n                <div \n                    class=\"col input-group input-group-sm p-0 mx-3 form-control \"\n                    [ngClass]=\"{'border border-danger': (confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched))}\"\n                >\n                    <input \n                        [type]=\"confirmPasswordInputType\" \n                        [formControl]=\"confirmPassword\"\n                        autocomplete=\"new-password\" \n                        id=\"basic-password-confirm\" \n                        class=\"form-control-plaintext pl-2 py-0\" \n                        aria-label=\"new password\"\n                    >\n                    <div class=\"input-group-append\">\n                        <button class=\"btn\" type=\"button\" (click)=\"toggleConfirmPasswordInputType()\">\n                            <svg *ngIf=\"confirmPasswordInputType === 'password'\" width=\"22px\" height=\"14px\" viewBox=\"0 0 22 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n                                <title>D356B5CC-D802-468E-B478-D690EF0B1599</title>\n                                <g id=\"WV-First-Run\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n                                    <g id=\"EE/WV-Login-Screen-WV-Login\" transform=\"translate(-831.000000, -393.000000)\" fill=\"#6C757D\" fill-rule=\"nonzero\">\n                                        <g id=\"Group-3\" transform=\"translate(436.000000, 178.000000)\">\n                                            <g id=\"ico_eye_open\" transform=\"translate(395.000000, 215.000000)\">\n                                                <path d=\"M11,0.25 C15.6985283,0.25 21.25,4.05503835 21.25,6.9375 C21.25,9.8199617 15.6985283,13.625 11,13.625 C6.30147173,13.625 0.75,9.8199617 0.75,6.9375 C0.75,4.05503835 6.30147173,0.25 11,0.25 Z M11,1.75 C7.0358394,1.75 2.25,5.0302657 2.25,6.9375 C2.25,8.8447343 7.0358394,12.125 11,12.125 C14.9641606,12.125 19.75,8.8447343 19.75,6.9375 C19.75,5.0302657 14.9641606,1.75 11,1.75 Z M11,2.625 C13.381728,2.625 15.3125,4.55577202 15.3125,6.9375 C15.3125,9.319228 13.381728,11.25 11,11.25 C8.61827202,11.25 6.6875,9.319228 6.6875,6.9375 C6.6875,4.55577202 8.61827202,2.625 11,2.625 Z M11,4.125 C9.4466991,4.125 8.1875,5.3841991 8.1875,6.9375 C8.1875,8.4908009 9.4466991,9.75 11,9.75 C12.5533009,9.75 13.8125,8.4908009 13.8125,6.9375 C13.8125,5.3841991 12.5533009,4.125 11,4.125 Z\" id=\"Combined-Shape\"></path>\n                                            </g>\n                                        </g>\n                                    </g>\n                                </g>\n                            </svg>\n                            <svg *ngIf=\"confirmPasswordInputType === 'text'\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"20px\" height=\"10px\" viewBox=\"0 0 20 10\" version=\"1.1\">\n                                <title>2A3A2612-8497-4621-9BF1-DFA7E6A9EFE4</title>\n                                <g id=\"WV-First-Run\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n                                    <g id=\"EE/WV-Login-Screen-WV-Login-Show-PW\" transform=\"translate(-832.000000, -397.000000)\" fill=\"#6C757D\" fill-rule=\"nonzero\">\n                                        <g id=\"Group-3\" transform=\"translate(436.000000, 178.000000)\">\n                                            <g id=\"ico_eye_closed\" transform=\"translate(396.000000, 219.000000)\">\n                                                <path d=\"M9.9007162,7.2319741 C10.3585312,7.2319741 10.7296635,7.6031065 10.7296635,8.0609215 L10.7296635,9.1661847 C10.7296635,9.6239997 10.3585312,9.995132 9.9007162,9.995132 C9.4429012,9.995132 9.0717688,9.6239997 9.0717688,9.1661847 L9.0717688,8.0609215 C9.0717688,7.6031065 9.4429012,7.2319741 9.9007162,7.2319741 Z M5.95219128,6.70018363 C6.38239665,6.85676558 6.60421225,7.3324507 6.44763033,7.76265599 L6.06960805,8.80126366 C5.9130261,9.23146904 5.43734099,9.45328466 5.00713562,9.29670272 C4.57693025,9.14012077 4.35511465,8.66443564 4.5116966,8.23423026 L4.88971888,7.19562259 C5.0463008,6.76541731 5.52198591,6.54360168 5.95219128,6.70018363 Z M13.8492415,6.70018372 C14.2794469,6.54360176 14.755132,6.76541739 14.9117139,7.19562267 L14.9117139,7.19562267 L15.2897362,8.23423034 C15.4463181,8.66443572 15.2245025,9.14012085 14.7942971,9.2967028 C14.3640918,9.45328476 13.8884066,9.23146914 13.7318247,8.80126376 L13.7318247,8.80126376 L13.3538024,7.76265609 C13.1972205,7.3324508 13.4190361,6.85676567 13.8492415,6.70018372 Z M17.4417701,4.87724621 C17.8167902,4.61465431 18.3336768,4.70579543 18.5962686,5.08081552 L18.5962686,5.08081552 L19.2302215,5.98619405 C19.4928134,6.36121415 19.4016724,6.87810075 19.0266523,7.14069265 C18.6516322,7.40328454 18.1347456,7.31214348 17.8721537,6.93712339 L17.8721537,6.93712339 L17.2382008,6.03174486 C16.9756089,5.65672477 17.06675,5.1398381 17.4417701,4.87724621 Z M2.22665195,4.87724622 C2.60167203,5.13983811 2.69281307,5.65672476 2.43022118,6.03174485 L1.79626831,6.93712338 C1.53367641,7.31214347 1.01678977,7.40328456 0.641769685,7.14069266 C0.2667496,6.87810077 0.175608552,6.36121412 0.438200448,5.98619403 L1.07215332,5.0808155 C1.33474521,4.70579541 1.85163186,4.61465433 2.22665195,4.87724622 Z M0.47761541,0.3928102 C0.84022687,0.1925958 1.29648738,0.3242446 1.49670178,0.686856 C2.70099679,2.8679737 6.64124122,5.125 10,5.125 C13.3442219,5.125 17.2639874,2.8896385 18.4904069,0.7099828 C18.6935255,0.3489901 19.150828,0.2210078 19.5118207,0.4241264 C19.8728134,0.6272449 20.0007957,1.0845475 19.7976771,1.4455402 C18.3024429,4.1029471 13.8799564,6.625 10,6.625 C6.10236709,6.625 1.65553254,4.0777919 0.18356954,1.4118965 C-0.01664487,1.0492851 0.11500396,0.5930246 0.47761541,0.3928102 Z\" id=\"Combined-Shape\"/>\n                                            </g>\n                                        </g>\n                                    </g>\n                                </g>\n                            </svg>\n                        </button>\n                    </div>\n                </div>\n            </div>\n            \n            <div class=\"row mt-1 mx-1 pl-4\" *ngIf=\"\n                (confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) || (password.invalid && (password.dirty || password.touched))\">\n                \n                <ul class=\"p-0 text-danger\">\n                    <li *ngIf=\"password.errors?.required\">\n                        Password is required.\n                    </li>\n                    <li *ngIf=\"!password.errors?.required && (password.invalid && (password.dirty || password.touched))\">\n                        {{passwordPatternValidatorFailedMessage}}\n                    </li>\n                    <li *ngIf=\"confirmPassword.errors?.noMatch && (confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched))\">\n                        Confirm password must match Password.\n                    </li>\n                </ul>\n\n            </div>\n\n            <div class=\"row mt-4 justify-content-center\">\n                <div class=\"col text-center\">\n                    <button class=\"btn btn-primary btn-block\" type=\"submit\" [disabled]=\"!form.valid\">\n                        Submit\n                    </button>\n                </div>\n            </div>\n\n        </form>\n    </div>\n</div>",
                styles: [".component{max-width:55vw;min-width:5vw}.form-control-plaintext{outline:0}"]
            }]
    }], function () { return [{ type: IContentService }]; }, { application: [{
            type: Input
        }], usernameForAccessibility: [{
            type: Input
        }], submitEmitter: [{
            type: Output
        }], replacements: [{
            type: Input
        }], passwordPatternValidator: [{
            type: Input
        }], passwordPatternValidatorFailedMessage: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigurationService }, { type: ɵngcc6.OAuthService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationBellService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-auth',
                template: "<h3>Authentication</h3>\n<div class=\"mt-3 mb-3\">\n  <button class=\"btn btn-success mr-1\" *ngIf=\"!accessToken\" (click)=\"login()\">Login</button>\n  <button class=\"btn btn-secondary mr-1\" *ngIf=\"accessToken\" (click)=\"logout()\">Logout</button>\n  <button class=\"btn btn-warning mr-1\" *ngIf=\"accessToken\" (click)='refresh()'>Refresh Token</button>\n  <button class=\"btn btn-info mr-1\" *ngIf=\"accessToken\" (click)='getUserProfile()'>User Profile</button>\n</div>\n<div class=\"text-break mt-3 mb-3\" *ngIf=\"accessToken\">\n  <p>Access Token : {{accessToken}}</p>\n</div>\n\n<div class=\"text-break mt-3 mb-3\" *ngIf=\"userProfile\">\n  <p>User Profile : {{userProfile}}</p>\n</div>\n",
                styles: [""]
            }]
    }], function () { return [{ type: AuthService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationBellComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-notification-bell',
                template: "<ng-template #popTitle>Notifications ({{notificationListItems ? notificationListItems.length : '0'}})</ng-template>\n <ng-template #popContent>\n    <div class=\"container\">\n    <ng-container  *ngIf=\"notificationListItems.length > 0\"> \n        <div class=\"row\" *ngFor=\"let item of notificationListItems let indexOfelement=index;\">\n           <emerson-notification-bell-list-item class=\"{{indexOfelement > 0 ? 'notification-item-pad-top' : ''}}\" [notificationItem]=\"item\"></emerson-notification-bell-list-item>\n        </div>\n    </ng-container>\n    <ng-container *ngIf=\"notificationListItems.length == 0\">\n        <div style=\"text-align: center; font-weight:bold\">You have no new notifications</div>\n    </ng-container>\n   </div>\n </ng-template>\n <span style=\"position:relative\">\n   <button class=\"btn btn-outline-none\" \n           type=\"button\" placement=\"bottom\" \n           popoverClass=\"notification-bell-popover\"\n           [ngbPopover]=\"popContent\" \n           [popoverTitle]=\"popTitle\" \n           #notifyPop=\"ngbPopover\">\n      <i  class=\"fa fa-bell{{this.targetApp === 'wv' ? '-o' : ''}} notification-bell-{{this.targetApp}}\" style=\"font-size: 20px; float: left;\"></i>\n   </button>\n   <span *ngIf=\"notificationListItems && notificationListItems.length > 0\" class=\"notification-bell-badge notification-bell-badge-danger\" (click)=\"notifyPop.open()\">{{notificationListItems.length}}</span>\n</span>\n\n\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".notification-bell-badge{padding:3px 5px 2px;position:absolute;top:-8px;right:1px;display:inline-block;min-width:15px;font-size:16px;font-weight:700;color:#fff;line-height:1;vertical-align:baseline;white-space:nowrap;text-align:center;border-radius:10px}.notification-bell-badge-danger{background-color:red}.notification-bell-ee{color:green}.notification-bell-wv{color:#fff}.notification-bell-default{color:#000}.notification-item-pad-top{padding-top:20px}.notification-bell-popover{max-width:370px;min-width:370px}@media (max-width:600px){.notification-bell-popover{min-width:95vw;max-width:95vw;max-height:70vh;min-height:5vh;transform:translate(-71vw,25px)!important}.notification-bell-popover .arrow{left:81%!important}}@media (min-width:610px) and (max-width:768px){.notification-bell-popover{min-width:95vw;max-width:95vw;max-height:70vh;min-height:5vh;transform:translate(-84vw,25px)!important}}.notification-bell-popover .popover-body{min-height:5vh;max-height:550px;overflow-x:hidden;overflow-y:auto}@media (max-width:768px){.notification-bell-popover .popover-body{min-height:5vh;max-height:60vh}}@media (min-width:800px) and (max-width:1200px){.notification-bell-popover{min-width:95vw;max-width:95vw;max-height:70vh;min-height:5vh;transform:translate(-87vw,25px)!important}.notification-bell-popover .popover-body{min-height:5vh;max-height:60vh}}@media (min-width:610px) and (max-width:768px){.notification-bell-popover .arrow{left:91.5%!important}}@media (min-width:800px) and (max-width:1024px){.notification-bell-popover .arrow{left:94%!important}}@media (orientation:landscape) and (max-width:850px){.notification-bell-popover{min-width:95vw;max-width:95vw;max-height:70vh;min-height:5vh;transform:translate(-84vw,25px)!important}.notification-bell-popover .popover-body{max-height:55vh;min-height:5vh}.notification-bell-popover .arrow{left:91.5%!important}}div::-webkit-scrollbar{width:5px}div::-webkit-scrollbar-track{background:#f1f1f1}div::-webkit-scrollbar-thumb{background:#888}div::-webkit-scrollbar-thumb:hover{background:#555}"]
            }]
    }], function () { return [{ type: NotificationBellService }]; }, { targetApp: [{
            type: Input,
            args: ["targetApp"]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationBellListItemComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-notification-bell-list-item',
                template: "<div class=\"row\">\n    <div class=\"col-1\">\n        <i class=\"fa fa-circle {{item?.status === 0 ? 'oval' : 'oval-off'}}\" aria-hidden=\"true\"></i>\n    </div>\n    <div class=\"col notification-list-item-header\">\n        {{item?.header}}\n    </div>\n</div>\n<div class=\"row\">\n    <div class=\"col-1\">\n        <i class=\"fa fa-circle oval-off \" aria-hidden=\"true\"></i>\n    </div>\n    <div class=\"col\">\n        {{item?.body}} <span class=\"notification-action-button\" (click)=\"item?.executeAction()\">{{item?.actionText}}</span>\n    </div>\n    <div class=\"col-1\"></div>\n</div>\n",
                styles: [".oval{color:#007bff;font-size:8pt}.oval-off{color:transparent;font-size:8pt}.notification-list-item-header{font-weight:700}.notification-list-item-body{margin-left:10px;overflow-wrap:break-word}.notification-action-button{border-bottom:1px solid #337ab7;color:#337ab7;cursor:pointer}"]
            }]
    }], function () { return []; }, { item: [{
            type: Input,
            args: ["notificationItem"]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AppTabLinkComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-app-tab-link',
                template: "<div class=\"component-container large-view\" (click)=\"clicked.emit()\">\n  <div class=\"tab-link-content\">\n    <span class=\"icon\">\n      <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"23px\" height=\"20px\" viewBox=\"0 0 23 20\" version=\"1.1\">\n          <title>2E322D88-F7CD-4D13-8EF8-5EE5196C1D1B</title>\n          <g id=\"Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n              <g id=\"WV-Logged-Out-Tab-Final\" transform=\"translate(-845.000000, -10.000000)\">\n                  <rect fill=\"#FFFFFF\" x=\"0\" y=\"0\" width=\"1466\" height=\"858\"/>\n                  <g id=\"tab\" transform=\"translate(800.000000, 0.000000)\">\n                      <polygon id=\"Rectangle\" fill=\"#76BD23\" transform=\"translate(333.000000, 20.000000) scale(-1, 1) translate(-333.000000, -20.000000) \" points=\"0 0 666 0 636.783743 40 0 40\"/>\n                      <g id=\"Group\" transform=\"translate(45.000000, 10.000000)\" fill=\"#FFFFFF\" fill-rule=\"nonzero\">\n                          <g id=\"logo_leaf\">\n                              <path d=\"M12.4373262,17.7826603 C7.60718715,20.528237 2.19157672,20.3056227 2.33794457,19.3409606 C3.72843914,7.91342483 14.3035163,4.50000506 15.0353555,5.13074567 C15.1817234,5.24205284 11.8884467,6.42932928 8.8147219,9.87985144 C5.85077295,13.2190664 4.97256586,16.6324862 4.86278997,18.0052746 C4.82619801,18.3391961 10.8638718,17.5229435 15.4012751,12.6625306 C19.2434312,8.46996067 20.7802936,2.16255457 21.4389489,1.49471157 C22.0244203,0.863970957 21.4755409,12.6254282 12.4373262,17.7826603 Z M18.2920402,0.010616014 C20.4875579,-0.0635887637 21.9146444,0.270332736 22.0976042,0.418742291 C22.1341962,0.492947069 22.1341962,0.530049458 22.0976042,0.530049458 C21.8780525,0.567151846 19.6825347,0.826868568 19.426391,0.863970957 C5.22870959,3.01590951 2.41112849,8.50706306 1.34996158,15.9275408 C1.16700177,16.9664077 1.27677766,17.9310698 1.13040981,17.9310698 C1.09381785,17.9310698 1.05722588,17.9310698 0.910858034,17.7455579 C0.142426824,16.7437934 -0.186900837,14.8144692 0.105834862,12.7367354 C0.618122335,9.21200844 2.63068026,5.87279345 5.7044051,3.64665012 C9.692929,0.715561402 15.8403787,0.0848207916 18.2920402,0.010616014 Z\" id=\"Combined-Shape\"/>\n                          </g>\n                      </g>\n                  </g>\n              </g>\n          </g>\n      </svg>\n    </span>\n    <div class=\"message\">\n      <span [innerHTML]=\"message\">\n      </span>\n    </div>\n  </div>\n</div>\n\n<div class=\"component-container small-view\" (click)=\"shortClicked.emit()\">\n  <div class=\"tab-link-content\">\n    <span class=\"icon\">\n      <svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"23px\" height=\"20px\" viewBox=\"0 0 23 20\" version=\"1.1\">\n          <title>2E322D88-F7CD-4D13-8EF8-5EE5196C1D1B</title>\n          <g id=\"Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n              <g id=\"WV-Logged-Out-Tab-Final\" transform=\"translate(-845.000000, -10.000000)\">\n                  <rect fill=\"#FFFFFF\" x=\"0\" y=\"0\" width=\"1466\" height=\"858\"/>\n                  <g id=\"tab\" transform=\"translate(800.000000, 0.000000)\">\n                      <polygon id=\"Rectangle\" fill=\"#76BD23\" transform=\"translate(333.000000, 20.000000) scale(-1, 1) translate(-333.000000, -20.000000) \" points=\"0 0 666 0 636.783743 40 0 40\"/>\n                      <g id=\"Group\" transform=\"translate(45.000000, 10.000000)\" fill=\"#FFFFFF\" fill-rule=\"nonzero\">\n                          <g id=\"logo_leaf\">\n                              <path d=\"M12.4373262,17.7826603 C7.60718715,20.528237 2.19157672,20.3056227 2.33794457,19.3409606 C3.72843914,7.91342483 14.3035163,4.50000506 15.0353555,5.13074567 C15.1817234,5.24205284 11.8884467,6.42932928 8.8147219,9.87985144 C5.85077295,13.2190664 4.97256586,16.6324862 4.86278997,18.0052746 C4.82619801,18.3391961 10.8638718,17.5229435 15.4012751,12.6625306 C19.2434312,8.46996067 20.7802936,2.16255457 21.4389489,1.49471157 C22.0244203,0.863970957 21.4755409,12.6254282 12.4373262,17.7826603 Z M18.2920402,0.010616014 C20.4875579,-0.0635887637 21.9146444,0.270332736 22.0976042,0.418742291 C22.1341962,0.492947069 22.1341962,0.530049458 22.0976042,0.530049458 C21.8780525,0.567151846 19.6825347,0.826868568 19.426391,0.863970957 C5.22870959,3.01590951 2.41112849,8.50706306 1.34996158,15.9275408 C1.16700177,16.9664077 1.27677766,17.9310698 1.13040981,17.9310698 C1.09381785,17.9310698 1.05722588,17.9310698 0.910858034,17.7455579 C0.142426824,16.7437934 -0.186900837,14.8144692 0.105834862,12.7367354 C0.618122335,9.21200844 2.63068026,5.87279345 5.7044051,3.64665012 C9.692929,0.715561402 15.8403787,0.0848207916 18.2920402,0.010616014 Z\" id=\"Combined-Shape\"/>\n                          </g>\n                      </g>\n                  </g>\n              </g>\n          </g>\n      </svg>\n    </span>\n    <div class=\"message\">\n      <span *ngIf=\"!shortMessage\" [innerHTML]=\"message\">\n      </span>\n      <span *ngIf=\"shortMessage\" [innerHTML]=\"shortMessage\">\n      </span>\n    </div>\n  </div>\n</div>",
                styles: [".icon{margin-right:.25em;margin-left:-1em;margin-top:-.5em}.message{display:flex;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;max-width:10em}.large-view{display:none}.component-container{border-top:3em solid #76bd23;border-left:2em solid transparent;cursor:pointer}.tab-link-content{display:flex;align-items:center;padding-left:1rem;margin-top:-3em;height:3em;overflow:hidden;color:#fff}@media (min-width:575.98px){.small-view{display:none;white-space:unset}.large-view{display:flex}.icon{margin-left:0;margin-top:0}.message{padding:0 .5em;max-width:unset}}"]
            }]
    }], function () { return []; }, { shortMessage: [{
            type: Input
        }], message: [{
            type: Input
        }], clicked: [{
            type: Output
        }], shortClicked: [{
            type: Output
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HighlightComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-highlight',
                template: "<div [ngbPopover]=\"popContent\"\n     animation=\"false\"\n     class=\"element-target\"\n     placement={{placement}}\n     popoverClass=\"highlight\"\n     #popover=\"ngbPopover\"\n     [autoClose]=\"false\"\n     openDelay=\"500\"\n     showOnLoad=\"false\"\n     triggers=\"manual\">\n  <!-- Tip: replace 'manual' with 'click' to triggers above for development mode -->\n  <ng-content></ng-content>\n</div>\n<ng-template #popContent>\n  <p>{{bodyHtml}}</p>\n  <button type=\"button\" (click)=\"popover.close();removeOverlay();\" class=\"got-it btn btn-sm\">{{btnText}}</button>\n</ng-template>\n<div class=\"overlay\" *ngIf=\"(popover.isOpen() || showOverlay) && showOnLoad\"></div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".highlight{background:#0181d8;border-color:#0181d8;z-index:99999}.highlight .arrow::after{border-top-color:#0181d8;border-bottom-color:#0181d8}.highlight .arrow::before{border-left-color:transparent;border-right-color:transparent}.bs-popover-top>.arrow::after{right:0;border-color:#0181d8 transparent}.bs-popover-left>.arrow::after{right:0;border-color:transparent #0181d8}.bs-popover-right>.arrow::after{border-top-color:transparent;border-bottom-color:transparent;border-right-color:#0181d8;right:0}.btn-outline-secondary.active,.btn-outline-secondary.focus,.btn-outline-secondary:active,.btn-outline-secondary:focus{box-shadow:none}.popover-body{color:#fff}.got-it{background:#fff;color:#0181d8;float:right;font-weight:700;margin-bottom:8px}.got-it:hover{color:#0181d8}.overlay{width:100%;height:100%;position:fixed;top:0;left:0;z-index:99990;background-color:rgba(0,0,0,.5);opacity:50%}.element-target{z-index:99998;position:relative;display:inline-block}"]
            }]
    }], function () { return []; }, { btnText: [{
            type: Input
        }], bodyHtml: [{
            type: Input
        }], placement: [{
            type: Input
        }], showOnLoad: [{
            type: Input
        }], popover: [{
            type: ViewChild,
            args: ['popover', { static: false }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ValidateaddressService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ValidateAddressComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-validate-address',
                template: "<ng-template #content let-modal class=\"\">\n    <div class=\"modal-body address_val_modal\">\n        <form>\n            <h2>Address Validation</h2>\n            <div class=\"add_content\">\n                <p *ngIf=\"addrResponse.body.similarAddresses.length == 0 && !addrResponse.body.isValid\">\n                    Address wasn't able to be successfully validated\n                </p>\n                <p *ngIf=\"addrResponse.body.similarAddresses.length > 0 && !addrResponse.body.isValid\">\n                    The address you entered can not be validated. We recommend using the below address that has been\n                    validated.\n                </p>\n            </div>\n            <div class=\"form-group\">\n                <div class=\"input-group\">\n                    <div class=\"\">\n                        <div class=\"radio\">\n                            <div class=\"first\" *ngFor=\"let item of addrResponse.body.similarAddresses;index as i\">\n                                <input type=\"radio\" class=\"custom-control-input \" name=\"radioaddress\" (change)=\"selectOptions($event)\" id=\"{{i}}\" value=\"{{i}}\" [checked]=\"selectedAddressType==i\">\n                                <label class=\"form-check-label radio-label\" for=\"{{i}}\">{{formatAddress(item)}}</label>\n                            </div>\n                        </div>\n                        <div class=\"radio\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"radioaddress\" (change)=\"selectOptions($event)\" id=\"-1\" value=\"-1\" [checked]=\"selectedAddressType==='-1'\">\n                            <label class=\"form-check-label radio-label\" for=\"-1\">Use the address you entered</label>\n\n                        </div>\n                        <div class=\"radio\">\n                            <input class=\"form-check-input\" type=\"radio\" name=\"radioaddress\" (change)=\"selectOptions($event)\" id=\"-2\" value=\"-2\" />\n                            <label class=\"form-check-label radio-label\" for=\"-2\">Re-enter your address</label>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n        </form>\n        <div class=\"clear\" style=\"clear: both;\"></div>\n        <div class=\"footerModal\">\n            <div class=\"flexrow text\">\n                <div [hidden]=\"selectedAddressType!='-1' || hideDontAskAgain\">\n                    <input type=\"checkbox\" class=\"form-check-input\" [(ngModel)]=\"isUserOptOut\" id=\"chk_useroptout\" name=\"chk_useroptout\">\n                    <label for=\"chk_useroptout\" class=\"form-check-label radio-label\"> Don't ask me again for this address</label><br>\n                </div>\n            </div>\n            <div [ngClass]=\"{'text-right':selectedAddressType!='-1' || hideDontAskAgain}\">\n                <button type=\"button\" class=\"btn btn-primary\" (click)=\"modal.close('Continue')\">\n                    Continue\n                </button>\n            </div>\n        </div>\n\n    </div>\n</ng-template>\n\n<ng-template #Defaultaddress let-modal>\n    <div class=\"modal-body address_val_modal\">\n        <h2>Set default address</h2>\n\n        <div class=\"\">\n            <div class=\"form-group\">\n                <div class=\"add_content\">\n                    <p> Would you like to set this new address as your default shipping address?</p>\n                    <p class=\"address_p\">\n                        {{formatAddress(selectedAddr.selectedaddress)}}\n                    </p>\n                </div>\n\n            </div>\n            <br />\n            <div class=\"text-right\">\n                <button type=\"button\" class=\"btn btn-primary skip_btn\" (click)=\"modal.close('skip')\">\n                    Skip this step\n                </button>\n                <button type=\"button\" class=\"btn btn-primary set_btn\" (click)=\"modal.close('setdefault')\">\n                    Set as default\n                </button>\n            </div>\n        </div>\n    </div>\n</ng-template>\n",
                styles: [".AddressValidation_modal .modal-content{border:1px solid #ddd;border-radius:4px}@media (min-width:576px){.AddressValidation_modal .modal-dialog{max-width:400px!important}}.text-right{text-align:right}.address_val_modal{font-family:Roboto;color:#212529}.address_val_modal h2{font-size:20px;letter-spacing:0;color:#212529;line-height:24px;font-weight:500}.address_val_modal .add_content p{font-size:16px;letter-spacing:0;line-height:24px}.address_val_modal .address_p{font-weight:500}.address_val_modal .radio{margin-bottom:10px}.address_val_modal .radio .radio-label{display:flex;line-height:22px;cursor:pointer}.address_val_modal .btn-primary{background-color:#0063a5;border-color:#0063a5;color:#fff}.address_val_modal .btn-primary.skip_btn{background-color:#fff;border-color:#0063a5;color:#0063a5;margin-right:15px}.address_val_modal .btn-primary.skip_btn:hover{background-color:#0063a5;color:#fff}.address_val_modal .btn-primary.set_btn{color:#fff}.address_val_modal .btn-primary.set_btn:hover{background-color:#004472;border-color:#004472;color:#fff}.address_val_modal .footerModal{display:flex;flex-direction:row}.address_val_modal .flexrow{flex:1;margin-left:20px}.radio input[type=radio]{position:absolute;opacity:0}.radio input[type=radio]+.radio-label:before{content:\"\";background:#fff;border-radius:100%;border:1px solid #0063a5;display:inline-block;width:15px;height:15px;flex:0 0 15px;position:relative;top:5px;margin-right:10px;vertical-align:top;cursor:pointer;text-align:center;transition:250ms}.radio input[type=radio]:checked+.radio-label:before{background-color:#fff;box-shadow:inset 0 0 0 4px #0063a5}"]
            }]
    }], function () { return [{ type: ValidateaddressService }, { type: ɵngcc7.NgbModal }]; }, { Dialog: [{
            type: ViewChild,
            args: ['content', { static: false }]
        }], DefaultDialog: [{
            type: ViewChild,
            args: ['Defaultaddress', { static: false }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'emerson-header',
                template: "<link rel=\"stylesheet\" href=\"https://cdn.jsdelivr.net/npm/bootstrap-icons@1.5.0/font/bootstrap-icons.css\">\n<script src=\"https://code.jquery.com/jquery-3.4.1.slim.min.js\" integrity=\"sha384-J6qa4849blE2+poT4WnyKhv5vZF5SrPo0iEjwBvKU7imGFAV0wwj1yYfoRSJoZ+n\" crossorigin=\"anonymous\"></script>\n<script src=\"https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js\" integrity=\"sha384-Q6E9RHvbIyZFJoft+2mJbHaEWldlvI9IOYy5n3zV9zzTtmI3UksdQRVvoxMfooAo\" crossorigin=\"anonymous\"></script>\n<script src=\"https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js\" integrity=\"sha384-wfSDF2E50Y2D1uUdj0O3uMBJnjuUD4Ih7YwaYd1iqfktj0Uod8GCExl3Og8ifwB6\" crossorigin=\"anonymous\"></script>\n\n<div class=\"header container-full d-none d-md-block\" [ngClass]=\"applyThemeClass('header')\">\n    <div class=\"col-12\">\n        <div class=\"row desktop-row\">\n            <header-tab-link \n                theme=\"{{theme}}\"\n                class=\"col-3 align-self-start\">\n            </header-tab-link>\n\n            <div class=\"col-2 logo-main justify-content-end align-self-end\">\n                <a href=\"\">\n                    <img src=\"/assets/images/{{theme}}_logo.svg\">\n                </a>\n            </div>\n\n            <header-search-bar\n                *ngIf=\"isEmersonTheme()\"\n                class=\"col align-self-end\"\n                theme=\"{{theme}}\">\n            </header-search-bar>\n\n            <header-navbar-wellevate\n                *ngIf=\"isWellevateTheme()\"\n                theme=\"{{theme}}\"\n                class=\"col align-self-end nav-bar-wellevate\">\n            </header-navbar-wellevate>\n\n            <header-button-bar\n                theme=\"{{theme}}\"\n                class=\"col-3 align-self-end\">\n            </header-button-bar>\n        </div>\n        \n        <header-navbar-emerson \n            *ngIf=\"isEmersonTheme()\"\n            theme=\"{{theme}}\">\n        </header-navbar-emerson>\n    </div>\n</div> <!-- header -->\n\n<div class=\"header header-mobile row d-md-none\" [ngClass]=\"applyThemeClass('header')\">\n    <div class=\"col-12\">\n        <div class=\"row\">\n            <header-tab-link \n                theme=\"{{theme}}\"\n                class=\"col-3\">\n            </header-tab-link>\n        </div>\n\n        <div class=\"row mobile-row justify-content-between align-items-center\">\n            <div class=\"col-2 justify-content-start\">\n                <i class=\"bi bi-list\" style=\"font-size:2em;\"></i>\n            </div>\n\n            <div class=\"col logo-main justify-content-start\">\n                <a href=\"\">\n                    <img src=\"/assets/images/{{theme}}_logo.svg\">\n                </a>\n            </div>\n\n            <header-button-bar\n                theme=\"{{theme}}\"\n                class=\"col col-offset-sm-1 justify-content-end\">\n            </header-button-bar>\n        </div>\n    </div>\n    \n</div>\n",
                styles: [".header{border-bottom:1px solid #ececec;font-family:Roboto;font-size:16px;padding-bottom:22px}.header-wellevate{color:#fff;background-color:#0081d8;padding-bottom:45px}.header-emerson{color:#777;background-color:#fff}.desktop-row{height:85px}.mobile-row{padding-top:15px}header-tab-link{padding:0}.logo-main{text-align:right;max-width:184px}.logo-main img{height:37px}.nav-bar-button{max-width:100px;font-weight:500;background-color:#fff;border-color:#fff}header-button-bar{margin-bottom:6px}"]
            }]
    }], function () { return [{ type: ConfigurationService }]; }, { theme: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabLinkComponent, [{
        type: Component,
        args: [{
                selector: 'header-tab-link',
                template: "<div class=\"tab-link\" [ngClass]=\"applyThemeClass('tab-link')\">\n    <img class=\"float-right\" (click)=\"goToWellevate()\" *ngIf=\"isEmersonTheme();\" src=\"/assets/images/wellevate_tab.svg\">\n    <img class=\"float-right\" (click)=\"goToEmerson()\" *ngIf=\"isWellevateTheme()\" src=\"/assets/images/emerson_tab.svg\">\n</div>",
                styles: [".tab-link{cursor:pointer;overflow:hidden}.tab-link-emerson{background:linear-gradient(90deg,#0081d8 80%,#fff 20%)}.tab-link-wellevate{background:linear-gradient(90deg,#fff 80%,#0081d8 20%)}@media (min-width:768px){.tab-link img{height:70px}}@media (max-width:767.98px){.tab-link img{height:36px}}"]
            }]
    }], function () { return [{ type: ConfigurationService }]; }, { theme: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SearchBarComponent, [{
        type: Component,
        args: [{
                selector: 'header-search-bar',
                template: "<div class=\"search-bar\">\n    <div class=\"input-group\">\n        <input \n            type=\"text\" \n            class=\"form-control shadow-none\" \n            placeholder=\"Search\" \n            [(ngModel)]=\"searchTerm\" \n            (keyup.enter)=\"emersonSearch()\">\n        <button \n            class=\"btn btn-secondary shadow-none\" \n            (click)=\"emersonSearch()\" \n            type=\"submit\" \n            id=\"search-button\">\n            <i class=\"bi bi-search\"></i>\n        </button>\n    </div>\n</div>",
                styles: [".search-bar{height:40px}.search-bar div input:focus{border-color:gray}#search-button{background-color:#e9ecef;color:#343a40;border-radius:0 5px 5px 0}#search-button:hover{background-color:#777}"]
            }]
    }], function () { return [{ type: ConfigurationService }]; }, { theme: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ButtonBarComponent, [{
        type: Component,
        args: [{
                selector: 'header-button-bar',
                template: "<div class=\"button-bar row d-none d-md-inline-block text-nowrap justify-content-end\">\n    <div class=\"col\">\n        <div class=\"button-bar-link\" (click)=\"goToSupport()\" [ngClass]=\"applyThemeClass('button-bar-link')\">\n            <i class=\"bi bi-chat-dots-fill button-bar-icon\" [ngClass]=\"applyThemeClass('button-bar-icon')\"></i>    \n        </div>\n    </div>\n\n    <div *ngIf=\"isEmersonTheme()\" class=\"col\">\n        <div class=\"button-bar-link\" (click)=\"goToCart()\" [ngClass]=\"applyThemeClass('button-bar-link')\">\n            <i class=\"bi bi-cart-fill button-bar-icon\" [ngClass]=\"applyThemeClass('button-bar-icon')\"></i>\n        </div>\n    </div>\n\n    <div class=\"col\">\n        <div class=\"button-bar-link text-nowrap\" (click)=\"goToLogin()\" [ngClass]=\"applyThemeClass('button-bar-link')\">\n            <i class=\"bi bi-person-circle button-bar-icon\" [ngClass]=\"applyThemeClass('button-bar-icon')\">\n            </i>\n            <div> Login</div>\n        </div>\n    </div>\n</div>\n\n<div class=\"button-bar row d-md-none justify-content-end\">\n    <div class=\"col align-items-center\">\n        <div class=\"button-bar-link\" (click)=\"goToSupport()\" [ngClass]=\"applyThemeClass('button-bar-link')\">\n            <i class=\"bi bi-chat-dots-fill button-bar-icon\" [ngClass]=\"applyThemeClass('button-bar-icon')\"></i>    \n        </div>\n    </div>\n</div>",
                styles: [".button-bar div{max-width:60px;border-color:#fff;display:inline;white-space:nowrap}.button-bar .col{padding-left:10px;padding-right:10px}.button-bar-icon{font-size:2em;vertical-align:sub}.button-bar-link{letter-spacing:.27px;line-height:16px;margin-right:5px}.button-bar-link:hover{cursor:pointer}.button-bar-link-emerson{color:gray}.button-bar-link-emerson:hover{color:#000}.button-bar-link-wellevate{color:#fff}.button-bar-link-wellevate:hover{color:#ff0}"]
            }]
    }], function () { return [{ type: ConfigurationService }]; }, { theme: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavbarEmersonComponent, [{
        type: Component,
        args: [{
                selector: 'header-navbar-emerson',
                template: "\n<div class=\"row nav-bar-emerson justify-content-end\">\n    <div class=\"col-md-7 col-sm-12\">\n        <div class=\"row\">\n            <div (click)=\"goToShop()\" class=\"text-nowrap col-sm-12 col-md-auto btn nav-bar-button nav-bar-button-emerson\">\n                Shop\n                <i class=\"bi bi-caret-down-fill\" width=\"16\" height=\"12\"></i>\n            </div>\n            <div (click)=\"goToBrands()\" class=\"col-sm-12 col-md-auto btn nav-bar-button nav-bar-button-emerson\">\n                Brands\n            </div>\n            <div (click)=\"goToEducation()\" class=\"col-sm-12 col-md-auto btn nav-bar-button nav-bar-button-emerson\">\n                Education\n            </div>\n            <div (click)=\"goToQuality()\" class=\"col-sm-12 col-md-auto btn nav-bar-button nav-bar-button-emerson\">\n                Quality\n            </div>\n        </div>\n    </div>\n    <div class=\"col-md-1 d-s-none\"></div>\n</div><!-- nav-bar navigation bar -->",
                styles: [".nav-bar-button{max-width:100px;font-weight:500;background-color:#fff;border-color:#fff}.nav-bar-emerson{white-space:nowrap;padding-top:15px}.nav-bar-button-emerson{color:#777}.nav-bar-button-emerson:hover{color:#000}.nav-bar-button-wellevate{color:#fff;padding:0;margin-left:5px;margin-right:5px;align-content:flex-end}.nav-bar-button-wellevate:hover{color:#ff0}"]
            }]
    }], function () { return [{ type: ConfigurationService }]; }, { theme: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavbarWellevateComponent, [{
        type: Component,
        args: [{
                selector: 'header-navbar-wellevate',
                template: "<div class=\"row text-nowrap justify-content-center align-items-center\">\n    <div (click)=\"goToWhyWellevate()\" type=\"button\" class=\"col-md-auto btn nav-bar-button-wellevate\">\n        Why Wellevate\n    </div>\n    <div (click)=\"goToResources()\" type=\"button\" class=\"col-md-auto btn nav-bar-button-wellevate\">\n        Resources\n    </div>\n    <div (click)=\"goToDemo()\" type=\"button\" class=\"col-md-auto btn nav-bar-button-wellevate\">\n        Schedule a Demo\n    </div>\n</div>",
                styles: [".nav-bar-wellevate{margin-bottom:5px;text-align:center;white-space:nowrap}.nav-bar-button-wellevate{font-size:1em;color:#fff;padding:0;margin-left:5px;margin-right:5px;align-content:flex-end;max-width:120px}.nav-bar-button-wellevate:hover{color:#ff0}"]
            }]
    }], function () { return [{ type: ConfigurationService }]; }, { theme: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HeaderModule, { declarations: function () { return [HeaderComponent, TabLinkComponent, SearchBarComponent, ButtonBarComponent, NavbarEmersonComponent, NavbarWellevateComponent]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [HeaderComponent, TabLinkComponent, SearchBarComponent, ButtonBarComponent, NavbarEmersonComponent, NavbarWellevateComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule
                ],
                declarations: [
                    HeaderComponent,
                    TabLinkComponent,
                    SearchBarComponent,
                    ButtonBarComponent,
                    NavbarEmersonComponent,
                    NavbarWellevateComponent
                ],
                exports: [
                    HeaderComponent,
                    TabLinkComponent,
                    SearchBarComponent,
                    ButtonBarComponent,
                    NavbarEmersonComponent,
                    NavbarWellevateComponent
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InventoryDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InventoryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: InventoryDataService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CatalogDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CatalogService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: CatalogDataService }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EmersonComponentsModule, { declarations: function () { return [EmailSubscriptionBoxComponent, SocialIconsComponent, BlogReferencesComponent, BlogPullQuoteComponent, JumbotronComponent, BlogPostDetailComponent, BlogImageComponent, ContentComponent, NavbarComponent, BreadcrumbComponent, BlogCategoryComponent, BlogTextBlockComponent, FooterComponent, BlogColumnsComponent, StaticcontentComponent, CategorycardComponent, BlogVideoComponent, BlogAuthorComponent, NothingHereComponent, PromotionContentComponent, GoogleAnalyticsComponent, GoogleTagManagerComponent, AccountMergePasswordSetSuccessComponent, AccountMergePasswordSetComponent, AuthComponent, NotificationBellComponent, NotificationBellListItemComponent, AppTabLinkComponent, HighlightComponent, ValidateAddressComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule, ɵngcc6.OAuthModule, NgbModule, HeaderModule]; }, exports: function () { return [EmailSubscriptionBoxComponent, SocialIconsComponent, BlogReferencesComponent, BlogPullQuoteComponent, JumbotronComponent, BlogPostDetailComponent, BlogImageComponent, ContentComponent, NavbarComponent, BreadcrumbComponent, BlogCategoryComponent, BlogTextBlockComponent, FooterComponent, BlogColumnsComponent, StaticcontentComponent, CategorycardComponent, BlogVideoComponent, BlogAuthorComponent, NothingHereComponent, PromotionContentComponent, GoogleAnalyticsComponent, GoogleTagManagerComponent, AccountMergePasswordSetSuccessComponent, AccountMergePasswordSetComponent, AuthComponent, NotificationBellComponent, AppTabLinkComponent, HighlightComponent, ValidateAddressComponent, HeaderModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EmersonComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    RouterModule,
                    OAuthModule.forRoot(),
                    NgbModule,
                    HeaderModule
                ],
                declarations: [
                    EmailSubscriptionBoxComponent,
                    SocialIconsComponent,
                    BlogReferencesComponent,
                    BlogPullQuoteComponent,
                    JumbotronComponent,
                    BlogPostDetailComponent,
                    BlogImageComponent,
                    ContentComponent,
                    NavbarComponent,
                    BreadcrumbComponent,
                    BlogCategoryComponent,
                    BlogTextBlockComponent,
                    FooterComponent,
                    BlogColumnsComponent,
                    StaticcontentComponent,
                    CategorycardComponent,
                    BlogVideoComponent,
                    BlogAuthorComponent,
                    NothingHereComponent,
                    PromotionContentComponent,
                    GoogleAnalyticsComponent,
                    GoogleTagManagerComponent,
                    AccountMergePasswordSetSuccessComponent,
                    AccountMergePasswordSetComponent,
                    AuthComponent,
                    NotificationBellComponent,
                    NotificationBellListItemComponent,
                    AppTabLinkComponent,
                    HighlightComponent,
                    ValidateAddressComponent
                ],
                exports: [
                    EmailSubscriptionBoxComponent,
                    SocialIconsComponent,
                    BlogReferencesComponent,
                    BlogPullQuoteComponent,
                    JumbotronComponent,
                    BlogPostDetailComponent,
                    BlogImageComponent,
                    ContentComponent,
                    NavbarComponent,
                    BreadcrumbComponent,
                    BlogCategoryComponent,
                    BlogTextBlockComponent,
                    FooterComponent,
                    BlogColumnsComponent,
                    StaticcontentComponent,
                    CategorycardComponent,
                    BlogVideoComponent,
                    BlogAuthorComponent,
                    NothingHereComponent,
                    PromotionContentComponent,
                    GoogleAnalyticsComponent,
                    GoogleTagManagerComponent,
                    AccountMergePasswordSetSuccessComponent,
                    AccountMergePasswordSetComponent,
                    AuthComponent,
                    NotificationBellComponent,
                    AppTabLinkComponent,
                    HighlightComponent,
                    ValidateAddressComponent,
                    HeaderModule
                ],
                providers: [
                    {
                        provide: OAuthStorage,
                        useFactory: storageFactory
                    },
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IContentDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ContentfulDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: IContentService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CookieService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicYieldService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ConfigurationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VersionCheckerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PricingService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }]; }, null); })();

export { AccountMergePasswordSetComponent, AccountMergePasswordSetSuccessComponent, AddressResponse, AppTabLinkComponent, AuthComponent, AuthService, BaseSortableAttribute, BaseSortableObject, BlogAuthorComponent, BlogCategoryComponent, BlogColumnsComponent, BlogImageComponent, BlogPostDetailComponent, BlogPullQuoteComponent, BlogReferencesComponent, BlogTextBlockComponent, BlogVideoComponent, Body, BreadcrumbComponent, CatalogDataService, CatalogService, CategorycardComponent, ConfigurationService, ContentComponent, ContentfulDataService, ContentfulService, CookieService, DynamicYieldService, EmailSubscriptionBoxComponent, EmersonComponentsModule, EnumAction, FeatureService, FooterComponent, GoogleAnalyticsComponent, GoogleTagManagerComponent, HighlightComponent, IContentDataService, IContentService, IHubSpotService, IStrategyComputeProvider, InventoryDataService, InventoryService, JumbotronComponent, LocalStrategyComputeProvider, NavbarComponent, NothingHereComponent, NotificationBellComponent, NotificationBellService, NotificationItem, NotificationStatus, PricingService, PromotionContentComponent, SelectedAddress, SocialIconsComponent, SortableList, StaticcontentComponent, UnleashService, ValidateAddressComponent, ValidateaddressService, VersionCheckerService, address, storageFactory, ɵ0, HeaderModule as ɵa, HeaderComponent as ɵb, TabLinkComponent as ɵc, SearchBarComponent as ɵd, ButtonBarComponent as ɵe, NavbarEmersonComponent as ɵf, NavbarWellevateComponent as ɵg, NotificationBellListItemComponent as ɵh };

//# sourceMappingURL=index.js.map